import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Continuation1aa2oekvx7jm7 as Continuation,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  copyToArray2j022khrow2yi as copyToArray,
  emptyList1g2z5xcrvp2zy as emptyList,
  toString1pkumu07cwy4m as toString,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  ArrayList3it5z8td81qkl as ArrayList,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  EmptyCoroutineContext_getInstance2wsqunjuleo79 as EmptyCoroutineContext_getInstance,
  Key_instance1cfwgdmm6vbbh as Key_instance,
  equals2au1ep9vhcato as equals,
  createCoroutineUninterceptedGeneratorVersion2gduom218i9ay as createCoroutineUninterceptedGeneratorVersion,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  isInterface3d6p8outrmvmk as isInterface,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  toString30pk9tzaqopn as toString_0,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  hashCodeq5arwsb9dgti as hashCode,
  Result__exceptionOrNull_impl_p6xea92zjvgyei8ws1 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  AbstractCoroutineContextKey9xr9r6wlj5bm as AbstractCoroutineContextKey,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  getxe4seun860fg as get,
  protoOf180f3jzyo7rfj as protoOf,
  minusKey2uxs00uz5ceqp as minusKey,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  RuntimeException1r3t0zl97011n as RuntimeException,
  addSuppressedu5jwjfvsc039 as addSuppressed,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Enum3alwj03lh1n41 as Enum,
  startCoroutine327fwvtqvedik as startCoroutine,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Long2qws0ah9gnpki as Long,
  compare2uud5j30pw5xc as compare,
  Duration__isPositive_impl_tvkkt23p4mzdx5y5zb9 as Duration__isPositive_impl_tvkkt2,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  DurationUnit_NANOSECONDS_getInstance3qw1csxyijo35 as DurationUnit_NANOSECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration,
  Duration__plus_impl_yu9v8f2as9k1ghoc0eo as Duration__plus_impl_yu9v8f,
  _Duration___get_inWholeMilliseconds__impl__msfiry3vw6k01dbd1ii as _Duration___get_inWholeMilliseconds__impl__msfiry,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  add85si75olwt6n as add,
  subtract16cg4lfi29fq9 as subtract,
  captureStack1fzi4aczwc4hg as captureStack,
  Error3ofk6owajcepa as Error_0,
  Element2gr7ezmxqaln7 as Element,
  constructCallableReference23y65rf941mch as constructCallableReference,
  sequence2vgswtrxvqoa7 as sequence,
  plusolev77jfy5r9 as plus,
  get6d5x931vk0s as get_0,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey_0,
  StringBuildermazzzhj6kkai as StringBuilder,
  anyToString3ho3k49fc56mj as anyToString,
  emptySequence25zpp7hgtqwdd as emptySequence,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  fromInt1lka3ktyu79a4 as fromInt,
  multiply18i3gv3wlmcjg as multiply,
  divide3tol6kxdi8xn6 as divide,
  modulo3mmbfwxzpcw3a as modulo,
  convertToIntofdoxh9bstof as convertToInt,
  equalsLong28bsrfhwvd686 as equalsLong,
  bitwiseAnd2g7wmsfd45l12 as bitwiseAnd,
  shiftRight2cr6y79ufiihy as shiftRight,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  listOf1jh22dvmctj1r as listOf,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  compareTo3ankvs086tmwq as compareTo,
  last2n4gf5az1lkn4 as last,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  shiftLeft1ck77p6vapyra as shiftLeft,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getKClass3t8tygqu4lcxf as getKClass,
  Unitkvevlwgzwiuc as Unit,
  copyOf2ng0t8oizk6it as copyOf,
  joinToString1cxrrlmo0chqs as joinToString,
  startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn as startCoroutineUninterceptedOrReturnGeneratorVersion,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  IndexedValue22atz80p92rrf as IndexedValue,
  fill3hcjvebk42tyx as fill,
  numberToByte2emqcesvvnksb as numberToByte,
  isArray1hxjqtqy632bc as isArray,
  arrayCopytctsywo3h7gj as arrayCopy,
  Exceptiondt2hlxn7j7vw as Exception,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  createCoroutineUninterceptedGeneratorVersion1ji2no4l6ift5 as createCoroutineUninterceptedGeneratorVersion_0,
  plus20p0vtfmu0596 as plus_0,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf_0,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull,
  KtMutableList1beimitadwkna as KtMutableList,
  coerceIn302bduskdb54x as coerceIn,
  boxApply1qmzdb3dh90hg as boxApply,
  HashSet2dzve9y63nf0v as HashSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
} from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Job {}
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.n1n(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.n1n.call(this, cause);
  }
  return tmp;
}
function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $super) {
  onCancelling = onCancelling === VOID ? false : onCancelling;
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  return $super === VOID ? this.h1n(onCancelling, invokeImmediately, handler) : $super.h1n.call(this, onCancelling, invokeImmediately, handler);
}
class ParentJob {}
class JobSupport {
  constructor(active) {
    this.x1l_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
    this.y1l_1 = atomic$ref$1(null);
  }
  j3() {
    return Key_instance_3;
  }
  v1m(value) {
    this.y1l_1.kotlinx$atomicfu$value = value;
  }
  w1m() {
    return this.y1l_1.kotlinx$atomicfu$value;
  }
  x1m() {
    var tmp0_safe_receiver = this.w1m();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1m();
  }
  z1l(parent) {
    // Inline function 'kotlinx.coroutines.assert' call
    if (parent == null) {
      this.v1m(NonDisposableHandle_instance);
      return Unit_instance;
    }
    parent.b1n();
    var handle = parent.x1n(this);
    this.v1m(handle);
    if (this.z1m()) {
      handle.u1o();
      this.v1m(NonDisposableHandle_instance);
    }
  }
  y1m() {
    return this.x1l_1.kotlinx$atomicfu$value;
  }
  e1m() {
    var state = this.y1m();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.e1m();
    } else {
      tmp = false;
    }
    return tmp;
  }
  z1m() {
    var tmp = this.y1m();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  }
  a1n() {
    var state = this.y1m();
    var tmp;
    if (state instanceof CompletedExceptionally) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.p1v();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  b1n() {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.y1m();
      var tmp0_subject = startInternal(this, state);
      if (tmp0_subject === 0)
        return false;
      else if (tmp0_subject === 1)
        return true;
    }
  }
  c1n() {
  }
  d1n() {
    var state = this.y1m();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.e1w();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.e1n(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException.o(toString(message));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        // Inline function 'kotlin.error' call
        var message_0 = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException.o(toString(message_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = this.f1n(state.j1m_1);
        } else {
          tmp = JobCancellationException.x1v(get_classSimpleName(this) + ' has completed normally', null, this);
        }
      }
    }
    return tmp;
  }
  e1n(_this__u8e3s4, message) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = JobCancellationException.x1v(message == null ? this.h1m() : message, _this__u8e3s4, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  f1n(_this__u8e3s4, message, $super) {
    message = message === VOID ? null : message;
    return $super === VOID ? this.e1n(_this__u8e3s4, message) : $super.e1n.call(this, _this__u8e3s4, message);
  }
  g1n(handler) {
    return this.j1n(true, new InvokeOnCompletion(handler));
  }
  h1n(onCancelling, invokeImmediately, handler) {
    var tmp;
    if (onCancelling) {
      tmp = new InvokeOnCancelling(handler);
    } else {
      tmp = new InvokeOnCompletion(handler);
    }
    return this.j1n(invokeImmediately, tmp);
  }
  j1n(invokeImmediately, node) {
    node.f1p_1 = this;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
      // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
      while (true) {
        var state = this.y1m();
        if (state instanceof Empty) {
          if (state.a1w_1) {
            if (this.x1l_1.atomicfu$compareAndSet(state, node)) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
          } else {
            promoteEmptyToNodeList(this, state);
          }
        } else {
          if (!(state == null) ? isInterface(state, Incomplete) : false) {
            var list = state.h1p();
            if (list == null) {
              promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
            } else {
              var tmp;
              if (node.y1o()) {
                var tmp0_safe_receiver = state instanceof Finishing ? state : null;
                var rootCause = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e1w();
                var tmp_0;
                if (rootCause == null) {
                  tmp_0 = list.l1p(node, 5);
                } else {
                  if (invokeImmediately) {
                    node.v1o(rootCause);
                  }
                  return NonDisposableHandle_instance;
                }
                tmp = tmp_0;
              } else {
                tmp = list.l1p(node, 1);
              }
              if (tmp) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
            }
          } else {
            tmp$ret$0 = false;
            break $l$block_1;
          }
        }
      }
    }
    var added = tmp$ret$0;
    if (added)
      return node;
    else if (invokeImmediately) {
      var tmp_1 = this.y1m();
      var tmp0_safe_receiver_0 = tmp_1 instanceof CompletedExceptionally ? tmp_1 : null;
      node.v1o(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.j1m_1);
    }
    return NonDisposableHandle_instance;
  }
  *k1n($completion) {
    if (!joinInternal(this)) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$0 = $completion.od();
      ensureActive_0(tmp$ret$0);
      return Unit_instance;
    }
    return yield* /*#__NOINLINE__*/joinSuspend(this, $completion);
  }
  l1n(node) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.y1m();
      if (state instanceof JobNode) {
        if (!(state === node))
          return Unit_instance;
        if (this.x1l_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
          return Unit_instance;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          if (!(state.h1p() == null)) {
            node.m1p();
          }
          return Unit_instance;
        } else {
          return Unit_instance;
        }
      }
    }
  }
  m1n() {
    return false;
  }
  n1n(cause) {
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = JobCancellationException.x1v(null == null ? this.h1m() : null, null, this);
    } else {
      tmp = cause;
    }
    this.p1n(tmp);
  }
  h1m() {
    return 'Job was cancelled';
  }
  p1n(cause) {
    this.t1n(cause);
  }
  q1n(parentJob) {
    this.t1n(parentJob);
  }
  r1n(cause) {
    if (cause instanceof CancellationException)
      return true;
    return this.t1n(cause) && this.a1o();
  }
  s1n(cause) {
    return this.t1n(cause);
  }
  t1n(cause) {
    var finalState = get_COMPLETING_ALREADY();
    if (this.m1n()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === get_COMPLETING_WAITING_CHILDREN())
        return true;
    }
    if (finalState === get_COMPLETING_ALREADY()) {
      finalState = makeCancelling(this, cause);
    }
    var tmp;
    if (finalState === get_COMPLETING_ALREADY()) {
      tmp = true;
    } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
      tmp = true;
    } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
      tmp = false;
    } else {
      this.o1m(finalState);
      tmp = true;
    }
    return tmp;
  }
  u1n() {
    var state = this.y1m();
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.e1w();
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = state.j1m_1;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot be cancelling child in this state: ' + toString(state);
          throw IllegalStateException.o(toString(message));
        } else {
          tmp = null;
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? JobCancellationException.x1v('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  }
  v1n(proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = this.y1m();
      $l$block: {
        var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          return false;
        else if (finalState === get_COMPLETING_WAITING_CHILDREN())
          return true;
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else {
          this.o1m(finalState);
          return true;
        }
      }
    }
  }
  m1m(proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = this.y1m();
      $l$block: {
        var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          throw IllegalStateException.q('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(this, proposedUpdate));
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else
          return finalState;
      }
    }
  }
  w1n() {
    return sequence(JobSupport$_get_children_$slambda_k839f8(this));
  }
  x1n(child) {
    // Inline function 'kotlin.also' call
    var this_0 = new ChildHandleNode(child);
    this_0.f1p_1 = this;
    var node = this_0;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
      // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
      while (true) {
        var state = this.y1m();
        if (state instanceof Empty) {
          if (state.a1w_1) {
            if (this.x1l_1.atomicfu$compareAndSet(state, node)) {
              tmp$ret$2 = true;
              break $l$block_1;
            }
          } else {
            promoteEmptyToNodeList(this, state);
          }
        } else {
          if (!(state == null) ? isInterface(state, Incomplete) : false) {
            var list = state.h1p();
            if (list == null) {
              promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
            } else {
              var addedBeforeCancellation = list.l1p(node, 7);
              var tmp;
              if (addedBeforeCancellation) {
                tmp = true;
              } else {
                var addedBeforeCompletion = list.l1p(node, 3);
                var latestState = this.y1m();
                var tmp_0;
                if (latestState instanceof Finishing) {
                  tmp_0 = latestState.e1w();
                } else {
                  // Inline function 'kotlinx.coroutines.assert' call
                  var tmp0_safe_receiver = latestState instanceof CompletedExceptionally ? latestState : null;
                  tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j1m_1;
                }
                var rootCause = tmp_0;
                node.v1o(rootCause);
                var tmp_1;
                if (addedBeforeCompletion) {
                  // Inline function 'kotlinx.coroutines.assert' call
                  tmp_1 = true;
                } else {
                  return NonDisposableHandle_instance;
                }
                tmp = tmp_1;
              }
              if (tmp) {
                tmp$ret$2 = true;
                break $l$block_1;
              }
            }
          } else {
            tmp$ret$2 = false;
            break $l$block_1;
          }
        }
      }
    }
    var added = tmp$ret$2;
    if (added)
      return node;
    var tmp_2 = this.y1m();
    var tmp0_safe_receiver_0 = tmp_2 instanceof CompletedExceptionally ? tmp_2 : null;
    node.v1o(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.j1m_1);
    return NonDisposableHandle_instance;
  }
  p1m(exception) {
    throw exception;
  }
  y1n(cause) {
  }
  z1n() {
    return false;
  }
  a1o() {
    return true;
  }
  b1o(exception) {
    return false;
  }
  i1m(state) {
  }
  o1m(state) {
  }
  toString() {
    return this.c1o() + '@' + get_hexAddress(this);
  }
  c1o() {
    return this.q1m() + '{' + stateString(this, this.y1m()) + '}';
  }
  q1m() {
    return get_classSimpleName(this);
  }
  d1o() {
    var state = this.y1m();
    // Inline function 'kotlin.check' call
    if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      var message = 'This job has not completed yet';
      throw IllegalStateException.o(toString(message));
    }
    if (state instanceof CompletedExceptionally)
      throw state.j1m_1;
    return unboxState(state);
  }
  *e1o($completion) {
    $l$loop: while (true) {
      var state = this.y1m();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
          throw state.j1m_1;
        }
        return unboxState(state);
      }
      if (startInternal(this, state) >= 0)
        break $l$loop;
    }
    return yield* /*#__NOINLINE__*/awaitSuspend(this, $completion);
  }
}
class AbstractCoroutine extends JobSupport {
  constructor(parentContext, initParentJob, active) {
    super(active);
    if (initParentJob) {
      this.z1l(parentContext.ae(Key_instance_3));
    }
    this.c1m_1 = parentContext.ep(this);
  }
  od() {
    return this.c1m_1;
  }
  d1m() {
    return this.c1m_1;
  }
  e1m() {
    return super.e1m();
  }
  f1m(value) {
  }
  g1m(cause, handled) {
  }
  h1m() {
    return get_classSimpleName(this) + ' was cancelled';
  }
  i1m(state) {
    if (state instanceof CompletedExceptionally) {
      this.g1m(state.j1m_1, state.l1m());
    } else {
      this.f1m(state);
    }
  }
  qd(result) {
    var state = this.m1m(toState_0(result));
    if (state === get_COMPLETING_WAITING_CHILDREN())
      return Unit_instance;
    this.n1m(state);
  }
  n1m(state) {
    return this.o1m(state);
  }
  p1m(exception) {
    handleCoroutineException(this.c1m_1, exception);
  }
  q1m() {
    var tmp0_elvis_lhs = get_coroutineName(this.c1m_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return super.q1m();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '"' + coroutineName + '":' + super.q1m();
  }
  r1m(start, receiver, block) {
    start.u1m(block, receiver, this);
  }
}
class NotCompleted {}
class CancelHandler {}
class DisposeHandlersOnCancel {
  constructor($outer, nodes) {
    this.j1o_1 = $outer;
    this.i1o_1 = nodes;
  }
  k1o() {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.i1o_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      element.t1o().u1o();
    }
  }
  v1o(cause) {
    this.k1o();
  }
  toString() {
    return 'DisposeHandlersOnCancel[' + toString(this.i1o_1) + ']';
  }
}
class LockFreeLinkedListNode {
  constructor($box) {
    boxApply(this, $box);
    this.i1p_1 = this;
    this.j1p_1 = this;
    this.k1p_1 = false;
  }
  l1p(node, permissionsBitmask) {
    var prev = this.j1p_1;
    var tmp;
    if (prev instanceof ListClosed) {
      tmp = ((prev.o2d_1 & permissionsBitmask) === 0 && prev.l1p(node, permissionsBitmask));
    } else {
      node.i1p_1 = this;
      node.j1p_1 = prev;
      prev.i1p_1 = node;
      this.j1p_1 = node;
      tmp = true;
    }
    return tmp;
  }
  y1v(forbiddenElementsBit) {
    this.l1p(new ListClosed(forbiddenElementsBit), forbiddenElementsBit);
  }
  m1p() {
    if (this.k1p_1)
      return false;
    var prev = this.j1p_1;
    var next = this.i1p_1;
    prev.i1p_1 = next;
    next.j1p_1 = prev;
    this.k1p_1 = true;
    return true;
  }
  n1p(node) {
    if (!(this.i1p_1 === this))
      return false;
    this.l1p(node, -2147483648);
    return true;
  }
}
class DisposableHandle {}
class Incomplete {}
class JobNode extends LockFreeLinkedListNode {
  g1p() {
    var tmp = this.f1p_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  }
  e1m() {
    return true;
  }
  h1p() {
    return null;
  }
  u1o() {
    return this.g1p().l1n(this);
  }
  toString() {
    return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.g1p()) + ']';
  }
}
class AwaitAllNode extends JobNode {
  constructor($outer, continuation, $box) {
    if ($box === VOID)
      $box = {};
    $box.s1o_1 = $outer;
    super($box);
    this.p1o_1 = continuation;
    this.r1o_1 = atomic$ref$1(null);
  }
  t1o() {
    var tmp = this.q1o_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('handle');
    }
  }
  w1o(value) {
    this.r1o_1.kotlinx$atomicfu$value = value;
  }
  x1o() {
    return this.r1o_1.kotlinx$atomicfu$value;
  }
  y1o() {
    return false;
  }
  v1o(cause) {
    if (!(cause == null)) {
      var token = this.p1o_1.a1p(cause);
      if (!(token == null)) {
        this.p1o_1.b1p(token);
        var tmp0_safe_receiver = this.x1o();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.k1o();
        }
      }
    } else if (this.s1o_1.g1o_1.atomicfu$decrementAndGet() === 0) {
      var tmp0 = this.p1o_1;
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.s1o_1.f1o_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(this_0.length);
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var item = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$2 = item.z1o();
        destination.d2(tmp$ret$2);
      }
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$4 = _Result___init__impl__xyqfz8(destination);
      tmp0.qd(tmp$ret$4);
    }
  }
}
class AwaitAll {
  constructor(deferreds) {
    this.f1o_1 = deferreds;
    this.g1o_1 = atomic$int$1(this.f1o_1.length);
  }
  *h1o($completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    return yield () => {
      var uCont = $completion;
      var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
      cancellable.u1p();
      var tmp = 0;
      var tmp_0 = this.f1o_1.length;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var deferred = this.f1o_1[tmp_2];
        deferred.b1n();
        // Inline function 'kotlin.apply' call
        var this_0 = new AwaitAllNode(this, cancellable);
        this_0.q1o_1 = invokeOnCompletion(deferred, VOID, this_0);
        tmp_1[tmp_2] = this_0;
        tmp = tmp + 1 | 0;
      }
      var nodes = tmp_1;
      var disposer = new DisposeHandlersOnCancel(this, nodes);
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = nodes.length;
      while (inductionVariable < last) {
        var element = nodes[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        element.w1o(disposer);
      }
      if (cancellable.z1m()) {
        disposer.k1o();
      } else {
        invokeOnCancellation(cancellable, disposer);
      }
      return cancellable.v1p();
    };
  }
}
class StandaloneCoroutine extends AbstractCoroutine {
  constructor(parentContext, active) {
    super(parentContext, true, active);
  }
  b1o(exception) {
    handleCoroutineException(this.c1m_1, exception);
    return true;
  }
}
class LazyStandaloneCoroutine extends StandaloneCoroutine {
  constructor(parentContext, block) {
    super(parentContext, false);
    this.i1q_1 = createCoroutineUninterceptedGeneratorVersion(block, this, this);
  }
  c1n() {
    startCoroutineCancellable_1(this.i1q_1, this);
  }
}
class Deferred {}
class DeferredCoroutine extends AbstractCoroutine {
  constructor(parentContext, active) {
    super(parentContext, true, active);
  }
  z1o() {
    return this.d1o();
  }
  *m1q($completion) {
    return yield* this.e1o($completion);
  }
}
class LazyDeferredCoroutine extends DeferredCoroutine {
  constructor(parentContext, block) {
    super(parentContext, false);
    this.q1q_1 = createCoroutineUninterceptedGeneratorVersion(block, this, this);
  }
  c1n() {
    startCoroutineCancellable_1(this.q1q_1, this);
  }
}
class ScopeCoroutine extends AbstractCoroutine {
  constructor(context, uCont) {
    super(context, true, true);
    this.u1q_1 = uCont;
  }
  z1n() {
    return true;
  }
  o1m(state) {
    resumeCancellableWith(intercepted(this.u1q_1), recoverResult(state, this.u1q_1));
  }
  v1q() {
  }
  n1m(state) {
    this.u1q_1.qd(recoverResult(state, this.u1q_1));
  }
}
class DispatchedCoroutine extends ScopeCoroutine {
  constructor(context, uCont) {
    super(context, uCont);
    this.b1q_1 = atomic$int$1(0);
  }
  o1m(state) {
    this.n1m(state);
  }
  n1m(state) {
    if (tryResume(this))
      return Unit_instance;
    resumeCancellableWith(intercepted(this.u1q_1), recoverResult(state, this.u1q_1));
  }
  v1p() {
    if (trySuspend(this))
      return get_COROUTINE_SUSPENDED();
    var state = unboxState(this.y1m());
    if (state instanceof CompletedExceptionally)
      throw state.j1m_1;
    return state;
  }
}
class CancellableContinuation {}
class DisposeOnCancel {
  constructor(handle) {
    this.c1r_1 = handle;
  }
  v1o(cause) {
    return this.c1r_1.u1o();
  }
  toString() {
    return 'DisposeOnCancel[' + toString(this.c1r_1) + ']';
  }
}
class UserSupplied {
  constructor(handler) {
    this.l1r_1 = handler;
  }
  v1o(cause) {
    this.l1r_1(cause);
  }
  toString() {
    return 'CancelHandler.UserSupplied[' + get_classSimpleName(this.l1r_1) + '@' + get_hexAddress(this) + ']';
  }
}
class Runnable {}
class SchedulerTask {}
class DispatchedTask extends SchedulerTask {
  constructor(resumeMode) {
    super();
    this.n1r_1 = resumeMode;
  }
  k1s(takenState, cause) {
  }
  q1s(state) {
    return state;
  }
  a1t(state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j1m_1;
  }
  c1t() {
    // Inline function 'kotlinx.coroutines.assert' call
    try {
      var tmp = this.i1s();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate.f1r_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      delegate.h1r_1;
      var context = continuation.od();
      var state = this.j1s();
      var exception = this.a1t(state);
      var job = exception == null && get_isCancellableMode(this.n1r_1) ? context.ae(Key_instance_3) : null;
      if (!(job == null) && !job.e1m()) {
        var cause = job.d1n();
        this.k1s(state, cause);
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception_0 = recoverStackTrace(cause, continuation);
        var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(exception_0));
        continuation.qd(tmp$ret$4);
      } else {
        if (!(exception == null)) {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$6 = _Result___init__impl__xyqfz8(createFailure(exception));
          continuation.qd(tmp$ret$6);
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = this.q1s(state);
          var tmp$ret$8 = _Result___init__impl__xyqfz8(value);
          continuation.qd(tmp$ret$8);
        }
      }
    } catch ($p) {
      if ($p instanceof DispatchException) {
        var e = $p;
        handleCoroutineException(this.i1s().od(), e.w1t_1);
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          this.d1t(e_0);
        } else {
          throw $p;
        }
      }
    }
  }
  d1t(exception) {
    var reason = CoroutinesInternalError.e1v('Fatal exception in coroutines machinery for ' + toString(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", exception);
    handleCoroutineException(this.i1s().od(), reason);
  }
}
class Waiter {}
class CancellableContinuationImpl extends DispatchedTask {
  constructor(delegate, resumeMode) {
    super(resumeMode);
    this.p1p_1 = delegate;
    // Inline function 'kotlinx.coroutines.assert' call
    this.q1p_1 = this.p1p_1.od();
    var tmp = this;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    var tmp$ret$1 = (0 << 29) + 536870911 | 0;
    tmp.r1p_1 = atomic$int$1(tmp$ret$1);
    this.s1p_1 = atomic$ref$1(Active_instance);
    this.t1p_1 = atomic$ref$1(null);
  }
  i1s() {
    return this.p1p_1;
  }
  od() {
    return this.q1p_1;
  }
  y1m() {
    return this.s1p_1.kotlinx$atomicfu$value;
  }
  z1m() {
    var tmp = this.y1m();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  }
  a1n() {
    var tmp = this.y1m();
    return tmp instanceof CancelledContinuation;
  }
  u1p() {
    var tmp0_elvis_lhs = installParentHandle(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    if (this.z1m()) {
      handle.u1o();
      this.t1p_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
    }
  }
  k1r() {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var state = this.s1p_1.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp;
    if (state instanceof CompletedContinuation) {
      tmp = !(state.b1s_1 == null);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.h1s();
      return false;
    }
    var tmp_0 = this.r1p_1;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
    this.s1p_1.kotlinx$atomicfu$value = Active_instance;
    return true;
  }
  j1s() {
    return this.y1m();
  }
  k1s(takenState, cause) {
    var tmp$ret$0;
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.s1p_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state == null) ? isInterface(state, NotCompleted) : false) {
        // Inline function 'kotlin.error' call
        var message = 'Not completed';
        throw IllegalStateException.o(toString(message));
      } else {
        if (state instanceof CompletedExceptionally)
          return Unit_instance;
        else {
          if (state instanceof CompletedContinuation) {
            // Inline function 'kotlin.check' call
            if (!!state.e1s()) {
              var message_0 = 'Must be called at most once';
              throw IllegalStateException.o(toString(message_0));
            }
            var update = state.f1s(VOID, VOID, VOID, VOID, cause);
            if (this.s1p_1.atomicfu$compareAndSet(state, update)) {
              state.l1s(this, cause);
              return Unit_instance;
            }
          } else {
            if (this.s1p_1.atomicfu$compareAndSet(state, new CompletedContinuation(state, VOID, VOID, VOID, cause))) {
              return Unit_instance;
            }
          }
        }
      }
    }
    return tmp$ret$0;
  }
  x1q(cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.s1p_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false))
          return false;
        var tmp;
        if (isInterface(tmp0, CancelHandler)) {
          tmp = true;
        } else {
          tmp = tmp0 instanceof Segment;
        }
        var update = new CancelledContinuation(this, cause, tmp);
        if (!this.s1p_1.atomicfu$compareAndSet(tmp0, update)) {
          break $l$block;
        }
        if (isInterface(tmp0, CancelHandler)) {
          this.d1s(tmp0, cause);
        } else {
          if (tmp0 instanceof Segment) {
            callSegmentOnCancellation(this, tmp0, cause);
          }
        }
        detachChildIfNonReusable(this);
        dispatchResume(this, this.n1r_1);
        return true;
      }
    }
  }
  m1s(cause) {
    if (cancelLater(this, cause))
      return Unit_instance;
    this.x1q(cause);
    detachChildIfNonReusable(this);
  }
  d1s(handler, cause) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
    try {
      handler.v1o(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.od(), CompletionHandlerException.x1r('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  n1s(onCancellation, cause, value) {
    try {
      onCancellation(cause, value, this.od());
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.od(), CompletionHandlerException.x1r('Exception in resume onCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
  }
  o1s(parent) {
    return parent.d1n();
  }
  v1p() {
    var isReusable_0 = isReusable(this);
    if (trySuspend_0(this)) {
      if (_get_parentHandle__f8dcex(this) == null) {
        installParentHandle(this);
      }
      if (isReusable_0) {
        this.p1s();
      }
      return get_COROUTINE_SUSPENDED();
    }
    if (isReusable_0) {
      this.p1s();
    }
    var state = this.y1m();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state.j1m_1, this);
    if (get_isCancellableMode(this.n1r_1)) {
      var job = this.od().ae(Key_instance_3);
      if (!(job == null) && !job.e1m()) {
        var cause = job.d1n();
        this.k1s(state, cause);
        throw recoverStackTrace(cause, this);
      }
    }
    return this.q1s(state);
  }
  p1s() {
    var tmp = this.p1p_1;
    var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r1s(this);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var cancellationCause = tmp_0;
    this.h1s();
    this.x1q(cancellationCause);
  }
  qd(result) {
    return this.s1s(toState(result, this), this.n1r_1);
  }
  t1s(value, onCancellation) {
    var tmp = this.n1r_1;
    var tmp_0;
    if (onCancellation == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = CancellableContinuationImpl$resume$lambda(onCancellation);
    }
    return this.u1s(value, tmp, tmp_0);
  }
  a1r(value, onCancellation) {
    return this.u1s(value, this.n1r_1, onCancellation);
  }
  v1s(segment, index) {
    var tmp0 = this.r1p_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.index' call
        // Inline function 'kotlin.check' call
        if (!((cur & 536870911) === 536870911)) {
          var message = 'invokeOnCancellation should be called at most once';
          throw IllegalStateException.o(toString(message));
        }
        // Inline function 'kotlinx.coroutines.decision' call
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call
        var upd = (cur >> 29 << 29) + index | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    invokeOnCancellationImpl(this, segment);
  }
  y1q(handler) {
    return invokeOnCancellation(this, new UserSupplied(handler));
  }
  b1r(handler) {
    return invokeOnCancellationImpl(this, handler);
  }
  u1s(proposedUpdate, resumeMode, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.s1p_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
          var update = resumedState(this, tmp0, proposedUpdate, resumeMode, onCancellation, null);
          if (!this.s1p_1.atomicfu$compareAndSet(tmp0, update)) {
            break $l$block;
          }
          detachChildIfNonReusable(this);
          dispatchResume(this, resumeMode);
          return Unit_instance;
        } else {
          if (tmp0 instanceof CancelledContinuation) {
            if (tmp0.z1s()) {
              if (onCancellation == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                this.n1s(onCancellation, tmp0.j1m_1, proposedUpdate);
              }
              return Unit_instance;
            }
          }
        }
        alreadyResumedError(this, proposedUpdate);
      }
    }
  }
  s1s(proposedUpdate, resumeMode, onCancellation, $super) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    var tmp;
    if ($super === VOID) {
      this.u1s(proposedUpdate, resumeMode, onCancellation);
      tmp = Unit_instance;
    } else {
      tmp = $super.u1s.call(this, proposedUpdate, resumeMode, onCancellation);
    }
    return tmp;
  }
  h1s() {
    var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    handle.u1o();
    this.t1p_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  }
  w1q(value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  }
  a1p(exception) {
    return tryResumeImpl(this, new CompletedExceptionally(exception), null, null);
  }
  b1p(token) {
    // Inline function 'kotlinx.coroutines.assert' call
    dispatchResume(this, this.n1r_1);
  }
  z1q(_this__u8e3s4, value) {
    var tmp = this.p1p_1;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if ((dc == null ? null : dc.e1r_1) === _this__u8e3s4) {
      tmp_0 = 4;
    } else {
      tmp_0 = this.n1r_1;
    }
    this.s1s(value, tmp_0);
  }
  q1s(state) {
    var tmp;
    if (state instanceof CompletedContinuation) {
      tmp = state.y1r_1;
    } else {
      tmp = state;
    }
    return tmp;
  }
  a1t(state) {
    var tmp0_safe_receiver = super.a1t(state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = recoverStackTrace(tmp0_safe_receiver, this.p1p_1);
    }
    return tmp;
  }
  toString() {
    return this.b1t() + '(' + toDebugString(this.p1p_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
  }
  b1t() {
    return 'CancellableContinuation';
  }
}
class Active {
  toString() {
    return 'Active';
  }
}
class CompletedContinuation {
  constructor(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    cancelHandler = cancelHandler === VOID ? null : cancelHandler;
    onCancellation = onCancellation === VOID ? null : onCancellation;
    idempotentResume = idempotentResume === VOID ? null : idempotentResume;
    cancelCause = cancelCause === VOID ? null : cancelCause;
    this.y1r_1 = result;
    this.z1r_1 = cancelHandler;
    this.a1s_1 = onCancellation;
    this.b1s_1 = idempotentResume;
    this.c1s_1 = cancelCause;
  }
  e1s() {
    return !(this.c1s_1 == null);
  }
  l1s(cont, cause) {
    var tmp0_safe_receiver = this.z1r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cont.d1s(tmp0_safe_receiver, cause);
    }
    var tmp1_safe_receiver = this.a1s_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cont.n1s(tmp1_safe_receiver, cause, this.y1r_1);
    }
  }
  e1t(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  }
  f1s(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
    result = result === VOID ? this.y1r_1 : result;
    cancelHandler = cancelHandler === VOID ? this.z1r_1 : cancelHandler;
    onCancellation = onCancellation === VOID ? this.a1s_1 : onCancellation;
    idempotentResume = idempotentResume === VOID ? this.b1s_1 : idempotentResume;
    cancelCause = cancelCause === VOID ? this.c1s_1 : cancelCause;
    return $super === VOID ? this.e1t(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.e1t.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  }
  toString() {
    return 'CompletedContinuation(result=' + toString_0(this.y1r_1) + ', cancelHandler=' + toString_0(this.z1r_1) + ', onCancellation=' + toString_0(this.a1s_1) + ', idempotentResume=' + toString_0(this.b1s_1) + ', cancelCause=' + toString_0(this.c1s_1) + ')';
  }
  hashCode() {
    var result = this.y1r_1 == null ? 0 : hashCode(this.y1r_1);
    result = imul(result, 31) + (this.z1r_1 == null ? 0 : hashCode(this.z1r_1)) | 0;
    result = imul(result, 31) + (this.a1s_1 == null ? 0 : hashCode(this.a1s_1)) | 0;
    result = imul(result, 31) + (this.b1s_1 == null ? 0 : hashCode(this.b1s_1)) | 0;
    result = imul(result, 31) + (this.c1s_1 == null ? 0 : hashCode(this.c1s_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedContinuation ? other : THROW_CCE();
    if (!equals(this.y1r_1, tmp0_other_with_cast.y1r_1))
      return false;
    if (!equals(this.z1r_1, tmp0_other_with_cast.z1r_1))
      return false;
    if (!equals(this.a1s_1, tmp0_other_with_cast.a1s_1))
      return false;
    if (!equals(this.b1s_1, tmp0_other_with_cast.b1s_1))
      return false;
    if (!equals(this.c1s_1, tmp0_other_with_cast.c1s_1))
      return false;
    return true;
  }
}
class ChildContinuation extends JobNode {
  constructor(child) {
    super();
    this.j1t_1 = child;
  }
  y1o() {
    return true;
  }
  v1o(cause) {
    this.j1t_1.m1s(this.j1t_1.o1s(this.g1p()));
  }
}
class CompletableDeferredImpl extends JobSupport {
  constructor(parent) {
    super(true);
    this.z1l(parent);
  }
  m1n() {
    return true;
  }
  z1o() {
    return this.d1o();
  }
  *m1q($completion) {
    return yield* this.e1o($completion);
  }
  l1t(value) {
    return this.v1n(value);
  }
  k1t(exception) {
    return this.v1n(new CompletedExceptionally(exception));
  }
}
class CompletableJob {}
class CompletedExceptionally {
  constructor(cause, handled) {
    handled = handled === VOID ? false : handled;
    this.j1m_1 = cause;
    this.k1m_1 = atomic$boolean$1(handled);
  }
  l1m() {
    return this.k1m_1.kotlinx$atomicfu$value;
  }
  g1s() {
    return this.k1m_1.atomicfu$compareAndSet(false, true);
  }
  toString() {
    return get_classSimpleName(this) + '[' + this.j1m_1.toString() + ']';
  }
}
class CancelledContinuation extends CompletedExceptionally {
  constructor(continuation, cause, handled) {
    super(cause == null ? CancellationException.n('Continuation ' + toString(continuation) + ' was cancelled normally') : cause, handled);
    this.y1s_1 = atomic$boolean$1(false);
  }
  z1s() {
    return this.y1s_1.atomicfu$compareAndSet(false, true);
  }
}
class Key extends AbstractCoroutineContextKey {
  constructor() {
    Key_instance_0 = null;
    var tmp = Key_instance;
    super(tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
    Key_instance_0 = this;
  }
}
class CoroutineDispatcher extends AbstractCoroutineContextElement {
  static q1t() {
    Key_getInstance();
    return this.jp(Key_instance);
  }
  r1t(context) {
    return true;
  }
  t1t(context, block) {
    return safeDispatch(this, context, block);
  }
  be(continuation) {
    return new DispatchedContinuation(this, continuation);
  }
  ce(continuation) {
    var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
    dispatched.u1t();
  }
  toString() {
    return get_classSimpleName(this) + '@' + get_hexAddress(this);
  }
}
class Key_0 {}
class Key_1 {}
class CoroutineName extends AbstractCoroutineContextElement {
  constructor(name) {
    return new.target.b1u(name);
  }
  static b1u(name) {
    var $this = this.jp(Key_instance_2);
    $this.a1u_1 = name;
    return $this;
  }
  toString() {
    return 'CoroutineName(' + this.a1u_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.a1u_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CoroutineName))
      return false;
    var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
    if (!(this.a1u_1 === tmp0_other_with_cast.a1u_1))
      return false;
    return true;
  }
}
class GlobalScope {
  d1m() {
    return EmptyCoroutineContext_getInstance();
  }
}
class CoroutineStart extends Enum {
  u1m(block, receiver, completion) {
    var tmp;
    switch (this.w1_1) {
      case 0:
        startCoroutineCancellable_0(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 2:
        startCoroutine(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 3:
        startCoroutineUndispatched(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 1:
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  w1p() {
    return this === CoroutineStart_LAZY_getInstance();
  }
}
class CopyableThrowable {}
class Delay {}
function invokeOnTimeout(timeMillis, block, context) {
  return get_DefaultDelay().j1u(timeMillis, block, context);
}
class DelayWithTimeoutDiagnostics {}
class EventLoop extends CoroutineDispatcher {
  static p1u() {
    var $this = this.q1t();
    $this.m1u_1 = new Long(0, 0);
    $this.n1u_1 = false;
    $this.o1u_1 = null;
    return $this;
  }
  q1u() {
    var tmp0_elvis_lhs = this.o1u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.am();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.c1t();
    return true;
  }
  r1u(task) {
    var tmp0_elvis_lhs = this.o1u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayDeque.ul();
      this.o1u_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.yl(task);
  }
  s1u() {
    return compare(this.m1u_1, delta(this, true)) >= 0;
  }
  t1u() {
    var tmp0_safe_receiver = this.o1u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  u1u(unconfined) {
    this.m1u_1 = add(this.m1u_1, delta(this, unconfined));
    if (!unconfined)
      this.n1u_1 = true;
  }
  v1u(unconfined) {
    this.m1u_1 = subtract(this.m1u_1, delta(this, unconfined));
    if (compare(this.m1u_1, new Long(0, 0)) > 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.n1u_1) {
      this.w1u();
    }
  }
  w1u() {
  }
}
class ThreadLocalEventLoop {
  constructor() {
    ThreadLocalEventLoop_instance = this;
    this.x1u_1 = commonThreadLocal(new Symbol('ThreadLocalEventLoop'));
  }
  y1u() {
    var tmp0_elvis_lhs = this.x1u_1.a1v();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance().x1u_1.b1v(this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class CompletionHandlerException extends RuntimeException {
  constructor(message, cause) {
    return new.target.x1r(message, cause);
  }
  static x1r(message, cause) {
    var $this = this.qe(message, cause);
    captureStack($this, $this.w1r_1);
    return $this;
  }
}
class CoroutinesInternalError extends Error_0 {
  constructor(message, cause) {
    return new.target.e1v(message, cause);
  }
  static e1v(message, cause) {
    var $this = this.ze(message, cause);
    captureStack($this, $this.d1v_1);
    return $this;
  }
}
class Key_2 {}
class NonDisposableHandle {
  x1m() {
    return null;
  }
  u1o() {
  }
  r1n(cause) {
    return false;
  }
  toString() {
    return 'NonDisposableHandle';
  }
}
class DisposeOnCompletion extends JobNode {
  constructor(handle) {
    super();
    this.j1v_1 = handle;
  }
  y1o() {
    return false;
  }
  v1o(cause) {
    return this.j1v_1.u1o();
  }
}
class SynchronizedObject {}
class Finishing extends SynchronizedObject {
  constructor(list, isCompleting, rootCause) {
    super();
    this.l1v_1 = list;
    this.m1v_1 = atomic$boolean$1(isCompleting);
    this.n1v_1 = atomic$ref$1(rootCause);
    this.o1v_1 = atomic$ref$1(null);
  }
  h1p() {
    return this.l1v_1;
  }
  f1w(value) {
    this.m1v_1.kotlinx$atomicfu$value = value;
  }
  b1w() {
    return this.m1v_1.kotlinx$atomicfu$value;
  }
  l1w(value) {
    this.n1v_1.kotlinx$atomicfu$value = value;
  }
  e1w() {
    return this.n1v_1.kotlinx$atomicfu$value;
  }
  c1w() {
    return _get_exceptionsHolder__nhszp(this) === get_SEALED();
  }
  p1v() {
    return !(this.e1w() == null);
  }
  e1m() {
    return this.e1w() == null;
  }
  q1v(proposedException) {
    var eh = _get_exceptionsHolder__nhszp(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        // Inline function 'kotlin.also' call
        var this_0 = allocateList(this);
        this_0.d2(eh);
        tmp = this_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          // Inline function 'kotlin.error' call
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException.o(toString(message));
        }
      }
    }
    var list = tmp;
    var rootCause = this.e1w();
    if (rootCause == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      list.f5(0, rootCause);
    }
    if (!(proposedException == null) && !equals(proposedException, rootCause)) {
      list.d2(proposedException);
    }
    _set_exceptionsHolder__tqm22h(this, get_SEALED());
    return list;
  }
  d1w(exception) {
    var rootCause = this.e1w();
    if (rootCause == null) {
      this.l1w(exception);
      return Unit_instance;
    }
    if (exception === rootCause)
      return Unit_instance;
    var eh = _get_exceptionsHolder__nhszp(this);
    if (eh == null) {
      _set_exceptionsHolder__tqm22h(this, exception);
    } else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_instance;
        // Inline function 'kotlin.apply' call
        var this_0 = allocateList(this);
        this_0.d2(eh);
        this_0.d2(exception);
        _set_exceptionsHolder__tqm22h(this, this_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).d2(exception);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException.o(toString(message));
        }
      }
    }
  }
  toString() {
    return 'Finishing[cancelling=' + this.p1v() + ', completing=' + this.b1w() + ', rootCause=' + toString_0(this.e1w()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.l1v_1.toString() + ']';
  }
}
class ChildCompletion extends JobNode {
  constructor(parent, state, child, proposedUpdate) {
    super();
    this.q1w_1 = parent;
    this.r1w_1 = state;
    this.s1w_1 = child;
    this.t1w_1 = proposedUpdate;
  }
  y1o() {
    return false;
  }
  v1o(cause) {
    continueCompleting(this.q1w_1, this.r1w_1, this.s1w_1, this.t1w_1);
  }
}
class AwaitContinuation extends CancellableContinuationImpl {
  constructor(delegate, job) {
    super(delegate, 1);
    this.a1x_1 = job;
  }
  o1s(parent) {
    var state = this.a1x_1.y1m();
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.e1w();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver;
      }
    }
    if (state instanceof CompletedExceptionally)
      return state.j1m_1;
    return parent.d1n();
  }
  b1t() {
    return 'AwaitContinuation';
  }
}
class JobImpl extends JobSupport {
  constructor(parent) {
    super(true);
    this.z1l(parent);
    this.d1x_1 = handlesExceptionF(this);
  }
  m1n() {
    return true;
  }
  a1o() {
    return this.d1x_1;
  }
  o1t() {
    return this.v1n(Unit_instance);
  }
  k1t(exception) {
    return this.v1n(new CompletedExceptionally(exception));
  }
}
class Empty {
  constructor(isActive) {
    this.a1w_1 = isActive;
  }
  e1m() {
    return this.a1w_1;
  }
  h1p() {
    return null;
  }
  toString() {
    return 'Empty{' + (this.a1w_1 ? 'Active' : 'New') + '}';
  }
}
class LockFreeLinkedListHead extends LockFreeLinkedListNode {}
class NodeList extends LockFreeLinkedListHead {
  e1m() {
    return true;
  }
  h1p() {
    return this;
  }
  h1x(state) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('List{');
    this_0.m1(state);
    this_0.m1('}[');
    var first = true;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
    var cur = this.i1p_1;
    while (!equals(cur, this)) {
      var node = cur;
      if (node instanceof JobNode) {
        if (first) {
          first = false;
        } else
          this_0.m1(', ');
        this_0.s1(node);
      }
      cur = cur.i1p_1;
    }
    this_0.m1(']');
    return this_0.toString();
  }
  toString() {
    return get_DEBUG() ? this.h1x('Active') : super.toString();
  }
}
class IncompleteStateBox {
  constructor(state) {
    this.k1v_1 = state;
  }
}
class InactiveNodeList {
  constructor(list) {
    this.z1v_1 = list;
  }
  h1p() {
    return this.z1v_1;
  }
  e1m() {
    return false;
  }
  toString() {
    return get_DEBUG() ? this.z1v_1.h1x('New') : anyToString(this);
  }
}
class InvokeOnCompletion extends JobNode {
  constructor(handler) {
    super();
    this.m1x_1 = handler;
  }
  y1o() {
    return false;
  }
  v1o(cause) {
    return this.m1x_1(cause);
  }
}
class InvokeOnCancelling extends JobNode {
  constructor(handler) {
    super();
    this.r1x_1 = handler;
    this.s1x_1 = atomic$boolean$1(false);
  }
  y1o() {
    return true;
  }
  v1o(cause) {
    if (this.s1x_1.atomicfu$compareAndSet(false, true))
      this.r1x_1(cause);
  }
}
class ResumeOnCompletion extends JobNode {
  constructor(continuation) {
    super();
    this.x1x_1 = continuation;
  }
  y1o() {
    return false;
  }
  v1o(cause) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = this.x1x_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.qd(tmp$ret$1);
    return Unit_instance;
  }
}
class ChildHandleNode extends JobNode {
  constructor(childJob) {
    super();
    this.k1w_1 = childJob;
  }
  x1m() {
    return this.g1p();
  }
  y1o() {
    return true;
  }
  v1o(cause) {
    return this.k1w_1.q1n(this.g1p());
  }
  r1n(cause) {
    return this.g1p().r1n(cause);
  }
}
class ResumeAwaitOnCompletion extends JobNode {
  constructor(continuation) {
    super();
    this.c1y_1 = continuation;
  }
  y1o() {
    return false;
  }
  v1o(cause) {
    var state = this.g1p().y1m();
    // Inline function 'kotlinx.coroutines.assert' call
    if (state instanceof CompletedExceptionally) {
      var tmp0 = this.c1y_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = state.j1m_1;
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.qd(tmp$ret$2);
    } else {
      var tmp0_0 = this.c1y_1;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = unboxState(state);
      var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
      tmp0_0.qd(tmp$ret$4);
    }
  }
}
class MainCoroutineDispatcher extends CoroutineDispatcher {
  static e1y() {
    return this.q1t();
  }
  toString() {
    var tmp0_elvis_lhs = this.g1y();
    return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
  }
  g1y() {
    var main = Dispatchers_getInstance().g1u();
    if (this === main)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main.f1y();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  }
}
class NonCancellable extends AbstractCoroutineContextElement {
  constructor() {
    return new.target.j1y();
  }
  static j1y() {
    NonCancellable_instance = null;
    var $this = this.jp(Key_instance_3);
    NonCancellable_instance = $this;
    $this.i1y_1 = "NonCancellable can be used only as an argument for 'withContext', direct usages of its API are prohibited";
    return $this;
  }
  e1m() {
    return true;
  }
  z1m() {
    return false;
  }
  a1n() {
    return false;
  }
  b1n() {
    return false;
  }
  *k1n($completion) {
    throw UnsupportedOperationException.a1('This job is always active');
  }
  d1n() {
    throw IllegalStateException.o('This job is always active');
  }
  g1n(handler) {
    return NonDisposableHandle_instance;
  }
  h1n(onCancelling, invokeImmediately, handler) {
    return NonDisposableHandle_instance;
  }
  n1n(cause) {
  }
  w1n() {
    return emptySequence();
  }
  x1n(child) {
    return NonDisposableHandle_instance;
  }
  toString() {
    return 'NonCancellable';
  }
}
class SupervisorJobImpl extends JobImpl {
  r1n(cause) {
    return false;
  }
}
class SupervisorCoroutine extends ScopeCoroutine {
  r1n(cause) {
    return false;
  }
}
class TimeoutCancellationException extends CancellationException {
  constructor(message, coroutine) {
    return new.target.x1y(message, coroutine);
  }
  static x1y(message, coroutine) {
    var $this = this.n(message);
    captureStack($this, $this.w1y_1);
    $this.v1y_1 = coroutine;
    return $this;
  }
  static y1y(message) {
    return this.x1y(message, null);
  }
  h1u() {
    var tmp0_elvis_lhs = this.message;
    // Inline function 'kotlin.also' call
    var this_0 = TimeoutCancellationException.x1y(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this.v1y_1);
    initCause(this_0, this);
    return this_0;
  }
}
class TimeoutCoroutine extends ScopeCoroutine {
  constructor(time, uCont) {
    super(uCont.od(), uCont);
    this.d1z_1 = time;
  }
  c1t() {
    this.s1n(TimeoutCancellationException_0(this.d1z_1, get_delay(this.c1m_1), this));
  }
  q1m() {
    return super.q1m() + '(timeMillis=' + this.d1z_1.toString() + ')';
  }
}
class Unconfined extends CoroutineDispatcher {
  constructor() {
    return new.target.f1z();
  }
  static f1z() {
    Unconfined_instance = null;
    var $this = this.q1t();
    Unconfined_instance = $this;
    return $this;
  }
  r1t(context) {
    return false;
  }
  s1t(context, block) {
    var yieldContext = context.ae(Key_instance_4);
    if (!(yieldContext == null)) {
      yieldContext.h1z_1 = true;
      return Unit_instance;
    }
    throw UnsupportedOperationException.a1('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  }
  toString() {
    return 'Dispatchers.Unconfined';
  }
}
class Key_3 {}
class YieldContext extends AbstractCoroutineContextElement {
  constructor() {
    return new.target.i1z();
  }
  static i1z() {
    var $this = this.jp(Key_instance_4);
    $this.h1z_1 = false;
    return $this;
  }
}
class BufferOverflow extends Enum {}
class ConcurrentLinkedListNode {
  constructor(prev) {
    this.s20_1 = atomic$ref$1(null);
    this.t20_1 = atomic$ref$1(prev);
  }
  u20() {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return null;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    return tmp;
  }
  v20(value) {
    return this.s20_1.atomicfu$compareAndSet(null, value);
  }
  w20() {
    return this.u20() == null;
  }
  x20() {
    return this.t20_1.kotlinx$atomicfu$value;
  }
  y20() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    this.t20_1.kotlinx$atomicfu$value = null;
  }
  z20() {
    return this.s20_1.atomicfu$compareAndSet(null, get_CLOSED());
  }
  s7() {
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.w20())
      return Unit_instance;
    $l$loop_0: while (true) {
      var prev = _get_aliveSegmentLeft__mr4ndu(this);
      var next = _get_aliveSegmentRight__7ulr0b(this);
      var tmp0 = next.t20_1;
      $l$block: {
        // Inline function 'kotlinx.atomicfu.update' call
        while (true) {
          var cur = tmp0.kotlinx$atomicfu$value;
          var upd = cur === null ? null : prev;
          if (tmp0.atomicfu$compareAndSet(cur, upd)) {
            break $l$block;
          }
        }
      }
      if (!(prev === null))
        prev.s20_1.kotlinx$atomicfu$value = next;
      if (next.p20() && !next.w20())
        continue $l$loop_0;
      if (!(prev === null) && prev.p20())
        continue $l$loop_0;
      return Unit_instance;
    }
  }
}
class Segment extends ConcurrentLinkedListNode {
  constructor(id, prev, pointers) {
    super(prev);
    this.r1r_1 = id;
    this.s1r_1 = atomic$int$1(pointers << 16);
  }
  p20() {
    return this.s1r_1.kotlinx$atomicfu$value === this.r1z() && !this.w20();
  }
  q20() {
    var tmp0 = this.s1r_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.internal.addConditionally' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (!(!(cur === this.r1z()) || this.w20())) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        if (tmp0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
    }
    return tmp$ret$0;
  }
  r20() {
    return this.s1r_1.atomicfu$addAndGet(-65536) === this.r1z() && !this.w20();
  }
  o20() {
    if (this.s1r_1.atomicfu$incrementAndGet() === this.r1z()) {
      this.s7();
    }
  }
}
class ChannelSegment extends Segment {
  constructor(id, prev, channel, pointers) {
    super(id, prev, pointers);
    this.o1z_1 = channel;
    this.p1z_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
  }
  q1z() {
    return ensureNotNull(this.o1z_1);
  }
  r1z() {
    return get_SEGMENT_SIZE();
  }
  s1z(index, element) {
    setElementLazy(this, index, element);
  }
  t1z(index) {
    return this.p1z_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
  }
  u1z(index) {
    // Inline function 'kotlin.also' call
    var this_0 = this.t1z(index);
    this.v1z(index);
    return this_0;
  }
  v1z(index) {
    setElementLazy(this, index, null);
  }
  w1z(index) {
    return this.p1z_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
  }
  x1z(index, value) {
    this.p1z_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
  }
  y1z(index, from, to) {
    return this.p1z_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
  }
  z1z(index, update) {
    return this.p1z_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
  }
  t1r(index, cause, context) {
    var isSender = index >= get_SEGMENT_SIZE();
    var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
    var element = this.t1z(index_0);
    $l$loop: while (true) {
      var cur = this.w1z(index_0);
      var tmp;
      if (!(cur == null) ? isInterface(cur, Waiter) : false) {
        tmp = true;
      } else {
        tmp = cur instanceof WaiterEB;
      }
      if (tmp) {
        var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
        if (this.y1z(index_0, cur, update)) {
          this.v1z(index_0);
          this.m20(index_0, !isSender);
          if (isSender) {
            var tmp0_safe_receiver = this.q1z().b20_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp0_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        }
      } else {
        if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
          this.v1z(index_0);
          if (isSender) {
            var tmp1_safe_receiver = this.q1z().b20_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp1_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        } else {
          if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
            continue $l$loop;
          else {
            if (cur === get_DONE_RCV() || cur === get_BUFFERED())
              return Unit_instance;
            else {
              if (cur === get_CHANNEL_CLOSED())
                return Unit_instance;
              else {
                // Inline function 'kotlin.error' call
                var message = 'unexpected state: ' + toString_0(cur);
                throw IllegalStateException.o(toString(message));
              }
            }
          }
        }
      }
    }
  }
  m20(index, receiver) {
    if (receiver) {
      var tmp = this.q1z();
      var tmp0 = this.r1r_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      // Inline function 'kotlin.Long.plus' call
      var this_0 = multiply(tmp0, fromInt(other));
      var tmp$ret$1 = add(this_0, fromInt(index));
      tmp.n20(tmp$ret$1);
    }
    this.o20();
  }
}
class SendBroadcast {}
class BufferedChannelIterator {
  constructor($outer) {
    this.c21_1 = $outer;
    this.a21_1 = get_NO_RECEIVE_RESULT();
    this.b21_1 = null;
  }
  *x21($completion) {
    var tmp;
    if (!(this.a21_1 === get_NO_RECEIVE_RESULT()) && !(this.a21_1 === get_CHANNEL_CLOSED())) {
      tmp = true;
    } else {
      var tmp0 = this.c21_1;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
        var segment = tmp0.h20_1.kotlinx$atomicfu$value;
        $l$loop_0: while (true) {
          if (tmp0.f21()) {
            tmp$ret$0 = onClosedHasNext(this);
            break $l$block_0;
          }
          var r = tmp0.d20_1.atomicfu$getAndIncrement$long();
          // Inline function 'kotlin.Long.div' call
          var other = get_SEGMENT_SIZE();
          var id = divide(r, fromInt(other));
          // Inline function 'kotlin.Long.rem' call
          var other_0 = get_SEGMENT_SIZE();
          var tmp$ret$3 = modulo(r, fromInt(other_0));
          var i = convertToInt(tmp$ret$3);
          if (!equalsLong(segment.r1r_1, id)) {
            var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            segment = tmp_0;
          }
          var updCellResult = updateCellReceive(tmp0, segment, i, r, null);
          var tmp_1;
          if (updCellResult === get_SUSPEND()) {
            var tmp1_safe_receiver = (!(null == null) ? isInterface(null, Waiter) : false) ? null : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment, i);
            }
            // Inline function 'kotlin.error' call
            var message = 'unreachable';
            throw IllegalStateException.o(toString(message));
          } else if (updCellResult === get_FAILED()) {
            if (compare(r, tmp0.e21()) < 0) {
              segment.y20();
            }
            continue $l$loop_0;
          } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
            var segm = segment;
            return yield* /*#__NOINLINE__*/hasNextOnNoWaiterSuspend(this, segm, i, r, $completion);
          } else {
            segment.y20();
            this.a21_1 = updCellResult;
            tmp_1 = true;
          }
          tmp$ret$0 = tmp_1;
          break $l$block_0;
        }
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  v1s(segment, index) {
    var tmp0_safe_receiver = this.b21_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.v1s(segment, index);
    }
  }
  r1() {
    var result = this.a21_1;
    // Inline function 'kotlin.check' call
    if (!!(result === get_NO_RECEIVE_RESULT())) {
      var message = '`hasNext()` has not been invoked';
      throw IllegalStateException.o(toString(message));
    }
    this.a21_1 = get_NO_RECEIVE_RESULT();
    if (result === get_CHANNEL_CLOSED())
      throw recoverStackTrace_0(_get_receiveException__foorc1(this.c21_1));
    return result;
  }
  k21(element) {
    var cont = ensureNotNull(this.b21_1);
    this.b21_1 = null;
    this.a21_1 = element;
    var tmp0_safe_receiver = this.c21_1.b20_1;
    return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(this.c21_1, tmp0_safe_receiver, element));
  }
  y21() {
    var cont = ensureNotNull(this.b21_1);
    this.b21_1 = null;
    this.a21_1 = get_CHANNEL_CLOSED();
    var cause = this.c21_1.d21();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
      cont.qd(tmp$ret$1);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.qd(tmp$ret$3);
    }
  }
}
class SendChannel {}
function close$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  return $super === VOID ? this.w22(cause) : $super.w22.call(this, cause);
}
class ReceiveChannel {}
function cancel$default_0(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.n1n(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.n1n.call(this, cause);
  }
  return tmp;
}
class Channel {}
class BufferedChannel {
  constructor(capacity, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    this.a20_1 = capacity;
    this.b20_1 = onUndeliveredElement;
    // Inline function 'kotlin.require' call
    if (!(this.a20_1 >= 0)) {
      var message = 'Invalid channel capacity: ' + this.a20_1 + ', should be >=0';
      throw IllegalArgumentException.h2(toString(message));
    }
    this.c20_1 = atomic$long$1(new Long(0, 0));
    this.d20_1 = atomic$long$1(new Long(0, 0));
    this.e20_1 = atomic$long$1(initialBufferEnd(this.a20_1));
    this.f20_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
    var firstSegment = new ChannelSegment(new Long(0, 0), null, this, 3);
    this.g20_1 = atomic$ref$1(firstSegment);
    this.h20_1 = atomic$ref$1(firstSegment);
    var tmp = this;
    var tmp_0;
    if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
      var tmp_1 = get_NULL_SEGMENT();
      tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = firstSegment;
    }
    tmp.i20_1 = atomic$ref$1(tmp_0);
    var tmp_2 = this;
    var tmp_3;
    if (this.b20_1 == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
    }
    tmp_2.j20_1 = tmp_3;
    this.k20_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
    this.l20_1 = atomic$ref$1(null);
  }
  e21() {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var this_0 = this.c20_1.kotlinx$atomicfu$value;
    return bitwiseAnd(this_0, new Long(-1, 268435455));
  }
  h21() {
    return this.d20_1.kotlinx$atomicfu$value;
  }
  *j22(element, $completion) {
    $l$block_5: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = this.g20_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = this.c20_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
        var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(s, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(s, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.r1r_1, id)) {
          var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
              break $l$block_5;
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        switch (updateCellSend(this, segment, i, element, s, null, closed)) {
          case 0:
            segment.y20();
            break $l$block_5;
          case 1:
            break $l$block_5;
          case 2:
            if (closed) {
              segment.o20();
              yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
              break $l$block_5;
            }

            var tmp2_safe_receiver = (!(null == null) ? isInterface(null, Waiter) : false) ? null : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
            }

            // Inline function 'kotlinx.coroutines.assert' call

            break $l$block_5;
          case 4:
            if (compare(s, this.h21()) < 0) {
              segment.y20();
            }

            yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
            break $l$block_5;
          case 5:
            segment.y20();
            continue $l$loop_0;
          case 3:
            var segm = segment;
            yield* /*#__NOINLINE__*/sendOnNoWaiterSuspend(this, segm, i, element, s, $completion);
            break $l$block_5;
        }
      }
    }
    return Unit_instance;
  }
  k22(element) {
    if (shouldSendSuspend0(this, this.c20_1.kotlinx$atomicfu$value))
      return Companion_getInstance_0().l22();
    var tmp4 = get_INTERRUPTED_SEND();
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = this.g20_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = this.c20_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
        var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(s, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(s, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.r1r_1, id)) {
          var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              tmp$ret$0 = Companion_getInstance_0().r21(this.g21());
              break $l$block_5;
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        switch (updateCellSend(this, segment, i, element, s, tmp4, closed)) {
          case 0:
            segment.y20();
            tmp$ret$0 = Companion_getInstance_0().m21(Unit_instance);
            break $l$block_5;
          case 1:
            tmp$ret$0 = Companion_getInstance_0().m21(Unit_instance);
            break $l$block_5;
          case 2:
            if (closed) {
              segment.o20();
              tmp$ret$0 = Companion_getInstance_0().r21(this.g21());
              break $l$block_5;
            }

            var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter) : false) ? tmp4 : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
            }

            segment.o20();
            tmp$ret$0 = Companion_getInstance_0().l22();
            break $l$block_5;
          case 4:
            if (compare(s, this.h21()) < 0) {
              segment.y20();
            }

            tmp$ret$0 = Companion_getInstance_0().r21(this.g21());
            break $l$block_5;
          case 5:
            segment.y20();
            continue $l$loop_0;
          case 3:
            // Inline function 'kotlin.error' call

            var message = 'unexpected';
            throw IllegalStateException.o(toString(message));
        }
      }
    }
    return tmp$ret$0;
  }
  m22(element) {
    var tmp4 = get_BUFFERED();
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = this.g20_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = this.c20_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
        var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(s, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(s, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.r1r_1, id)) {
          var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              return Companion_getInstance_0().r21(this.g21());
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        switch (updateCellSend(this, segment, i, element, s, tmp4, closed)) {
          case 0:
            segment.y20();
            return Companion_getInstance_0().m21(Unit_instance);
          case 1:
            return Companion_getInstance_0().m21(Unit_instance);
          case 2:
            if (closed) {
              segment.o20();
              return Companion_getInstance_0().r21(this.g21());
            }

            var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter) : false) ? tmp4 : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
            }

            var tmp0 = segment.r1r_1;
            // Inline function 'kotlin.Long.times' call

            var other_1 = get_SEGMENT_SIZE();
            // Inline function 'kotlin.Long.plus' call

            var this_0 = multiply(tmp0, fromInt(other_1));
            var tmp$ret$10 = add(this_0, fromInt(i));
            this.f22(tmp$ret$10);
            return Companion_getInstance_0().m21(Unit_instance);
          case 4:
            if (compare(s, this.h21()) < 0) {
              segment.y20();
            }

            return Companion_getInstance_0().r21(this.g21());
          case 5:
            segment.y20();
            continue $l$loop_0;
          case 3:
            // Inline function 'kotlin.error' call

            var message = 'unexpected';
            throw IllegalStateException.o(toString(message));
        }
      }
    }
    return tmp$ret$0;
  }
  p21() {
  }
  i21() {
  }
  *n22($completion) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
      var segment = this.h20_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        if (this.f21()) {
          throw recoverStackTrace_0(_get_receiveException__foorc1(this));
        }
        var r = this.d20_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(r, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(r, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.r1r_1, id)) {
          var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var updCellResult = updateCellReceive(this, segment, i, r, null);
        var tmp_0;
        if (updCellResult === get_SUSPEND()) {
          var tmp1_safe_receiver = (!(null == null) ? isInterface(null, Waiter) : false) ? null : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            prepareReceiverForSuspension(this, tmp1_safe_receiver, segment, i);
          }
          // Inline function 'kotlin.error' call
          var message = 'unexpected';
          throw IllegalStateException.o(toString(message));
        } else if (updCellResult === get_FAILED()) {
          if (compare(r, this.e21()) < 0) {
            segment.y20();
          }
          continue $l$loop_0;
        } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
          var segm = segment;
          tmp_0 = yield* /*#__NOINLINE__*/receiveOnNoWaiterSuspend(this, segm, i, r, $completion);
        } else {
          segment.y20();
          return updCellResult;
        }
        tmp$ret$0 = tmp_0;
        break $l$block_0;
      }
    }
    return tmp$ret$0;
  }
  *o22($completion) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
      var segment = this.h20_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        if (this.f21()) {
          tmp$ret$0 = Companion_getInstance_0().r21(this.d21());
          break $l$block_0;
        }
        var r = this.d20_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(r, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(r, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.r1r_1, id)) {
          var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var updCellResult = updateCellReceive(this, segment, i, r, null);
        var tmp_0;
        if (updCellResult === get_SUSPEND()) {
          var tmp1_safe_receiver = (!(null == null) ? isInterface(null, Waiter) : false) ? null : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            prepareReceiverForSuspension(this, tmp1_safe_receiver, segment, i);
          }
          // Inline function 'kotlin.error' call
          var message = 'unexpected';
          throw IllegalStateException.o(toString(message));
        } else if (updCellResult === get_FAILED()) {
          if (compare(r, this.e21()) < 0) {
            segment.y20();
          }
          continue $l$loop_0;
        } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
          var segm = segment;
          tmp_0 = yield* /*#__NOINLINE__*/receiveCatchingOnNoWaiterSuspend(this, segm, i, r, $completion);
        } else {
          segment.y20();
          tmp_0 = new ChannelResult(Companion_getInstance_0().m21(updCellResult));
        }
        tmp$ret$0 = tmp_0.q21_1;
        break $l$block_0;
      }
    }
    return new ChannelResult(tmp$ret$0);
  }
  p22() {
    var r = this.d20_1.kotlinx$atomicfu$value;
    var sendersAndCloseStatusCur = this.c20_1.kotlinx$atomicfu$value;
    if (_get_isClosedForReceive0__f7qknl(this, sendersAndCloseStatusCur)) {
      return Companion_getInstance_0().r21(this.d21());
    }
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var s = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
    if (compare(r, s) >= 0)
      return Companion_getInstance_0().l22();
    var tmp2 = get_INTERRUPTED_RCV();
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
      var segment = this.h20_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        if (this.f21()) {
          tmp$ret$1 = Companion_getInstance_0().r21(this.d21());
          break $l$block_0;
        }
        var r_0 = this.d20_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(r_0, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$4 = modulo(r_0, fromInt(other_0));
        var i = convertToInt(tmp$ret$4);
        if (!equalsLong(segment.r1r_1, id)) {
          var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var updCellResult = updateCellReceive(this, segment, i, r_0, tmp2);
        var tmp_0;
        if (updCellResult === get_SUSPEND()) {
          var tmp1_safe_receiver = (!(tmp2 == null) ? isInterface(tmp2, Waiter) : false) ? tmp2 : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            prepareReceiverForSuspension(this, tmp1_safe_receiver, segment, i);
          }
          var segm = segment;
          this.n20(r_0);
          segm.o20();
          tmp_0 = new ChannelResult(Companion_getInstance_0().l22());
        } else if (updCellResult === get_FAILED()) {
          if (compare(r_0, this.e21()) < 0) {
            segment.y20();
          }
          continue $l$loop_0;
        } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
          // Inline function 'kotlin.error' call
          var message = 'unexpected';
          throw IllegalStateException.o(toString(message));
        } else {
          segment.y20();
          tmp_0 = new ChannelResult(Companion_getInstance_0().m21(updCellResult));
        }
        tmp$ret$1 = tmp_0.q21_1;
        break $l$block_0;
      }
    }
    return tmp$ret$1;
  }
  f22(globalCellIndex) {
    // Inline function 'kotlinx.coroutines.assert' call
    var segment = this.h20_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var r = this.d20_1.kotlinx$atomicfu$value;
      // Inline function 'kotlin.Long.plus' call
      var other = this.a20_1;
      var tmp0 = add(r, fromInt(other));
      // Inline function 'kotlin.math.max' call
      var b = _get_bufferEndCounter__2d4hee(this);
      var tmp$ret$2 = compare(tmp0, b) >= 0 ? tmp0 : b;
      if (compare(globalCellIndex, tmp$ret$2) < 0)
        return Unit_instance;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$3 = add(r, fromInt(1));
      if (!this.d20_1.atomicfu$compareAndSet(r, tmp$ret$3))
        continue $l$loop_0;
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      var id = divide(r, fromInt(other_0));
      // Inline function 'kotlin.Long.rem' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$5 = modulo(r, fromInt(other_1));
      var i = convertToInt(tmp$ret$5);
      if (!equalsLong(segment.r1r_1, id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      var updCellResult = updateCellReceive(this, segment, i, r, null);
      if (updCellResult === get_FAILED()) {
        if (compare(r, this.e21()) < 0) {
          segment.y20();
        }
      } else {
        segment.y20();
        var tmp1_safe_receiver = this.b20_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp1_safe_receiver, updCellResult);
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp2_safe_receiver;
        }
      }
    }
  }
  n20(globalIndex) {
    if (_get_isRendezvousOrUnlimited__3mdufi(this))
      return Unit_instance;
    while (compare(_get_bufferEndCounter__2d4hee(this), globalIndex) <= 0) {
    }
    // Inline function 'kotlin.repeat' call
    var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = _get_bufferEndCounter__2d4hee(this);
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var this_0 = this.f20_1.kotlinx$atomicfu$value;
        var ebCompleted = bitwiseAnd(this_0, new Long(-1, 1073741823));
        if (equalsLong(b, ebCompleted) && equalsLong(b, _get_bufferEndCounter__2d4hee(this)))
          return Unit_instance;
      }
       while (inductionVariable < times);
    var tmp0 = this.f20_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var tmp$ret$5 = bitwiseAnd(cur, new Long(-1, 1073741823));
        var upd = constructEBCompletedAndPauseFlag(tmp$ret$5, true);
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    while (true) {
      var b_0 = _get_bufferEndCounter__2d4hee(this);
      var ebCompletedAndBit = this.f20_1.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var ebCompleted_0 = bitwiseAnd(ebCompletedAndBit, new Long(-1, 1073741823));
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      var pauseExpandBuffers = !equalsLong(bitwiseAnd(ebCompletedAndBit, new Long(0, 1073741824)), new Long(0, 0));
      if (equalsLong(b_0, ebCompleted_0) && equalsLong(b_0, _get_bufferEndCounter__2d4hee(this))) {
        var tmp0_0 = this.f20_1;
        $l$block_0: {
          // Inline function 'kotlinx.atomicfu.update' call
          while (true) {
            var cur_0 = tmp0_0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var tmp$ret$10 = bitwiseAnd(cur_0, new Long(-1, 1073741823));
            var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$10, false);
            if (tmp0_0.atomicfu$compareAndSet(cur_0, upd_0)) {
              break $l$block_0;
            }
          }
        }
        return Unit_instance;
      }
      if (!pauseExpandBuffers) {
        this.f20_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
      }
    }
  }
  p1() {
    return new BufferedChannelIterator(this);
  }
  d21() {
    var tmp = this.k20_1.kotlinx$atomicfu$value;
    return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
  }
  g21() {
    var tmp0_elvis_lhs = this.d21();
    return tmp0_elvis_lhs == null ? ClosedSendChannelException.u22('Channel was closed') : tmp0_elvis_lhs;
  }
  v22() {
  }
  w22(cause) {
    return this.x22(cause, false);
  }
  n1n(cause) {
    this.z22(cause);
  }
  z22(cause) {
    return this.x22(cause == null ? CancellationException.n('Channel was cancelled') : cause, true);
  }
  x22(cause, cancel) {
    if (cancel) {
      markCancellationStarted(this);
    }
    var closedByThisOperation = this.k20_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
    if (cancel) {
      markCancelled(this);
    } else {
      markClosed(this);
    }
    completeCloseOrCancel(this);
    // Inline function 'kotlin.also' call
    this.v22();
    if (closedByThisOperation) {
      invokeCloseHandler(this);
    }
    return closedByThisOperation;
  }
  b23(handler) {
    if (this.l20_1.atomicfu$compareAndSet(null, handler)) {
      return Unit_instance;
    }
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.l20_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      if (cur === get_CLOSE_HANDLER_CLOSED()) {
        if (this.l20_1.atomicfu$compareAndSet(get_CLOSE_HANDLER_CLOSED(), get_CLOSE_HANDLER_INVOKED())) {
          handler(this.d21());
          return Unit_instance;
        }
      } else if (cur === get_CLOSE_HANDLER_INVOKED()) {
        // Inline function 'kotlin.error' call
        var message = 'Another handler was already registered and successfully invoked';
        throw IllegalStateException.o(toString(message));
      } else {
        // Inline function 'kotlin.error' call
        var message_0 = 'Another handler is already registered: ' + toString_0(cur);
        throw IllegalStateException.o(toString(message_0));
      }
    }
  }
  g22() {
    return false;
  }
  e22() {
    return _get_isClosedForSend0__kxgf9m(this, this.c20_1.kotlinx$atomicfu$value);
  }
  f21() {
    return _get_isClosedForReceive0__f7qknl(this, this.c20_1.kotlinx$atomicfu$value);
  }
  h22() {
    $l$loop: while (true) {
      var segment = this.h20_1.kotlinx$atomicfu$value;
      var r = this.h21();
      var s = this.e21();
      if (compare(s, r) <= 0)
        return false;
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = divide(r, fromInt(other));
      if (!equalsLong(segment.r1r_1, id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (compare(this.h20_1.kotlinx$atomicfu$value.r1r_1, id) < 0) {
            return false;
          } else {
            continue $l$loop;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      segment.y20();
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$1 = modulo(r, fromInt(other_0));
      var i = convertToInt(tmp$ret$1);
      if (isCellNonEmpty(this, segment, i, r))
        return true;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = add(r, fromInt(1));
      this.d20_1.atomicfu$compareAndSet(r, tmp$ret$2);
    }
  }
  toString() {
    var sb = StringBuilder.l1();
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var this_0 = this.c20_1.kotlinx$atomicfu$value;
    var tmp0_subject = convertToInt(shiftRight(this_0, 60));
    if (tmp0_subject === 2) {
      sb.m1('closed,');
    } else if (tmp0_subject === 3) {
      sb.m1('cancelled,');
    }
    sb.m1('capacity=' + this.a20_1 + ',');
    sb.m1('data=[');
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = listOf([this.h20_1.kotlinx$atomicfu$value, this.g20_1.kotlinx$atomicfu$value, this.i20_1.kotlinx$atomicfu$value]);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(element === get_NULL_SEGMENT())) {
        destination.d2(element);
      }
    }
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var iterator = destination.p1();
      if (!iterator.q1())
        throw NoSuchElementException.w7();
      var minElem = iterator.r1();
      if (!iterator.q1()) {
        tmp$ret$4 = minElem;
        break $l$block;
      }
      var minValue = minElem.r1r_1;
      do {
        var e = iterator.r1();
        var v = e.r1r_1;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.q1());
      tmp$ret$4 = minElem;
    }
    var firstSegment = tmp$ret$4;
    var r = this.h21();
    var s = this.e21();
    var segment = firstSegment;
    append_elements: while (true) {
      var inductionVariable = 0;
      var last_0 = get_SEGMENT_SIZE();
      if (inductionVariable < last_0)
        process_cell: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_0 = segment.r1r_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_1 = multiply(tmp0_0, fromInt(other));
          var globalCellIndex = add(this_1, fromInt(i));
          if (compare(globalCellIndex, s) >= 0 && compare(globalCellIndex, r) >= 0)
            break append_elements;
          var cellState = segment.w1z(i);
          var element_0 = segment.t1z(i);
          var tmp;
          if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) {
            tmp = compare(globalCellIndex, r) < 0 && compare(globalCellIndex, s) >= 0 ? 'receive' : compare(globalCellIndex, s) < 0 && compare(globalCellIndex, r) >= 0 ? 'send' : 'cont';
          } else {
            if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) {
              tmp = compare(globalCellIndex, r) < 0 && compare(globalCellIndex, s) >= 0 ? 'onReceive' : compare(globalCellIndex, s) < 0 && compare(globalCellIndex, r) >= 0 ? 'onSend' : 'select';
            } else {
              if (cellState instanceof ReceiveCatching) {
                tmp = 'receiveCatching';
              } else {
                if (cellState instanceof SendBroadcast) {
                  tmp = 'sendBroadcast';
                } else {
                  if (cellState instanceof WaiterEB) {
                    tmp = 'EB(' + cellState.toString() + ')';
                  } else {
                    if (equals(cellState, get_RESUMING_BY_RCV()) || equals(cellState, get_RESUMING_BY_EB())) {
                      tmp = 'resuming_sender';
                    } else {
                      if (cellState == null || (equals(cellState, get_IN_BUFFER()) || equals(cellState, get_DONE_RCV())) || (equals(cellState, get_POISONED()) || equals(cellState, get_INTERRUPTED_RCV()) || (equals(cellState, get_INTERRUPTED_SEND()) || equals(cellState, get_CHANNEL_CLOSED())))) {
                        continue process_cell;
                      } else {
                        tmp = toString(cellState);
                      }
                    }
                  }
                }
              }
            }
          }
          var cellStateString = tmp;
          if (!(element_0 == null)) {
            sb.m1('(' + cellStateString + ',' + toString_0(element_0) + '),');
          } else {
            sb.m1(cellStateString + ',');
          }
        }
         while (inductionVariable < last_0);
      var tmp2_elvis_lhs = segment.u20();
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        break append_elements;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      segment = tmp_0;
    }
    if (last(sb) === _Char___init__impl__6a9atx(44)) {
      sb.th(sb.a() - 1 | 0);
    }
    sb.m1(']');
    return sb.toString();
  }
}
class WaiterEB {
  constructor(waiter) {
    this.j21_1 = waiter;
  }
  toString() {
    return 'WaiterEB(' + toString(this.j21_1) + ')';
  }
}
class ReceiveCatching {
  constructor(cont) {
    this.n21_1 = cont;
  }
  v1s(segment, index) {
    this.n21_1.v1s(segment, index);
  }
}
class Factory {
  constructor() {
    Factory_instance = this;
    this.c23_1 = 2147483647;
    this.d23_1 = 0;
    this.e23_1 = -1;
    this.f23_1 = -2;
    this.g23_1 = -3;
    this.h23_1 = 'kotlinx.coroutines.channels.defaultBuffer';
    this.i23_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
}
class ClosedReceiveChannelException extends NoSuchElementException {
  constructor(message) {
    return new.target.d22(message);
  }
  static d22(message) {
    var $this = this.a2(message);
    captureStack($this, $this.c22_1);
    return $this;
  }
}
class Failed {
  toString() {
    return 'Failed';
  }
}
class Closed extends Failed {
  constructor(cause) {
    super();
    this.j23_1 = cause;
  }
  equals(other) {
    var tmp;
    if (other instanceof Closed) {
      tmp = equals(this.j23_1, other.j23_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.j23_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  toString() {
    return 'Closed(' + toString_0(this.j23_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.l21_1 = new Failed();
  }
  m21(value) {
    return _ChannelResult___init__impl__siwsuf(value);
  }
  l22() {
    return _ChannelResult___init__impl__siwsuf(this.l21_1);
  }
  r21(cause) {
    return _ChannelResult___init__impl__siwsuf(new Closed(cause));
  }
}
class ChannelResult {
  constructor(holder) {
    Companion_getInstance_0();
    this.q21_1 = holder;
  }
  toString() {
    return ChannelResult__toString_impl_rrcqu7(this.q21_1);
  }
  hashCode() {
    return ChannelResult__hashCode_impl_lilec2(this.q21_1);
  }
  equals(other) {
    return ChannelResult__equals_impl_f471ri(this.q21_1, other);
  }
}
class ClosedSendChannelException extends IllegalStateException {
  constructor(message) {
    return new.target.u22(message);
  }
  static u22(message) {
    var $this = this.o(message);
    captureStack($this, $this.t22_1);
    return $this;
  }
}
class ChannelCoroutine extends AbstractCoroutine {
  constructor(parentContext, _channel, initParentJob, active) {
    super(parentContext, initParentJob, active);
    this.n23_1 = _channel;
  }
  n1n(cause) {
    if (this.a1n())
      return Unit_instance;
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = JobCancellationException.x1v(null == null ? this.h1m() : null, null, this);
    } else {
      tmp = cause;
    }
    this.p1n(tmp);
  }
  a23(cause, $super) {
    return this.o1n(cause, ($super == null ? true : $super instanceof ChannelCoroutine) ? $super : THROW_CCE());
  }
  p1n(cause) {
    var exception = this.f1n(cause);
    this.n23_1.n1n(exception);
    this.s1n(exception);
  }
  e22() {
    return this.n23_1.e22();
  }
  *j22(element, $completion) {
    yield* this.n23_1.j22(element, $completion);
    return Unit_instance;
  }
  k22(element) {
    return this.n23_1.k22(element);
  }
  w22(cause) {
    return this.n23_1.w22(cause);
  }
  b23(handler) {
    this.n23_1.b23(handler);
  }
  *n22($completion) {
    return yield* this.n23_1.n22($completion);
  }
  *o22($completion) {
    return yield* this.n23_1.o22($completion);
  }
  p22() {
    return this.n23_1.p22();
  }
  p1() {
    return this.n23_1.p1();
  }
}
class ConflatedBufferedChannel extends BufferedChannel {
  constructor(capacity, onBufferOverflow, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    super(capacity, onUndeliveredElement);
    this.a24_1 = capacity;
    this.b24_1 = onBufferOverflow;
    // Inline function 'kotlin.require' call
    if (!!(this.b24_1 === BufferOverflow_SUSPEND_getInstance())) {
      var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel).j1() + ' instead';
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.a24_1 >= 1)) {
      var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.a24_1 + ' was specified';
      throw IllegalArgumentException.h2(toString(message_0));
    }
  }
  g22() {
    return this.b24_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
  }
  *j22(element, $completion) {
    // Inline function 'kotlinx.coroutines.channels.onClosed' call
    var this_0 = trySendImpl(this, element, true);
    var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
    if (tmp instanceof Closed) {
      ChannelResult__exceptionOrNull_impl_16ei30(this_0);
      var tmp0_safe_receiver = this.b20_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, this.g21());
        throw tmp1_safe_receiver;
      }
      throw this.g21();
    }
    return Unit_instance;
  }
  k22(element) {
    return trySendImpl(this, element, false);
  }
}
class ProducerCoroutine extends ChannelCoroutine {
  constructor(parentContext, channel) {
    super(parentContext, channel, true, true);
  }
  e1m() {
    return super.e1m();
  }
  g24(value) {
    this.n23_1.y22();
  }
  f1m(value) {
    return this.g24(value instanceof Unit ? value : THROW_CCE());
  }
  g1m(cause, handled) {
    var processed = this.n23_1.w22(cause);
    if (!processed && !handled) {
      handleCoroutineException(this.c1m_1, cause);
    }
  }
  a23(cause, $super) {
    return this.o1n(cause, ($super == null ? true : $super instanceof ProducerCoroutine) ? $super : THROW_CCE());
  }
}
class Flow {}
class AbstractFlow {
  *j24(collector, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.od();
    var safeCollector = new SafeCollector(collector, tmp$ret$0);
    try {
      yield* this.i24(safeCollector, $completion);
    }finally {
      safeCollector.yd();
    }
    return Unit_instance;
  }
}
class SafeFlow extends AbstractFlow {
  constructor(block) {
    super();
    this.h24_1 = block;
  }
  *i24(collector, $completion) {
    yield* this.h24_1(collector, $completion);
    return Unit_instance;
  }
}
class FlowCollector {}
class AbstractSharedFlow extends SynchronizedObject {
  constructor() {
    super();
    this.b25_1 = null;
    this.c25_1 = 0;
    this.d25_1 = 0;
    this.e25_1 = null;
  }
  t25() {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var curSlots = this.b25_1;
    var tmp;
    if (curSlots == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.b26(2);
      this.b25_1 = this_0;
      tmp = this_0;
    } else {
      var tmp_0;
      if (this.c25_1 >= curSlots.length) {
        // Inline function 'kotlin.also' call
        var this_1 = copyOf(curSlots, imul(2, curSlots.length));
        this.b25_1 = this_1;
        tmp_0 = this_1;
      } else {
        tmp_0 = curSlots;
      }
      tmp = tmp_0;
    }
    var slots = tmp;
    var index = this.d25_1;
    var slot;
    $l$loop: while (true) {
      var tmp0_elvis_lhs = slots[index];
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_2 = this.a26();
        slots[index] = this_2;
        tmp_1 = this_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      slot = tmp_1;
      index = index + 1 | 0;
      if (index >= slots.length)
        index = 0;
      if ((slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).f26(this))
        break $l$loop;
    }
    this.d25_1 = index;
    this.c25_1 = this.c25_1 + 1 | 0;
    subscriptionCount = this.e25_1;
    var slot_0 = slot;
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.x26(1);
    return slot_0;
  }
  z25(slot) {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    this.c25_1 = this.c25_1 - 1 | 0;
    subscriptionCount = this.e25_1;
    if (this.c25_1 === 0)
      this.d25_1 = 0;
    var resumes = (slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).h26(this);
    var inductionVariable = 0;
    var last = resumes.length;
    while (inductionVariable < last) {
      var cont = resumes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cont == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
        cont.qd(tmp$ret$4);
      }
    }
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.x26(-1);
  }
}
class FusibleFlow {}
function fuse$default(context, capacity, onBufferOverflow, $super) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  capacity = capacity === VOID ? -3 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  return $super === VOID ? this.c26(context, capacity, onBufferOverflow) : $super.c26.call(this, context, capacity, onBufferOverflow);
}
class StateFlowImpl extends AbstractSharedFlow {
  constructor(initialState) {
    super();
    this.l25_1 = atomic$ref$1(initialState);
    this.m25_1 = 0;
  }
  p25(value) {
    updateState(this, null, value == null ? get_NULL() : value);
  }
  k3() {
    var tmp0 = get_NULL();
    // Inline function 'kotlinx.coroutines.internal.Symbol.unbox' call
    var value = this.l25_1.kotlinx$atomicfu$value;
    return value === tmp0 ? null : value;
  }
  q25(expect, update) {
    var tmp = expect == null ? get_NULL() : expect;
    return updateState(this, tmp, update == null ? get_NULL() : update);
  }
  r25(value) {
    this.p25(value);
    return true;
  }
  *k24(value, $completion) {
    this.p25(value);
    return Unit_instance;
  }
  *s25(collector, $completion) {
    var slot = this.t25();
    try {
      if (collector instanceof SubscribedFlowCollector)
        yield* collector.w25($completion);
      // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
      // Inline function 'kotlin.js.getCoroutineContext' call
      var collectorJob = $completion.od().ae(Key_instance_3);
      var oldState = null;
      while (true) {
        var newState = this.l25_1.kotlinx$atomicfu$value;
        if (collectorJob == null)
          null;
        else {
          ensureActive_1(collectorJob);
        }
        if (oldState == null || !equals(oldState, newState)) {
          // Inline function 'kotlinx.coroutines.internal.Symbol.unbox' call
          var tmp$ret$2 = newState === get_NULL() ? null : newState;
          yield* collector.k24(tmp$ret$2, $completion);
          oldState = newState;
        }
        if (!slot.y25()) {
          yield* slot.x25($completion);
        }
      }
    }finally {
      this.z25(slot);
    }
  }
  j24(collector, $completion) {
    return this.s25(collector, $completion);
  }
  a26() {
    return new StateFlowSlot();
  }
  b26(size) {
    // Inline function 'kotlin.arrayOfNulls' call
    return Array(size);
  }
  c26(context, capacity, onBufferOverflow) {
    return fuseStateFlow(this, context, capacity, onBufferOverflow);
  }
}
class AbstractSharedFlowSlot {}
class StateFlowSlot extends AbstractSharedFlowSlot {
  constructor() {
    super();
    this.n25_1 = new WorkaroundAtomicReference(null);
  }
  e26(flow) {
    if (!(get_value(this.n25_1) == null))
      return false;
    set_value(this.n25_1, get_NONE());
    return true;
  }
  f26(flow) {
    return this.e26(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  }
  g26(flow) {
    set_value(this.n25_1, null);
    return get_EMPTY_RESUMES();
  }
  h26(flow) {
    return this.g26(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  }
  o25() {
    // Inline function 'kotlinx.coroutines.internal.loop' call
    var this_0 = this.n25_1;
    while (true) {
      var state = get_value(this_0);
      if (state == null)
        return Unit_instance;
      else if (state === get_PENDING())
        return Unit_instance;
      else if (state === get_NONE()) {
        if (this.n25_1.j26(state, get_PENDING()))
          return Unit_instance;
      } else {
        if (this.n25_1.j26(state, get_NONE())) {
          // Inline function 'kotlin.coroutines.resume' call
          var this_1 = state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
          this_1.qd(tmp$ret$3);
          return Unit_instance;
        }
      }
    }
  }
  y25() {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.assert' call
    return ensureNotNull(this.n25_1.k26(get_NONE())) === get_PENDING();
  }
  *x25($completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    (yield () => {
      var uCont = $completion;
      var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
      cancellable.u1p();
      $l$block: {
        // Inline function 'kotlinx.coroutines.assert' call
        if (this.n25_1.j26(get_NONE(), cancellable)) {
          break $l$block;
        }
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.qd(tmp$ret$7);
      }
      return cancellable.v1p();
    });
    return Unit_instance;
  }
}
class ChannelFlow {
  constructor(context, capacity, onBufferOverflow) {
    this.j27_1 = context;
    this.k27_1 = capacity;
    this.l27_1 = onBufferOverflow;
    // Inline function 'kotlinx.coroutines.assert' call
  }
  m27() {
    return ChannelFlow$_get_collectToFun_$slambda_j53z2e(this);
  }
  n27() {
    return this.k27_1 === -3 ? -2 : this.k27_1;
  }
  c26(context, capacity, onBufferOverflow) {
    // Inline function 'kotlinx.coroutines.assert' call
    var newContext = context.ep(this.j27_1);
    var newCapacity;
    var newOverflow;
    if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
      newCapacity = capacity;
      newOverflow = onBufferOverflow;
    } else {
      var tmp;
      if (this.k27_1 === -3) {
        tmp = capacity;
      } else if (capacity === -3) {
        tmp = this.k27_1;
      } else if (this.k27_1 === -2) {
        tmp = capacity;
      } else if (capacity === -2) {
        tmp = this.k27_1;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        var sum = this.k27_1 + capacity | 0;
        tmp = sum >= 0 ? sum : 2147483647;
      }
      newCapacity = tmp;
      newOverflow = this.l27_1;
    }
    if (equals(newContext, this.j27_1) && newCapacity === this.k27_1 && newOverflow.equals(this.l27_1))
      return this;
    return this.c27(newContext, newCapacity, newOverflow);
  }
  o27(scope) {
    return produce_0(scope, this.j27_1, this.n27(), this.l27_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.m27());
  }
  *j24(collector, $completion) {
    return yield* coroutineScope(ChannelFlow$collect$slambda(collector, this), $completion);
  }
  p27() {
    return null;
  }
  toString() {
    var props = ArrayList.n2(4);
    var tmp0_safe_receiver = this.p27();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      props.d2(tmp0_safe_receiver);
    }
    if (!(this.j27_1 === EmptyCoroutineContext_getInstance())) {
      props.d2('context=' + toString(this.j27_1));
    }
    if (!(this.k27_1 === -3)) {
      props.d2('capacity=' + this.k27_1);
    }
    if (!this.l27_1.equals(BufferOverflow_SUSPEND_getInstance())) {
      props.d2('onBufferOverflow=' + this.l27_1.toString());
    }
    return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
  }
}
class ChannelFlowOperator extends ChannelFlow {
  constructor(flow, context, capacity, onBufferOverflow) {
    super(context, capacity, onBufferOverflow);
    this.g27_1 = flow;
  }
  *i27(scope, $completion) {
    return yield* this.h27(new SendingCollector(scope), $completion);
  }
  *j24(collector, $completion) {
    if (this.k27_1 === -3) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      var collectContext = $completion.od();
      var newContext = newCoroutineContext_0(collectContext, this.j27_1);
      if (equals(newContext, collectContext))
        return yield* this.h27(collector, $completion);
      if (equals(newContext.ae(Key_instance), collectContext.ae(Key_instance)))
        return yield* /*#__NOINLINE__*/collectWithContextUndispatched(this, collector, newContext, $completion);
    }
    yield* protoOf(ChannelFlow).j24.call(this, collector, $completion);
    return Unit_instance;
  }
  toString() {
    return toString(this.g27_1) + ' -> ' + super.toString();
  }
}
class ChannelFlowOperatorImpl extends ChannelFlowOperator {
  constructor(flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    super(flow, context, capacity, onBufferOverflow);
  }
  c27(context, capacity, onBufferOverflow) {
    return new ChannelFlowOperatorImpl(this.g27_1, context, capacity, onBufferOverflow);
  }
  *h27(collector, $completion) {
    return yield* this.g27_1.j24(collector, $completion);
  }
}
class UndispatchedContextCollector {
  constructor(downstream, emitContext) {
    this.q27_1 = emitContext;
    this.r27_1 = threadContextElements(this.q27_1);
    var tmp = this;
    tmp.s27_1 = UndispatchedContextCollector$emitRef$slambda(downstream);
  }
  *k24(value, $completion) {
    return yield* /*#__NOINLINE__*/withContextUndispatched(this.q27_1, value, this.r27_1, this.s27_1, $completion);
  }
}
class StackFrameContinuation {
  constructor(uCont, context) {
    this.t27_1 = uCont;
    this.u27_1 = context;
  }
  od() {
    return this.u27_1;
  }
  qd(result) {
    this.t27_1.qd(result);
  }
}
class sam$kotlinx_coroutines_flow_FlowCollector$0 {
  constructor(function_0) {
    this.v27_1 = function_0;
  }
  *k24(value, $completion) {
    return yield* this.v27_1(value, $completion);
  }
  p5() {
    return this.v27_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class FlowCoroutine extends ScopeCoroutine {
  r1n(cause) {
    if (cause instanceof ChildCancelledException)
      return true;
    return this.t1n(cause);
  }
}
class sam$kotlinx_coroutines_flow_FlowCollector$0_0 {
  constructor(function_0) {
    this.i28_1 = function_0;
  }
  *k24(value, $completion) {
    return yield* this.i28_1(value, $completion);
  }
  p5() {
    return this.i28_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class ChannelFlowTransformLatest extends ChannelFlowOperator {
  constructor(transform, flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    super(flow, context, capacity, onBufferOverflow);
    this.n28_1 = transform;
  }
  c27(context, capacity, onBufferOverflow) {
    return new ChannelFlowTransformLatest(this.n28_1, this.g27_1, context, capacity, onBufferOverflow);
  }
  *u28(collector, $completion) {
    // Inline function 'kotlinx.coroutines.assert' call
    yield* coroutineScope(ChannelFlowTransformLatest$flowCollect$slambda(this, collector), $completion);
    return Unit_instance;
  }
  h27(collector, $completion) {
    return this.u28(collector, $completion);
  }
}
class NopCollector {
  *v28(value, $completion) {
    return Unit_instance;
  }
  k24(value, $completion) {
    return this.v28(value, $completion);
  }
}
class SendingCollector {
  constructor(channel) {
    this.w28_1 = channel;
  }
  *k24(value, $completion) {
    return yield* this.w28_1.j22(value, $completion);
  }
}
class ThrowingCollector {}
class SubscribedFlowCollector {
  *w25($completion) {
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.od();
    var safeCollector = new SafeCollector(this.u25_1, tmp$ret$0);
    try {
      yield* this.v25_1(safeCollector, $completion);
    }finally {
      safeCollector.yd();
    }
    var tmp = this.u25_1;
    if (tmp instanceof SubscribedFlowCollector)
      yield* this.u25_1.w25($completion);
    return Unit_instance;
  }
}
class combine$$inlined$unsafeFlow$1 {
  constructor($this_combine, $flow, $transform) {
    this.y28_1 = $this_combine;
    this.z28_1 = $flow;
    this.a29_1 = $transform;
  }
  *b29(collector, $completion) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [this.y28_1, this.z28_1];
    var tmp_0 = nullArrayFactory();
    yield* combineInternal(collector, tmp, tmp_0, combine$o$collect$slambda(this.a29_1), $completion);
    return Unit_instance;
  }
  j24(collector, $completion) {
    return this.b29(collector, $completion);
  }
}
class first$$inlined$collectWhile$1 {
  constructor($predicate, $result) {
    this.c29_1 = $predicate;
    this.d29_1 = $result;
  }
  *v28(value, $completion) {
    var tmp;
    if (yield* this.c29_1(value, $completion)) {
      this.d29_1._v = value;
      tmp = false;
    } else {
      tmp = true;
    }
    if (!tmp) {
      throw AbortFlowException.e29(this);
    }
    return Unit_instance;
  }
  k24(value, $completion) {
    return this.v28(value, $completion);
  }
}
class first$$inlined$collectWhile$2 {
  constructor($result) {
    this.f29_1 = $result;
  }
  *v28(value, $completion) {
    this.f29_1._v = value;
    if (!false) {
      throw AbortFlowException.e29(this);
    }
    return Unit_instance;
  }
  k24(value, $completion) {
    return this.v28(value, $completion);
  }
}
class SegmentOrClosed {
  constructor(value) {
    this.i22_1 = value;
  }
  toString() {
    return SegmentOrClosed__toString_impl_pzb2an(this.i22_1);
  }
  hashCode() {
    return SegmentOrClosed__hashCode_impl_4855hs(this.i22_1);
  }
  equals(other) {
    return SegmentOrClosed__equals_impl_6erq1g(this.i22_1, other);
  }
}
class ExceptionSuccessfullyProcessed extends Exception {}
class DispatchedContinuation extends DispatchedTask {
  constructor(dispatcher, continuation) {
    super(-1);
    this.e1r_1 = dispatcher;
    this.f1r_1 = continuation;
    this.g1r_1 = get_UNDEFINED();
    this.h1r_1 = threadContextElements(this.od());
    this.i1r_1 = atomic$ref$1(null);
  }
  m1r() {
    return !(this.i1r_1.kotlinx$atomicfu$value == null);
  }
  l29() {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.i1r_1;
    while (true) {
      if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
        return Unit_instance;
    }
  }
  u1t() {
    this.l29();
    var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.h1s();
    }
  }
  j1r() {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.i1r_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state === null) {
        this.i1r_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
        return null;
      } else {
        if (state instanceof CancellableContinuationImpl) {
          if (this.i1r_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
            return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          }
        } else {
          if (state !== get_REUSABLE_CLAIMED()) {
            if (!(state instanceof Error)) {
              // Inline function 'kotlin.error' call
              var message = 'Inconsistent state ' + toString_0(state);
              throw IllegalStateException.o(toString(message));
            }
          }
        }
      }
    }
  }
  r1s(continuation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.i1r_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state === get_REUSABLE_CLAIMED()) {
        if (this.i1r_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
          return null;
      } else {
        if (state instanceof Error) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.require' call
          if (!this.i1r_1.atomicfu$compareAndSet(state, null)) {
            var message = 'Failed requirement.';
            throw IllegalArgumentException.h2(toString(message));
          }
          return state;
        } else {
          // Inline function 'kotlin.error' call
          var message_0 = 'Inconsistent state ' + toString_0(state);
          throw IllegalStateException.o(toString(message_0));
        }
      }
    }
  }
  o1r(cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.i1r_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (equals(state, get_REUSABLE_CLAIMED())) {
        if (this.i1r_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
          return true;
      } else {
        if (state instanceof Error)
          return true;
        else {
          if (this.i1r_1.atomicfu$compareAndSet(state, null))
            return false;
        }
      }
    }
  }
  j1s() {
    var state = this.g1r_1;
    // Inline function 'kotlinx.coroutines.assert' call
    this.g1r_1 = get_UNDEFINED();
    return state;
  }
  i1s() {
    return this;
  }
  qd(result) {
    var state = toState_0(result);
    if (safeIsDispatchNeeded(this.e1r_1, this.od())) {
      this.g1r_1 = state;
      this.n1r_1 = 0;
      safeDispatch(this.e1r_1, this.od(), this);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().y1u();
        if (false && eventLoop.t1u()) {
          break $l$block;
        }
        var tmp;
        if (eventLoop.s1u()) {
          this.g1r_1 = state;
          this.n1r_1 = 0;
          eventLoop.r1u(this);
          tmp = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.u1u(true);
          try {
            this.od();
            // Inline function 'kotlinx.coroutines.withCoroutineContext' call
            this.h1r_1;
            this.f1r_1.qd(result);
            $l$loop: while (eventLoop.q1u()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              this.d1t(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.v1u(true);
          }
          tmp = false;
        }
      }
    }
  }
  j1z(context, value) {
    this.g1r_1 = value;
    this.n1r_1 = 1;
    this.e1r_1.t1t(context, this);
  }
  toString() {
    return 'DispatchedContinuation[' + this.e1r_1.toString() + ', ' + toDebugString(this.f1r_1) + ']';
  }
  od() {
    return this.f1r_1.od();
  }
}
class DispatchException extends Exception {
  constructor(cause, dispatcher, context) {
    return new.target.m29(cause, dispatcher, context);
  }
  static m29(cause, dispatcher, context) {
    var $this = this.ue('Coroutine dispatcher ' + dispatcher.toString() + ' threw an exception, context = ' + toString(context), cause);
    captureStack($this, $this.x1t_1);
    $this.w1t_1 = cause;
    delete $this.cause;
    return $this;
  }
  s() {
    return this.w1t_1;
  }
  get cause() {
    return this.s();
  }
}
class UndeliveredElementException extends RuntimeException {
  constructor(message, cause) {
    return new.target.q29(message, cause);
  }
  static q29(message, cause) {
    var $this = this.qe(message, cause);
    captureStack($this, $this.p29_1);
    return $this;
  }
}
class ContextScope {
  constructor(context) {
    this.r29_1 = context;
  }
  d1m() {
    return this.r29_1;
  }
  toString() {
    return 'CoroutineScope(coroutineContext=' + toString(this.r29_1) + ')';
  }
}
class Symbol {
  constructor(symbol) {
    this.s29_1 = symbol;
  }
  toString() {
    return '<' + this.s29_1 + '>';
  }
}
class SelectInstance {}
class ClauseData {
  x29(select, internalResult) {
    var tmp0_safe_receiver = this.w29_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(select, this.v29_1, internalResult);
  }
}
class SelectImplementation {
  w21(clauseObject, result) {
    return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
  }
}
class TrySelectDetailedResult extends Enum {}
class CancellableContinuationWithOwner {
  constructor($outer, cont, owner) {
    this.j2a_1 = $outer;
    this.h2a_1 = cont;
    this.i2a_1 = owner;
  }
  u2a(value, idempotent, onCancellation) {
    // Inline function 'kotlinx.coroutines.assert' call
    var token = this.h2a_1.w1q(value, idempotent, MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this.j2a_1, this));
    if (!(token == null)) {
      // Inline function 'kotlinx.coroutines.assert' call
      this.j2a_1.f2a_1.kotlinx$atomicfu$value = this.i2a_1;
    }
    return token;
  }
  w1q(value, idempotent, onCancellation) {
    return this.u2a(value instanceof Unit ? value : THROW_CCE(), idempotent, onCancellation);
  }
  v2a(value, onCancellation) {
    // Inline function 'kotlinx.coroutines.assert' call
    this.j2a_1.f2a_1.kotlinx$atomicfu$value = this.i2a_1;
    this.h2a_1.t1s(Unit_instance, MutexImpl$CancellableContinuationWithOwner$resume$lambda(this.j2a_1, this));
  }
  a1r(value, onCancellation) {
    return this.v2a(value instanceof Unit ? value : THROW_CCE(), onCancellation);
  }
  z1m() {
    return this.h2a_1.z1m();
  }
  a1n() {
    return this.h2a_1.a1n();
  }
  a1p(exception) {
    return this.h2a_1.a1p(exception);
  }
  b1p(token) {
    this.h2a_1.b1p(token);
  }
  x1q(cause) {
    return this.h2a_1.x1q(cause);
  }
  y1q(handler) {
    this.h2a_1.y1q(handler);
  }
  v1s(segment, index) {
    this.h2a_1.v1s(segment, index);
  }
  w2a(_this__u8e3s4, value) {
    this.h2a_1.z1q(_this__u8e3s4, Unit_instance);
  }
  z1q(_this__u8e3s4, value) {
    return this.w2a(_this__u8e3s4, value instanceof Unit ? value : THROW_CCE());
  }
  cn(result) {
    this.h2a_1.qd(result);
  }
  qd(result) {
    return this.cn(result);
  }
  od() {
    return this.h2a_1.od();
  }
}
class SemaphoreAndMutexImpl {
  constructor(permits, acquiredPermits) {
    this.m2a_1 = permits;
    this.o2a_1 = atomic$long$1(new Long(0, 0));
    this.q2a_1 = atomic$long$1(new Long(0, 0));
    // Inline function 'kotlin.require' call
    if (!(this.m2a_1 > 0)) {
      var message = 'Semaphore should have at least 1 permit, but had ' + this.m2a_1;
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(0 <= acquiredPermits ? acquiredPermits <= this.m2a_1 : false)) {
      var message_0 = 'The number of acquired permits should be in 0..' + this.m2a_1;
      throw IllegalArgumentException.h2(toString(message_0));
    }
    var s = new SemaphoreSegment(new Long(0, 0), null, 2);
    this.n2a_1 = atomic$ref$1(s);
    this.p2a_1 = atomic$ref$1(s);
    this.r2a_1 = atomic$int$1(this.m2a_1 - acquiredPermits | 0);
    var tmp = this;
    tmp.s2a_1 = SemaphoreAndMutexImpl$onCancellationRelease$lambda(this);
  }
  x2a() {
    // Inline function 'kotlin.math.max' call
    var a = this.r2a_1.kotlinx$atomicfu$value;
    return Math.max(a, 0);
  }
  t2a() {
    $l$loop: while (true) {
      var p = this.r2a_1.kotlinx$atomicfu$value;
      if (p > this.m2a_1) {
        coerceAvailablePermitsAtMaximum(this);
        continue $l$loop;
      }
      if (p <= 0)
        return false;
      if (this.r2a_1.atomicfu$compareAndSet(p, p - 1 | 0))
        return true;
    }
  }
  acquireCont(waiter) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire' call
      while (true) {
        var p = decPermits(this);
        if (p > 0) {
          waiter.a1r(Unit_instance, this.s2a_1);
          tmp$ret$0 = Unit_instance;
          break $l$block_0;
        }
        if (addAcquireToQueue(this, isInterface(waiter, Waiter) ? waiter : THROW_CCE())) {
          tmp$ret$0 = Unit_instance;
          break $l$block_0;
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  }
  a2b() {
    while (true) {
      var p = this.r2a_1.atomicfu$getAndIncrement();
      if (p >= this.m2a_1) {
        coerceAvailablePermitsAtMaximum(this);
        // Inline function 'kotlin.error' call
        var message = 'The number of released permits cannot be greater than ' + this.m2a_1;
        throw IllegalStateException.o(toString(message));
      }
      if (p >= 0)
        return Unit_instance;
      if (tryResumeNextFromQueue(this))
        return Unit_instance;
    }
  }
}
class MutexImpl extends SemaphoreAndMutexImpl {
  constructor(locked) {
    super(1, locked ? 1 : 0);
    this.f2a_1 = atomic$ref$1(locked ? null : get_NO_OWNER());
    var tmp = this;
    tmp.g2a_1 = MutexImpl$onSelectCancellationUnlockConstructor$lambda(this);
  }
  l2a() {
    return this.x2a() === 0;
  }
  *y2a(owner, $completion) {
    if (this.z2a(owner))
      return Unit_instance;
    yield* /*#__NOINLINE__*/lockSuspend(this, owner, $completion);
    return Unit_instance;
  }
  z2a(owner) {
    var tmp;
    switch (tryLockImpl(this, owner)) {
      case 0:
        tmp = true;
        break;
      case 1:
        tmp = false;
        break;
      case 2:
        // Inline function 'kotlin.error' call

        var message = 'This mutex is already locked by the specified owner: ' + toString_0(owner);
        throw IllegalStateException.o(toString(message));
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'unexpected';
        throw IllegalStateException.o(toString(message_0));
    }
    return tmp;
  }
  k2a(owner) {
    $l$loop_0: while (true) {
      // Inline function 'kotlin.check' call
      if (!this.l2a()) {
        var message = 'This mutex is not locked';
        throw IllegalStateException.o(toString(message));
      }
      var curOwner = this.f2a_1.kotlinx$atomicfu$value;
      if (curOwner === get_NO_OWNER())
        continue $l$loop_0;
      // Inline function 'kotlin.check' call
      if (!(curOwner === owner || owner == null)) {
        var message_0 = 'This mutex is locked by ' + toString_0(curOwner) + ', but ' + toString_0(owner) + ' is expected';
        throw IllegalStateException.o(toString(message_0));
      }
      if (!this.f2a_1.atomicfu$compareAndSet(curOwner, get_NO_OWNER()))
        continue $l$loop_0;
      this.a2b();
      return Unit_instance;
    }
  }
  toString() {
    return 'Mutex@' + get_hexAddress(this) + '[isLocked=' + this.l2a() + ',owner=' + toString_0(this.f2a_1.kotlinx$atomicfu$value) + ']';
  }
}
class SemaphoreSegment extends Segment {
  constructor(id, prev, pointers) {
    super(id, prev, pointers);
    this.f2b_1 = atomicfu$AtomicRefArray$ofNulls(get_SEGMENT_SIZE_0());
  }
  r1z() {
    return get_SEGMENT_SIZE_0();
  }
  t1r(index, cause, context) {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.set' call
    var value = get_CANCELLED();
    this.f2b_1.atomicfu$get(index).kotlinx$atomicfu$value = value;
    this.o20();
  }
  toString() {
    return 'SemaphoreSegment[id=' + this.r1r_1.toString() + ', hashCode=' + hashCode(this) + ']';
  }
}
class SetTimeoutBasedDispatcher extends CoroutineDispatcher {
  static l2b() {
    var $this = this.q1t();
    $this.k2b_1 = new ScheduledMessageQueue($this);
    return $this;
  }
  s1t(context, block) {
    this.k2b_1.z2b(block);
  }
  j1u(timeMillis, block, context) {
    var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
    return new ClearTimeout(handle);
  }
  i1u(timeMillis, continuation) {
    var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    invokeOnCancellation(continuation, new ClearTimeout(handle));
  }
}
class NodeDispatcher extends SetTimeoutBasedDispatcher {
  constructor() {
    return new.target.i2b();
  }
  static i2b() {
    NodeDispatcher_instance = null;
    var $this = this.l2b();
    NodeDispatcher_instance = $this;
    return $this;
  }
  m2b() {
    process.nextTick(this.k2b_1.r2b_1);
  }
}
class MessageQueue {
  constructor() {
    this.s2b_1 = ArrayDeque.ul();
    this.t2b_1 = 16;
    this.u2b_1 = false;
  }
  z2b(element) {
    this.a2c(element);
    if (!this.u2b_1) {
      this.u2b_1 = true;
      this.w2b();
    }
  }
  v2b() {
    try {
      // Inline function 'kotlin.repeat' call
      var times = this.t2b_1;
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs = removeFirstOrNull(this);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var element = tmp;
          element.c1t();
        }
         while (inductionVariable < times);
    }finally {
      if (this.n1()) {
        this.u2b_1 = false;
      } else {
        this.x2b();
      }
    }
  }
  a2c(element) {
    return this.s2b_1.d2(element);
  }
  d2(element) {
    return this.a2c((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  b2c(index, element) {
    this.s2b_1.f5(index, element);
  }
  f5(index, element) {
    return this.b2c(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  c2c(element) {
    return this.s2b_1.z4(element);
  }
  z4(element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.c2c((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  d2c(elements) {
    return this.s2b_1.t2(elements);
  }
  t2(elements) {
    return this.d2c(elements);
  }
  a5() {
    this.s2b_1.a5();
  }
  e2c(index, element) {
    return this.s2b_1.e5(index, element);
  }
  e5(index, element) {
    return this.e2c(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  g5(index) {
    return this.s2b_1.g5(index);
  }
  s4() {
    return this.s2b_1.s4();
  }
  x2(index) {
    return this.s2b_1.x2(index);
  }
  t4(fromIndex, toIndex) {
    return this.s2b_1.t4(fromIndex, toIndex);
  }
  n1() {
    return this.s2b_1.n1();
  }
  f2c(element) {
    return this.s2b_1.w2(element);
  }
  w2(element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.f2c((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  p1() {
    return this.s2b_1.p1();
  }
  g2c(elements) {
    return this.s2b_1.r4(elements);
  }
  r4(elements) {
    return this.g2c(elements);
  }
  u2(index) {
    return this.s2b_1.u2(index);
  }
  h2c(element) {
    return this.s2b_1.y2(element);
  }
  y2(element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return -1;
    return this.h2c((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  }
  s2() {
    return this.s2b_1.rl_1;
  }
}
class ScheduledMessageQueue extends MessageQueue {
  constructor(dispatcher) {
    super();
    this.q2b_1 = dispatcher;
    var tmp = this;
    tmp.r2b_1 = ScheduledMessageQueue$processQueue$lambda(this);
  }
  w2b() {
    this.q2b_1.m2b();
  }
  x2b() {
    setTimeout(this.r2b_1, 0);
  }
  y2b(timeout) {
    setTimeout(this.r2b_1, timeout);
  }
}
class WindowMessageQueue extends MessageQueue {
  constructor(window_0) {
    super();
    this.l2c_1 = window_0;
    this.m2c_1 = 'dispatchCoroutine';
    this.l2c_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
  }
  w2b() {
    var tmp = Promise.resolve(Unit_instance);
    tmp.then(WindowMessageQueue$schedule$lambda(this));
  }
  x2b() {
    this.l2c_1.postMessage(this.m2c_1, '*');
  }
}
class UnconfinedEventLoop extends EventLoop {
  constructor() {
    return new.target.v2c();
  }
  static v2c() {
    return this.p1u();
  }
  s1t(context, block) {
    unsupported();
  }
}
class SetTimeoutDispatcher extends SetTimeoutBasedDispatcher {
  constructor() {
    return new.target.y2c();
  }
  static y2c() {
    SetTimeoutDispatcher_instance = null;
    var $this = this.l2b();
    SetTimeoutDispatcher_instance = $this;
    return $this;
  }
  m2b() {
    this.k2b_1.y2b(0);
  }
}
class ClearTimeout {
  constructor(handle, $box) {
    boxApply(this, $box);
    this.b2d_1 = handle;
  }
  u1o() {
    w3cClearTimeout_0(this.b2d_1);
  }
  v1o(cause) {
    this.u1o();
  }
  toString() {
    return 'ClearTimeout[' + this.b2d_1 + ']';
  }
}
class WindowClearTimeout extends ClearTimeout {
  constructor($outer, handle, $box) {
    if ($box === VOID)
      $box = {};
    $box.a2d_1 = $outer;
    super(handle, $box);
  }
  u1o() {
    w3cClearTimeout(this.a2d_1.o2c_1, this.b2d_1);
  }
}
class WindowDispatcher extends CoroutineDispatcher {
  constructor(window_0) {
    return new.target.q2c(window_0);
  }
  static q2c(window_0) {
    var $this = this.q1t();
    $this.o2c_1 = window_0;
    $this.p2c_1 = new WindowMessageQueue($this.o2c_1);
    return $this;
  }
  s1t(context, block) {
    return this.p2c_1.z2b(block);
  }
  i1u(timeMillis, continuation) {
    var handle = w3cSetTimeout_0(this.o2c_1, WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    invokeOnCancellation(continuation, new WindowClearTimeout(this, handle));
  }
  j1u(timeMillis, block, context) {
    var handle = w3cSetTimeout_0(this.o2c_1, Runnable$run$ref(block), delayToInt(timeMillis));
    return new WindowClearTimeout(this, handle);
  }
}
class UndispatchedCoroutine extends ScopeCoroutine {
  n1m(state) {
    return this.u1q_1.qd(recoverResult(state, this.u1q_1));
  }
}
class Dispatchers {
  constructor() {
    Dispatchers_instance = this;
    this.c1u_1 = createDefaultDispatcher();
    this.d1u_1 = Unconfined_getInstance();
    this.e1u_1 = JsMainDispatcher.k2d(this.c1u_1, false);
    this.f1u_1 = null;
  }
  g1u() {
    var tmp0_elvis_lhs = this.f1u_1;
    return tmp0_elvis_lhs == null ? this.e1u_1 : tmp0_elvis_lhs;
  }
}
class JsMainDispatcher extends MainCoroutineDispatcher {
  constructor(delegate, invokeImmediately) {
    return new.target.k2d(delegate, invokeImmediately);
  }
  static k2d(delegate, invokeImmediately) {
    var $this = this.e1y();
    $this.h2d_1 = delegate;
    $this.i2d_1 = invokeImmediately;
    $this.j2d_1 = $this.i2d_1 ? $this : JsMainDispatcher.k2d($this.h2d_1, true);
    return $this;
  }
  f1y() {
    return this.j2d_1;
  }
  r1t(context) {
    return !this.i2d_1;
  }
  s1t(context, block) {
    return this.h2d_1.s1t(context, block);
  }
  t1t(context, block) {
    return this.h2d_1.t1t(context, block);
  }
  toString() {
    var tmp0_elvis_lhs = this.g1y();
    return tmp0_elvis_lhs == null ? this.h2d_1.toString() : tmp0_elvis_lhs;
  }
}
class JobCancellationException extends CancellationException {
  constructor(message, cause, job) {
    return new.target.x1v(message, cause, job);
  }
  static x1v(message, cause, job) {
    var $this = this.p(message, cause);
    captureStack($this, $this.w1v_1);
    $this.v1v_1 = job;
    return $this;
  }
  toString() {
    return super.toString() + '; job=' + toString(this.v1v_1);
  }
  equals(other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(other.v1v_1, this.v1v_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(other.cause, this.cause);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.v1v_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
}
class AbortFlowException extends CancellationException {
  constructor(owner) {
    return new.target.e29(owner);
  }
  static e29(owner) {
    var $this = this.n('Flow was aborted, no more elements needed');
    captureStack($this, $this.h28_1);
    $this.g28_1 = owner;
    return $this;
  }
}
class ChildCancelledException extends CancellationException {
  constructor() {
    return new.target.t28();
  }
  static t28() {
    var $this = this.n('Child of the scoped flow was cancelled');
    captureStack($this, $this.s28_1);
    return $this;
  }
}
class SafeCollector {
  constructor(collector, collectContext) {
    this.l24_1 = collector;
    this.m24_1 = collectContext;
    var tmp = this;
    tmp.n24_1 = this.m24_1.dp(0, SafeCollector$collectContextSize$lambda);
    this.o24_1 = null;
  }
  *k24(value, $completion) {
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var currentContext = $completion.od();
    ensureActive_0(currentContext);
    if (!(this.o24_1 === currentContext)) {
      checkContext(this, currentContext);
      this.o24_1 = currentContext;
    }
    yield* this.l24_1.k24(value, $completion);
    return Unit_instance;
  }
  yd() {
  }
}
class WorkaroundAtomicReference {
  constructor(value) {
    this.i26_1 = value;
  }
  a1v() {
    return this.i26_1;
  }
  g29(value) {
    this.i26_1 = value;
  }
  k26(value) {
    var prev = this.i26_1;
    this.i26_1 = value;
    return prev;
  }
  j26(expected, value) {
    if (this.i26_1 === expected) {
      this.i26_1 = value;
      return true;
    }
    return false;
  }
}
class DiagnosticCoroutineContextException extends RuntimeException {
  constructor(context) {
    return new.target.k29(context);
  }
  static k29(context) {
    var $this = this.xb(toString(context));
    captureStack($this, $this.j29_1);
    return $this;
  }
}
class ListClosed extends LockFreeLinkedListNode {
  constructor(forbiddenElementsBitmask) {
    super();
    this.o2d_1 = forbiddenElementsBitmask;
  }
}
class LocalAtomicInt {
  constructor(value) {
    this.w27_1 = value;
  }
  x27() {
    this.w27_1 = this.w27_1 - 1 | 0;
    return this.w27_1;
  }
}
class CommonThreadLocal {
  constructor() {
    this.z1u_1 = null;
  }
  a1v() {
    return this.z1u_1;
  }
  b1v(value) {
    this.z1u_1 = value;
  }
}
//endregion
function *awaitAll(_this__u8e3s4, $completion) {
  var tmp;
  if (_this__u8e3s4.n1()) {
    tmp = emptyList();
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(_this__u8e3s4);
    tmp = yield* (new AwaitAll(tmp$ret$0)).h1o($completion);
  }
  return tmp;
}
function launch(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.w1p() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
  coroutine.r1m(start, coroutine, block);
  return coroutine;
}
function async(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.w1p() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
  coroutine.r1m(start, coroutine, block);
  return coroutine;
}
function *withContext(context, block, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var tmp0 = $completion;
    var tmp$ret$1;
    $l$block_0: {
      var oldContext = tmp0.od();
      var newContext = newCoroutineContext_0(oldContext, context);
      ensureActive_0(newContext);
      if (newContext === oldContext) {
        var coroutine = new ScopeCoroutine(newContext, tmp0);
        tmp$ret$1 = startUndispatchedOrReturn(coroutine, coroutine, block);
        break $l$block_0;
      }
      if (equals(newContext.ae(Key_instance), oldContext.ae(Key_instance))) {
        var coroutine_0 = new UndispatchedCoroutine(newContext, tmp0);
        // Inline function 'kotlinx.coroutines.withCoroutineContext' call
        coroutine_0.c1m_1;
        tmp$ret$1 = startUndispatchedOrReturn(coroutine_0, coroutine_0, block);
        break $l$block_0;
      }
      var coroutine_1 = new DispatchedCoroutine(newContext, tmp0);
      startCoroutineCancellable_0(block, coroutine_1, coroutine_1);
      tmp$ret$1 = coroutine_1.v1p();
    }
    return tmp$ret$1;
  };
}
function trySuspend($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.b1q_1;
  while (true) {
    switch (this_0.kotlinx$atomicfu$value) {
      case 0:
        if ($this.b1q_1.atomicfu$compareAndSet(0, 1))
          return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException.o(toString(message));
    }
  }
}
function tryResume($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.b1q_1;
  while (true) {
    switch (this_0.kotlinx$atomicfu$value) {
      case 0:
        if ($this.b1q_1.atomicfu$compareAndSet(0, 2))
          return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException.o(toString(message));
    }
  }
}
function invokeOnCancellation(_this__u8e3s4, handler) {
  var tmp;
  if (_this__u8e3s4 instanceof CancellableContinuationImpl) {
    _this__u8e3s4.b1r(handler);
    tmp = Unit_instance;
  } else {
    throw UnsupportedOperationException.a1('third-party implementation of CancellableContinuation is not supported');
  }
  return tmp;
}
function disposeOnCancellation(_this__u8e3s4, handle) {
  return invokeOnCancellation(_this__u8e3s4, new DisposeOnCancel(handle));
}
function getOrCreateCancellableContinuation(delegate) {
  if (!(delegate instanceof DispatchedContinuation)) {
    return new CancellableContinuationImpl(delegate, 1);
  }
  var tmp0_safe_receiver = delegate.j1r();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver.k1r()) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return new CancellableContinuationImpl(delegate, 2);
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function get_RESUME_TOKEN() {
  _init_properties_CancellableContinuationImpl_kt__6rrtdd();
  return RESUME_TOKEN;
}
var RESUME_TOKEN;
function _get_parentHandle__f8dcex($this) {
  return $this.t1p_1.kotlinx$atomicfu$value;
}
function _get_stateDebugRepresentation__bf18u4($this) {
  var tmp0_subject = $this.y1m();
  var tmp;
  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
    tmp = 'Active';
  } else {
    if (tmp0_subject instanceof CancelledContinuation) {
      tmp = 'Cancelled';
    } else {
      tmp = 'Completed';
    }
  }
  return tmp;
}
function isReusable($this) {
  var tmp;
  if (get_isReusableMode($this.n1r_1)) {
    var tmp_0 = $this.p1p_1;
    tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).m1r();
  } else {
    tmp = false;
  }
  return tmp;
}
function cancelLater($this, cause) {
  if (!isReusable($this))
    return false;
  var tmp = $this.p1p_1;
  var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
  return dispatched.o1r(cause);
}
function callSegmentOnCancellation($this, segment, cause) {
  // Inline function 'kotlinx.coroutines.index' call
  var index = $this.r1p_1.kotlinx$atomicfu$value & 536870911;
  // Inline function 'kotlin.check' call
  if (!!(index === 536870911)) {
    var message = 'The index for Segment.onCancellation(..) is broken';
    throw IllegalStateException.o(toString(message));
  }
  // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
  try {
    segment.t1r(index, cause, $this.od());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException($this.od(), CompletionHandlerException.x1r('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
    } else {
      throw $p;
    }
  }
}
function trySuspend_0($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.r1p_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$4 = (1 << 29) + (cur & 536870911) | 0;
        if ($this.r1p_1.atomicfu$compareAndSet(cur, tmp$ret$4))
          return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException.o(toString(message));
    }
  }
}
function tryResume_0($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.r1p_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$4 = (2 << 29) + (cur & 536870911) | 0;
        if ($this.r1p_1.atomicfu$compareAndSet(cur, tmp$ret$4))
          return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException.o(toString(message));
    }
  }
}
function installParentHandle($this) {
  var tmp0_elvis_lhs = $this.od().ae(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parent = tmp;
  var handle = invokeOnCompletion(parent, VOID, new ChildContinuation($this));
  $this.t1p_1.atomicfu$compareAndSet(null, handle);
  return handle;
}
function invokeOnCancellationImpl($this, handler) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.s1p_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (state instanceof Active) {
      if ($this.s1p_1.atomicfu$compareAndSet(state, handler))
        return Unit_instance;
    } else {
      var tmp;
      if (!(state == null) ? isInterface(state, CancelHandler) : false) {
        tmp = true;
      } else {
        tmp = state instanceof Segment;
      }
      if (tmp) {
        multipleHandlersError($this, handler, state);
      } else {
        if (state instanceof CompletedExceptionally) {
          if (!state.g1s()) {
            multipleHandlersError($this, handler, state);
          }
          if (state instanceof CancelledContinuation) {
            var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
            var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j1m_1;
            if (isInterface(handler, CancelHandler)) {
              $this.d1s(handler, cause);
            } else {
              var segment = handler instanceof Segment ? handler : THROW_CCE();
              callSegmentOnCancellation($this, segment, cause);
            }
          }
          return Unit_instance;
        } else {
          if (state instanceof CompletedContinuation) {
            if (!(state.z1r_1 == null)) {
              multipleHandlersError($this, handler, state);
            }
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            if (state.e1s()) {
              $this.d1s(handler, state.c1s_1);
              return Unit_instance;
            }
            var update = state.f1s(VOID, handler);
            if ($this.s1p_1.atomicfu$compareAndSet(state, update))
              return Unit_instance;
          } else {
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            var update_0 = new CompletedContinuation(state, handler);
            if ($this.s1p_1.atomicfu$compareAndSet(state, update_0))
              return Unit_instance;
          }
        }
      }
    }
  }
}
function multipleHandlersError($this, handler, state) {
  // Inline function 'kotlin.error' call
  var message = "It's prohibited to register multiple handlers, tried to register " + toString(handler) + ', already has ' + toString_0(state);
  throw IllegalStateException.o(toString(message));
}
function dispatchResume($this, mode) {
  if (tryResume_0($this))
    return Unit_instance;
  dispatch($this, mode);
}
function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
  var tmp;
  if (proposedUpdate instanceof CompletedExceptionally) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    tmp = proposedUpdate;
  } else {
    if (!get_isCancellableMode(resumeMode) && idempotent == null) {
      tmp = proposedUpdate;
    } else {
      var tmp_0;
      var tmp_1;
      if (!(onCancellation == null)) {
        tmp_1 = true;
      } else {
        tmp_1 = isInterface(state, CancelHandler);
      }
      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = !(idempotent == null);
      }
      if (tmp_0) {
        tmp = new CompletedContinuation(proposedUpdate, isInterface(state, CancelHandler) ? state : null, onCancellation, idempotent);
      } else {
        tmp = proposedUpdate;
      }
    }
  }
  return tmp;
}
function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.s1p_1;
  while (true) {
    var tmp0 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
        var update = resumedState($this, tmp0, proposedUpdate, $this.n1r_1, onCancellation, idempotent);
        if (!$this.s1p_1.atomicfu$compareAndSet(tmp0, update)) {
          break $l$block;
        }
        detachChildIfNonReusable($this);
        return get_RESUME_TOKEN();
      } else {
        if (tmp0 instanceof CompletedContinuation) {
          var tmp;
          if (!(idempotent == null) && tmp0.b1s_1 === idempotent) {
            // Inline function 'kotlinx.coroutines.assert' call
            tmp = get_RESUME_TOKEN();
          } else {
            tmp = null;
          }
          return tmp;
        } else {
          return null;
        }
      }
    }
  }
}
function alreadyResumedError($this, proposedUpdate) {
  // Inline function 'kotlin.error' call
  var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
  throw IllegalStateException.o(toString(message));
}
function detachChildIfNonReusable($this) {
  if (!isReusable($this)) {
    $this.h1s();
  }
}
function CancellableContinuationImpl$resume$lambda($onCancellation) {
  return (cause, _unused_var__etf5q3, _unused_var__etf5q3_0) => {
    $onCancellation(cause);
    return Unit_instance;
  };
}
var Active_instance;
function Active_getInstance() {
  return Active_instance;
}
var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
  if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
    properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
    RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  }
}
function CompletableDeferred(parent) {
  parent = parent === VOID ? null : parent;
  return new CompletableDeferredImpl(parent);
}
function completeWith(_this__u8e3s4, result) {
  // Inline function 'kotlin.fold' call
  var exception = Result__exceptionOrNull_impl_p6xea9(result);
  var tmp;
  if (exception == null) {
    var it = _Result___get_value__impl__bjfvqg(result);
    tmp = _this__u8e3s4.l1t(it);
  } else {
    tmp = _this__u8e3s4.k1t(exception);
  }
  return tmp;
}
function CompletableDeferred_0(value) {
  // Inline function 'kotlin.apply' call
  var this_0 = new CompletableDeferredImpl(null);
  this_0.l1t(value);
  return this_0;
}
function recoverResult(state, uCont) {
  var tmp;
  if (state instanceof CompletedExceptionally) {
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(state.j1m_1, uCont);
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    tmp = _Result___init__impl__xyqfz8(state);
  }
  return tmp;
}
function toState(_this__u8e3s4, caller) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
  } else {
    tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
  }
  return tmp;
}
function toState_0(_this__u8e3s4) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
  } else {
    tmp = new CompletedExceptionally(exception);
  }
  return tmp;
}
function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
  return it instanceof CoroutineDispatcher ? it : null;
}
var Key_instance_0;
function Key_getInstance() {
  if (Key_instance_0 === VOID)
    new Key();
  return Key_instance_0;
}
var Key_instance_1;
function Key_getInstance_0() {
  return Key_instance_1;
}
function handleCoroutineException(context, exception) {
  var tmp;
  if (exception instanceof DispatchException) {
    tmp = exception.w1t_1;
  } else {
    tmp = exception;
  }
  var reportException = tmp;
  try {
    var tmp0_safe_receiver = context.ae(Key_instance_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.y1t(context, reportException);
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      handleUncaughtCoroutineException(context, handlerException(reportException, t));
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  handleUncaughtCoroutineException(context, reportException);
}
function handlerException(originalException, thrownException) {
  if (originalException === thrownException)
    return originalException;
  // Inline function 'kotlin.apply' call
  var this_0 = RuntimeException.qe('Exception while trying to handle coroutine exception', thrownException);
  addSuppressed(this_0, originalException);
  return this_0;
}
var Key_instance_2;
function Key_getInstance_1() {
  return Key_instance_2;
}
function *coroutineScope(block, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var coroutine = new ScopeCoroutine(uCont.od(), uCont);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  };
}
function cancel(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_elvis_lhs = _this__u8e3s4.d1m().ae(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Scope cannot be cancelled because it does not have a job: ' + toString(_this__u8e3s4);
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var job = tmp;
  job.n1n(cause);
}
function cancel_0(_this__u8e3s4, message, cause) {
  cause = cause === VOID ? null : cause;
  return cancel(_this__u8e3s4, CancellationException_0(message, cause));
}
var GlobalScope_instance;
function GlobalScope_getInstance() {
  return GlobalScope_instance;
}
function CoroutineScope(context) {
  return new ContextScope(!(context.ae(Key_instance_3) == null) ? context : context.ep(Job_0()));
}
function MainScope() {
  return new ContextScope(SupervisorJob().ep(Dispatchers_getInstance().g1u()));
}
function get_isActive(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.d1m().ae(Key_instance_3);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e1m();
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
}
function ensureActive(_this__u8e3s4) {
  return ensureActive_0(_this__u8e3s4.d1m());
}
var CoroutineStart_DEFAULT_instance;
var CoroutineStart_LAZY_instance;
var CoroutineStart_ATOMIC_instance;
var CoroutineStart_UNDISPATCHED_instance;
var CoroutineStart_entriesInitialized;
function CoroutineStart_initEntries() {
  if (CoroutineStart_entriesInitialized)
    return Unit_instance;
  CoroutineStart_entriesInitialized = true;
  CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
  CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
  CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
  CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
}
function CoroutineStart_DEFAULT_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_DEFAULT_instance;
}
function CoroutineStart_LAZY_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_LAZY_instance;
}
function CoroutineStart_ATOMIC_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_ATOMIC_instance;
}
function CoroutineStart_UNDISPATCHED_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_UNDISPATCHED_instance;
}
function *delay(timeMillis, $completion) {
  if (compare(timeMillis, new Long(0, 0)) <= 0)
    return Unit_instance;
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
    cancellable.u1p();
    if (compare(timeMillis, new Long(-1, 2147483647)) < 0) {
      get_delay(cancellable.od()).i1u(timeMillis, cancellable);
    }
    return cancellable.v1p();
  });
  return Unit_instance;
}
function *delay_0(duration, $completion) {
  return yield* /*#__NOINLINE__*/delay(toDelayMillis(duration), $completion);
}
function get_delay(_this__u8e3s4) {
  var tmp = _this__u8e3s4.ae(Key_instance);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
}
function toDelayMillis(_this__u8e3s4) {
  var tmp;
  switch (Duration__isPositive_impl_tvkkt2(_this__u8e3s4)) {
    case true:
      Companion_getInstance();
      // Inline function 'kotlin.time.Companion.nanoseconds' call

      var this_0 = new Long(999999, 0);
      var tmp$ret$0 = toDuration(this_0, DurationUnit_NANOSECONDS_getInstance());
      tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(Duration__plus_impl_yu9v8f(_this__u8e3s4, tmp$ret$0));
      break;
    case false:
      tmp = new Long(0, 0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function *awaitCancellation($completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
    cancellable.u1p();
    return cancellable.v1p();
  };
}
function delta($this, unconfined) {
  return unconfined ? new Long(0, 1) : new Long(1, 0);
}
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance === VOID)
    new ThreadLocalEventLoop();
  return ThreadLocalEventLoop_instance;
}
var Key_instance_3;
function Key_getInstance_2() {
  return Key_instance_3;
}
function get_job(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.ae(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = "Current context doesn't contain Job in it: " + toString(_this__u8e3s4);
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function *cancelAndJoin(_this__u8e3s4, $completion) {
  _this__u8e3s4.o1n();
  return yield* _this__u8e3s4.k1n($completion);
}
function Job_0(parent) {
  parent = parent === VOID ? null : parent;
  return new JobImpl(parent);
}
function cancel_1(_this__u8e3s4, message, cause) {
  cause = cause === VOID ? null : cause;
  return _this__u8e3s4.n1n(CancellationException_0(message, cause));
}
function cancel_2(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_safe_receiver = _this__u8e3s4.ae(Key_instance_3);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.n1n(cause);
  }
}
function cancelChildren(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_safe_receiver = _this__u8e3s4.ae(Key_instance_3);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1n();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s = tmp1_safe_receiver.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      element.n1n(cause);
    }
  }
}
function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  var tmp;
  if (_this__u8e3s4 instanceof JobSupport) {
    tmp = _this__u8e3s4.j1n(invokeImmediately, handler);
  } else {
    var tmp_0 = handler.y1o();
    tmp = _this__u8e3s4.h1n(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
  }
  return tmp;
}
function ensureActive_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.ae(Key_instance_3);
  if (tmp0_safe_receiver == null)
    null;
  else {
    ensureActive_1(tmp0_safe_receiver);
  }
}
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function ensureActive_1(_this__u8e3s4) {
  if (!_this__u8e3s4.e1m())
    throw _this__u8e3s4.d1n();
}
function disposeOnCompletion(_this__u8e3s4, handle) {
  return invokeOnCompletion(_this__u8e3s4, VOID, new DisposeOnCompletion(handle));
}
function cancelChildren_0(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  // Inline function 'kotlin.sequences.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.w1n().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.n1n(cause);
  }
}
function get_COMPLETING_ALREADY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_ALREADY;
}
var COMPLETING_ALREADY;
function get_COMPLETING_WAITING_CHILDREN() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_WAITING_CHILDREN;
}
var COMPLETING_WAITING_CHILDREN;
function get_COMPLETING_RETRY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_RETRY;
}
var COMPLETING_RETRY;
function get_TOO_LATE_TO_CANCEL() {
  _init_properties_JobSupport_kt__68f172();
  return TOO_LATE_TO_CANCEL;
}
var TOO_LATE_TO_CANCEL;
function get_SEALED() {
  _init_properties_JobSupport_kt__68f172();
  return SEALED;
}
var SEALED;
function get_EMPTY_NEW() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_NEW;
}
var EMPTY_NEW;
function get_EMPTY_ACTIVE() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_ACTIVE;
}
var EMPTY_ACTIVE;
function unboxState(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k1v_1;
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function _set_exceptionsHolder__tqm22h($this, value) {
  $this.o1v_1.kotlinx$atomicfu$value = value;
}
function _get_exceptionsHolder__nhszp($this) {
  return $this.o1v_1.kotlinx$atomicfu$value;
}
function allocateList($this) {
  return ArrayList.n2(4);
}
function finalizeFinishingState($this, state, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j1m_1;
  var wasCancelling;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  wasCancelling = state.p1v();
  var exceptions = state.q1v(proposedException);
  var finalCause = getFinalRootCause($this, state, exceptions);
  if (!(finalCause == null)) {
    addSuppressedExceptions($this, finalCause, exceptions);
  }
  var finalException = finalCause;
  var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
  if (!(finalException == null)) {
    var handled = cancelParent($this, finalException) || $this.b1o(finalException);
    if (handled) {
      (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).g1s();
    }
  }
  if (!wasCancelling) {
    $this.y1n(finalException);
  }
  $this.i1m(finalState);
  var casSuccess = $this.x1l_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
  // Inline function 'kotlinx.coroutines.assert' call
  completeStateFinalization($this, state, finalState);
  return finalState;
}
function getFinalRootCause($this, state, exceptions) {
  if (exceptions.n1()) {
    if (state.p1v()) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      return JobCancellationException.x1v(null == null ? $this.h1m() : null, null, $this);
    }
    return null;
  }
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = exceptions.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(element instanceof CancellationException)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var firstNonCancellation = tmp$ret$1;
  if (!(firstNonCancellation == null))
    return firstNonCancellation;
  var first = exceptions.u2(0);
  if (first instanceof TimeoutCancellationException) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = exceptions.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp;
        if (!(element_0 === first)) {
          tmp = element_0 instanceof TimeoutCancellationException;
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$3 = null;
    }
    var detailedTimeoutException = tmp$ret$3;
    if (!(detailedTimeoutException == null))
      return detailedTimeoutException;
  }
  return first;
}
function addSuppressedExceptions($this, rootCause, exceptions) {
  if (exceptions.s2() <= 1)
    return Unit_instance;
  var seenExceptions = identitySet(exceptions.s2());
  var unwrappedCause = unwrap(rootCause);
  var _iterator__ex2g4s = exceptions.p1();
  while (_iterator__ex2g4s.q1()) {
    var exception = _iterator__ex2g4s.r1();
    var unwrapped = unwrap(exception);
    var tmp;
    var tmp_0;
    if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
      tmp_0 = !(unwrapped instanceof CancellationException);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = seenExceptions.d2(unwrapped);
    } else {
      tmp = false;
    }
    if (tmp) {
      addSuppressed(rootCause, unwrapped);
    }
  }
}
function tryFinalizeSimpleState($this, state, update) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  if (!$this.x1l_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
    return false;
  $this.y1n(null);
  $this.i1m(update);
  completeStateFinalization($this, state, update);
  return true;
}
function completeStateFinalization($this, state, update) {
  var tmp0_safe_receiver = $this.w1m();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.u1o();
    $this.v1m(NonDisposableHandle_instance);
  }
  var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
  var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j1m_1;
  if (state instanceof JobNode) {
    try {
      state.v1o(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        $this.p1m(CompletionHandlerException.x1r('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  } else {
    var tmp2_safe_receiver = state.h1p();
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCompletion($this, tmp2_safe_receiver, cause);
    }
  }
}
function notifyCancelling($this, list, cause) {
  $this.y1n(cause);
  list.y1v(4);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = list.i1p_1;
  while (!equals(cur, list)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      tmp = node.y1o();
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.v1o(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = CompletionHandlerException.x1r('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.i1p_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.p1m(tmp0_safe_receiver_0);
  }
  cancelParent($this, cause);
}
function cancelParent($this, cause) {
  if ($this.z1n())
    return true;
  var isCancellation = cause instanceof CancellationException;
  var parent = $this.w1m();
  if (parent === null || parent === NonDisposableHandle_instance) {
    return isCancellation;
  }
  return parent.r1n(cause) || isCancellation;
}
function notifyCompletion($this, $receiver, cause) {
  $receiver.y1v(1);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = $receiver.i1p_1;
  while (!equals(cur, $receiver)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      tmp = true;
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.v1o(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = CompletionHandlerException.x1r('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.i1p_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.p1m(tmp0_safe_receiver_0);
  }
}
function startInternal($this, state) {
  if (state instanceof Empty) {
    if (state.a1w_1)
      return 0;
    if (!$this.x1l_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
      return -1;
    $this.c1n();
    return 1;
  } else {
    if (state instanceof InactiveNodeList) {
      if (!$this.x1l_1.atomicfu$compareAndSet(state, state.z1v_1))
        return -1;
      $this.c1n();
      return 1;
    } else {
      return 0;
    }
  }
}
function promoteEmptyToNodeList($this, state) {
  var list = new NodeList();
  var update = state.a1w_1 ? list : new InactiveNodeList(list);
  $this.x1l_1.atomicfu$compareAndSet(state, update);
}
function promoteSingleToNodeList($this, state) {
  state.n1p(new NodeList());
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
  var list = state.i1p_1;
  $this.x1l_1.atomicfu$compareAndSet(state, list);
}
function joinInternal($this) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.y1m();
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return false;
    if (startInternal($this, state) >= 0)
      return true;
  }
}
function *joinSuspend($this, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
    cancellable.u1p();
    disposeOnCancellation(cancellable, invokeOnCompletion($this, VOID, new ResumeOnCompletion(cancellable)));
    return cancellable.v1p();
  });
  return Unit_instance;
}
function cancelMakeCompleting($this, cause) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.y1m();
    var tmp;
    if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.b1w();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      return get_COMPLETING_ALREADY();
    }
    var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
    var finalState = tryMakeCompleting($this, state, proposedUpdate);
    if (!(finalState === get_COMPLETING_RETRY()))
      return finalState;
  }
}
function createCauseException($this, cause) {
  var tmp;
  if (cause == null ? true : cause instanceof Error) {
    var tmp_0;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp_0 = JobCancellationException.x1v(null == null ? $this.h1m() : null, null, $this);
    } else {
      tmp_0 = cause;
    }
    tmp = tmp_0;
  } else {
    tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).u1n();
  }
  return tmp;
}
function makeCancelling($this, cause) {
  var causeExceptionCache = null;
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp0 = $this.y1m();
    $l$block: {
      if (tmp0 instanceof Finishing) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        if (tmp0.c1w())
          return get_TOO_LATE_TO_CANCEL();
        var wasCancelling = tmp0.p1v();
        if (!(cause == null) || !wasCancelling) {
          var tmp0_elvis_lhs = causeExceptionCache;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createCauseException($this, cause);
            causeExceptionCache = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var causeException = tmp;
          tmp0.d1w(causeException);
        }
        // Inline function 'kotlin.takeIf' call
        var this_1 = tmp0.e1w();
        var tmp_0;
        if (!wasCancelling) {
          tmp_0 = this_1;
        } else {
          tmp_0 = null;
        }
        var notifyRootCause = tmp_0;
        if (notifyRootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          notifyCancelling($this, tmp0.l1v_1, notifyRootCause);
        }
        return get_COMPLETING_ALREADY();
      } else {
        if (!(tmp0 == null) ? isInterface(tmp0, Incomplete) : false) {
          var tmp2_elvis_lhs = causeExceptionCache;
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = createCauseException($this, cause);
            causeExceptionCache = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var causeException_0 = tmp_1;
          if (tmp0.e1m()) {
            if (tryMakeCancelling($this, tmp0, causeException_0))
              return get_COMPLETING_ALREADY();
          } else {
            var finalState = tryMakeCompleting($this, tmp0, new CompletedExceptionally(causeException_0));
            if (finalState === get_COMPLETING_ALREADY()) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot happen in ' + toString(tmp0);
              throw IllegalStateException.o(toString(message));
            } else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        } else {
          return get_TOO_LATE_TO_CANCEL();
        }
      }
    }
  }
}
function getOrPromoteCancellingList($this, state) {
  var tmp0_elvis_lhs = state.h1p();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (state instanceof Empty) {
      tmp_0 = new NodeList();
    } else {
      if (state instanceof JobNode) {
        promoteSingleToNodeList($this, state);
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.error' call
        var message = 'State should have list: ' + toString(state);
        throw IllegalStateException.o(toString(message));
      }
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function tryMakeCancelling($this, state, rootCause) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var cancelling = new Finishing(list, false, rootCause);
  if (!$this.x1l_1.atomicfu$compareAndSet(state, cancelling))
    return false;
  notifyCancelling($this, list, rootCause);
  return true;
}
function tryMakeCompleting($this, state, proposedUpdate) {
  if (!(!(state == null) ? isInterface(state, Incomplete) : false))
    return get_COMPLETING_ALREADY();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (state instanceof Empty) {
    tmp_1 = true;
  } else {
    tmp_1 = state instanceof JobNode;
  }
  if (tmp_1) {
    tmp_0 = !(state instanceof ChildHandleNode);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = !(proposedUpdate instanceof CompletedExceptionally);
  } else {
    tmp = false;
  }
  if (tmp) {
    if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
      return proposedUpdate;
    }
    return get_COMPLETING_RETRY();
  }
  return tryMakeCompletingSlowPath($this, state, proposedUpdate);
}
function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return get_COMPLETING_RETRY();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
  var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
  var notifyRootCause;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (finishing.b1w())
    return get_COMPLETING_ALREADY();
  finishing.f1w(true);
  if (!(finishing === state)) {
    if (!$this.x1l_1.atomicfu$compareAndSet(state, finishing))
      return get_COMPLETING_RETRY();
  }
  // Inline function 'kotlinx.coroutines.assert' call
  var wasCancelling = finishing.p1v();
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    finishing.d1w(tmp0_safe_receiver.j1m_1);
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = finishing.e1w();
  var tmp_0;
  if (!wasCancelling) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  notifyRootCause = tmp_0;
  if (notifyRootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    notifyCancelling($this, list, notifyRootCause);
  }
  var child = nextChild($this, list);
  if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  list.y1v(2);
  var anotherChild = nextChild($this, list);
  if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  return finalizeFinishingState($this, finishing, proposedUpdate);
}
function _get_exceptionOrNull__b3j7js($this, $receiver) {
  var tmp0_safe_receiver = $receiver instanceof CompletedExceptionally ? $receiver : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j1m_1;
}
function tryWaitForChild($this, state, child, proposedUpdate) {
  var $this_0 = $this;
  var state_0 = state;
  var child_0 = child;
  var proposedUpdate_0 = proposedUpdate;
  $l$1: do {
    $l$0: do {
      var handle = invokeOnCompletion(child_0.k1w_1, false, new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0));
      if (!(handle === NonDisposableHandle_instance))
        return true;
      var tmp0_elvis_lhs = nextChild($this_0, child_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      var tmp0 = $this_0;
      var tmp1 = state_0;
      var tmp3 = proposedUpdate_0;
      $this_0 = tmp0;
      state_0 = tmp1;
      child_0 = nextChild_0;
      proposedUpdate_0 = tmp3;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function continueCompleting($this, state, lastChild, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  var waitChild = nextChild($this, lastChild);
  if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
    return Unit_instance;
  state.l1v_1.y1v(2);
  var waitChildAgain = nextChild($this, lastChild);
  if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
    return Unit_instance;
  }
  var finalState = finalizeFinishingState($this, state, proposedUpdate);
  $this.o1m(finalState);
}
function nextChild($this, $receiver) {
  var cur = $receiver;
  $l$loop: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (!cur.k1p_1) {
      break $l$loop;
    }
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
    cur = cur.j1p_1;
  }
  $l$loop_0: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    cur = cur.i1p_1;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (cur.k1p_1)
      continue $l$loop_0;
    if (cur instanceof ChildHandleNode)
      return cur;
    if (cur instanceof NodeList)
      return null;
  }
}
function stateString($this, state) {
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.p1v() ? 'Cancelling' : state.b1w() ? 'Completing' : 'Active';
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.e1m() ? 'Active' : 'New';
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
  }
  return tmp;
}
function *awaitSuspend($this, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cont = new AwaitContinuation(intercepted(uCont), $this);
    cont.u1p();
    disposeOnCancellation(cont, invokeOnCompletion($this, VOID, new ResumeAwaitOnCompletion(cont)));
    return cont.v1p();
  };
}
function JobSupport$_get_children_$slambda_k839f8(this$0) {
  return constructCallableReference(function *($this$sequence, $completion) {
    var state = this$0.y1m();
    var tmp;
    if (state instanceof ChildHandleNode) {
      tmp = yield* $this$sequence.xm(state.k1w_1, $completion);
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var tmp0_safe_receiver = state.h1p();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
          var cur = tmp0_safe_receiver.i1p_1;
          while (!equals(cur, tmp0_safe_receiver)) {
            var it = cur;
            if (it instanceof ChildHandleNode)
              yield* $this$sequence.xm(it.k1w_1, $completion);
            cur = cur.i1p_1;
          }
        }
        tmp = Unit_instance;
      }
    }
    return Unit_instance;
  }, 1);
}
function handlesExceptionF($this) {
  var tmp = $this.w1m();
  var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g1p();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parentJob = tmp_0;
  while (true) {
    if (parentJob.a1o())
      return true;
    var tmp_1 = parentJob.w1m();
    var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.g1p();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    parentJob = tmp_2;
  }
}
function boxIncomplete(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
    tmp = new IncompleteStateBox(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
var properties_initialized_JobSupport_kt_5iq8a4;
function _init_properties_JobSupport_kt__68f172() {
  if (!properties_initialized_JobSupport_kt_5iq8a4) {
    properties_initialized_JobSupport_kt_5iq8a4 = true;
    COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
    COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
    COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
    TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
    SEALED = new Symbol('SEALED');
    EMPTY_NEW = new Empty(false);
    EMPTY_ACTIVE = new Empty(true);
  }
}
function JobNode$invoke$ref(p0) {
  return constructCallableReference((p0_0) => {
    p0.v1o(p0_0);
    return Unit_instance;
  }, 1, 0, 9, 'invoke', [p0]);
}
var NonCancellable_instance;
function NonCancellable_getInstance() {
  if (NonCancellable_instance === VOID)
    NonCancellable.j1y();
  return NonCancellable_instance;
}
function SupervisorJob(parent) {
  parent = parent === VOID ? null : parent;
  return new SupervisorJobImpl(parent);
}
function *supervisorScope(block, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var coroutine = new SupervisorCoroutine(uCont.od(), uCont);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  };
}
function *withTimeout(timeMillis, block, $completion) {
  if (compare(timeMillis, new Long(0, 0)) <= 0)
    throw TimeoutCancellationException.y1y('Timed out immediately');
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    return setupTimeout(new TimeoutCoroutine(timeMillis, uCont), block);
  };
}
function *withTimeoutOrNull(timeMillis, block, $completion) {
  if (compare(timeMillis, new Long(0, 0)) <= 0)
    return null;
  var coroutine = {_v: null};
  try {
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    return yield () => {
      var uCont = $completion;
      var timeoutCoroutine = new TimeoutCoroutine(timeMillis, uCont);
      coroutine._v = timeoutCoroutine;
      return setupTimeout(timeoutCoroutine, block);
    };
  } catch ($p) {
    if ($p instanceof TimeoutCancellationException) {
      var e = $p;
      if (e.v1y_1 === coroutine._v) {
        return null;
      }
      throw e;
    } else {
      throw $p;
    }
  }
}
function setupTimeout(coroutine, block) {
  var cont = coroutine.u1q_1;
  var context = cont.od();
  disposeOnCompletion(coroutine, get_delay(context).j1u(coroutine.d1z_1, coroutine, coroutine.c1m_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine) {
  var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics) ? delay : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp0_safe_receiver.k1u(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  var message = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
  return TimeoutCancellationException.x1y(message, coroutine);
}
function *withTimeoutOrNull_0(timeout, block, $completion) {
  return yield* /*#__NOINLINE__*/withTimeoutOrNull(toDelayMillis(timeout), block, $completion);
}
var Unconfined_instance;
function Unconfined_getInstance() {
  if (Unconfined_instance === VOID)
    Unconfined.f1z();
  return Unconfined_instance;
}
var Key_instance_4;
function Key_getInstance_3() {
  return Key_instance_4;
}
function *yield_0($completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var tmp0 = $completion;
    var tmp$ret$1;
    $l$block_0: {
      var context = tmp0.od();
      ensureActive_0(context);
      var tmp = intercepted(tmp0);
      var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var cont = tmp_0;
      if (safeIsDispatchNeeded(cont.e1r_1, context)) {
        cont.j1z(context, Unit_instance);
      } else {
        var yieldContext = YieldContext.i1z();
        cont.j1z(context.ep(yieldContext), Unit_instance);
        if (yieldContext.h1z_1) {
          tmp$ret$1 = yieldUndispatched(cont) ? get_COROUTINE_SUSPENDED() : Unit_instance;
          break $l$block_0;
        }
      }
      tmp$ret$1 = get_COROUTINE_SUSPENDED();
    }
    return tmp$ret$1;
  });
  return Unit_instance;
}
var BufferOverflow_SUSPEND_instance;
var BufferOverflow_DROP_OLDEST_instance;
var BufferOverflow_DROP_LATEST_instance;
var BufferOverflow_entriesInitialized;
function BufferOverflow_initEntries() {
  if (BufferOverflow_entriesInitialized)
    return Unit_instance;
  BufferOverflow_entriesInitialized = true;
  BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
  BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
  BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
}
function BufferOverflow_SUSPEND_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_SUSPEND_instance;
}
function BufferOverflow_DROP_OLDEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_OLDEST_instance;
}
function BufferOverflow_DROP_LATEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_LATEST_instance;
}
function get_NULL_SEGMENT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NULL_SEGMENT;
}
var NULL_SEGMENT;
function get_SEGMENT_SIZE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SEGMENT_SIZE;
}
var SEGMENT_SIZE;
function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
}
var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
function get_BUFFERED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return BUFFERED;
}
var BUFFERED;
function get_IN_BUFFER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return IN_BUFFER;
}
var IN_BUFFER;
function get_RESUMING_BY_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_RCV;
}
var RESUMING_BY_RCV;
function get_RESUMING_BY_EB() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_EB;
}
var RESUMING_BY_EB;
function get_POISONED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return POISONED;
}
var POISONED;
function get_DONE_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return DONE_RCV;
}
var DONE_RCV;
function get_INTERRUPTED_SEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_SEND;
}
var INTERRUPTED_SEND;
function get_INTERRUPTED_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_RCV;
}
var INTERRUPTED_RCV;
function get_CHANNEL_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CHANNEL_CLOSED;
}
var CHANNEL_CLOSED;
function get_SUSPEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND;
}
var SUSPEND;
function get_SUSPEND_NO_WAITER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND_NO_WAITER;
}
var SUSPEND_NO_WAITER;
function get_FAILED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return FAILED;
}
var FAILED;
function get_NO_RECEIVE_RESULT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_RECEIVE_RESULT;
}
var NO_RECEIVE_RESULT;
function get_CLOSE_HANDLER_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_CLOSED;
}
var CLOSE_HANDLER_CLOSED;
function get_CLOSE_HANDLER_INVOKED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_INVOKED;
}
var CLOSE_HANDLER_INVOKED;
function get_NO_CLOSE_CAUSE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_CLOSE_CAUSE;
}
var NO_CLOSE_CAUSE;
function setElementLazy($this, index, value) {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  $this.p1z_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
}
function onClosedHasNext($this) {
  $this.a21_1 = get_CHANNEL_CLOSED();
  var tmp0_elvis_lhs = $this.c21_1.d21();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cause = tmp;
  throw recoverStackTrace_0(cause);
}
function *hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      $this.b21_1 = cancellable;
      var tmp0 = $this.c21_1;
      var tmp2 = segment;
      var tmp4 = index;
      var tmp6 = r;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var waiter = $this;
      var updCellResult = updateCellReceive(tmp0, tmp2, tmp4, tmp6, waiter);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(tmp0, waiter, tmp2, tmp4);
      } else if (updCellResult === get_FAILED()) {
        if (compare(tmp6, tmp0.e21()) < 0) {
          tmp2.y20();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = tmp0.h20_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (tmp0.f21()) {
              onClosedHasNextNoWaiterSuspend($this);
              break $l$block_0;
            }
            var r_0 = tmp0.d20_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$8 = modulo(r_0, fromInt(other_0));
            var i = convertToInt(tmp$ret$8);
            if (!equalsLong(segment_0.r1r_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(tmp0, segment_0, i, r_0, waiter);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (compare(r_0, tmp0.e21()) < 0) {
                segment_0.y20();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException.o(toString(message));
            } else {
              segment_0.y20();
              $this.a21_1 = updCellResult_0;
              $this.b21_1 = null;
              var tmp0_safe_receiver = $this.c21_1.b20_1;
              cancellable.a1r(true, tmp0_safe_receiver == null ? null : bindCancellationFun($this.c21_1, tmp0_safe_receiver, updCellResult_0));
            }
            break $l$block_0;
          }
        }
      } else {
        tmp2.y20();
        $this.a21_1 = updCellResult;
        $this.b21_1 = null;
        var tmp0_safe_receiver_0 = $this.c21_1.b20_1;
        cancellable.a1r(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun($this.c21_1, tmp0_safe_receiver_0, updCellResult));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.p1s();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.v1p();
  };
}
function onClosedHasNextNoWaiterSuspend($this) {
  var cont = ensureNotNull($this.b21_1);
  $this.b21_1 = null;
  $this.a21_1 = get_CHANNEL_CLOSED();
  var cause = $this.c21_1.d21();
  if (cause == null) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
    cont.qd(tmp$ret$1);
  } else {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(cause, cont);
    var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.qd(tmp$ret$3);
  }
}
function _get_bufferEndCounter__2d4hee($this) {
  return $this.e20_1.kotlinx$atomicfu$value;
}
function _get_isRendezvousOrUnlimited__3mdufi($this) {
  // Inline function 'kotlin.let' call
  var it = _get_bufferEndCounter__2d4hee($this);
  return equalsLong(it, new Long(0, 0)) || equalsLong(it, new Long(-1, 2147483647));
}
function *onClosedSend($this, element, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
    cancellable.u1p();
    $l$block: {
      var tmp0_safe_receiver = $this.b20_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, $this.g21());
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = recoverStackTrace(tmp1_safe_receiver, cancellable);
        var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
        cancellable.qd(tmp$ret$7);
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      var exception_0 = $this.g21();
      // Inline function 'kotlin.Companion.failure' call
      var exception_1 = recoverStackTrace(exception_0, cancellable);
      var tmp$ret$9 = _Result___init__impl__xyqfz8(createFailure(exception_1));
      cancellable.qd(tmp$ret$9);
    }
    return cancellable.v1p();
  });
  return Unit_instance;
}
function *sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var tmp0 = $this;
      var tmp2 = segment;
      var tmp4 = index;
      var tmp6 = element;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
      var s_0 = s;
      switch (updateCellSend(tmp0, tmp2, tmp4, tmp6, s_0, cancellable, false)) {
        case 0:
          tmp2.y20();
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.qd(tmp$ret$7);
          break;
        case 1:
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.qd(tmp$ret$10);
          break;
        case 2:
          prepareSenderForSuspension(tmp0, cancellable, tmp2, tmp4);
          break;
        case 4:
          if (compare(s_0, tmp0.h21()) < 0) {
            tmp2.y20();
          }

          onClosedSendOnNoWaiterSuspend($this, element, cancellable);
          break;
        case 5:
          tmp2.y20();
          $l$block_5: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var segment_0 = tmp0.g20_1.kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              var sendersAndCloseStatusCur = tmp0.c20_1.atomicfu$getAndIncrement$long();
              // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
              var s_1 = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
              var closed = _get_isClosedForSend0__kxgf9m(tmp0, sendersAndCloseStatusCur);
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = divide(s_1, fromInt(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var tmp$ret$15 = modulo(s_1, fromInt(other_0));
              var i = convertToInt(tmp$ret$15);
              if (!equalsLong(segment_0.r1r_1, id)) {
                var tmp0_elvis_lhs = findSegmentSend(tmp0, id, segment_0);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  var tmp_0;
                  if (closed) {
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  } else {
                    continue $l$loop_0;
                  }
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                segment_0 = tmp;
              }
              switch (updateCellSend(tmp0, segment_0, i, tmp6, s_1, cancellable, closed)) {
                case 0:
                  segment_0.y20();
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$19 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.qd(tmp$ret$19);
                  break $l$block_5;
                case 1:
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$22 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.qd(tmp$ret$22);
                  break $l$block_5;
                case 2:
                  if (closed) {
                    segment_0.o20();
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  }

                  var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
                  if (tmp2_safe_receiver == null)
                    null;
                  else {
                    prepareSenderForSuspension(tmp0, tmp2_safe_receiver, segment_0, i);
                  }

                  break $l$block_5;
                case 4:
                  if (compare(s_1, tmp0.h21()) < 0) {
                    segment_0.y20();
                  }

                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                case 5:
                  segment_0.y20();
                  continue $l$loop_0;
                case 3:
                  // Inline function 'kotlin.error' call

                  var message = 'unexpected';
                  throw IllegalStateException.o(toString(message));
              }
            }
          }

          break;
        default:
          // Inline function 'kotlin.error' call

          var message_0 = 'unexpected';
          throw IllegalStateException.o(toString(message_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.p1s();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.v1p();
  });
  return Unit_instance;
}
function prepareSenderForSuspension($this, $receiver, segment, index) {
  $receiver.v1s(segment, index + get_SEGMENT_SIZE() | 0);
}
function onClosedSendOnNoWaiterSuspend($this, element, cont) {
  var tmp0_safe_receiver = $this.b20_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    callUndeliveredElement(tmp0_safe_receiver, element, cont.od());
  }
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = recoverStackTrace($this.g21(), cont);
  var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.qd(tmp$ret$1);
}
function updateCellSend($this, segment, index, element, s, waiter, closed) {
  segment.s1z(index, element);
  if (closed)
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  var state = segment.w1z(index);
  if (state === null) {
    if (bufferOrRendezvousSend($this, s)) {
      if (segment.y1z(index, null, get_BUFFERED())) {
        return 1;
      }
    } else {
      if (waiter == null) {
        return 3;
      } else {
        if (segment.y1z(index, null, waiter))
          return 2;
      }
    }
  } else {
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      segment.v1z(index);
      var tmp;
      if (tryResumeReceiver($this, state, element)) {
        segment.x1z(index, get_DONE_RCV());
        $this.i21();
        tmp = 0;
      } else {
        if (!(segment.z1z(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.m20(index, true);
        }
        tmp = 5;
      }
      return tmp;
    }
  }
  return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
}
function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
  while (true) {
    var state = segment.w1z(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s) && !closed) {
        if (segment.y1z(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (closed) {
          if (segment.y1z(index, null, get_INTERRUPTED_SEND())) {
            segment.m20(index, false);
            return 4;
          }
        } else if (waiter == null)
          return 3;
        else if (segment.y1z(index, null, waiter))
          return 2;
      }
    } else if (state === get_IN_BUFFER()) {
      if (segment.y1z(index, state, get_BUFFERED())) {
        return 1;
      }
    } else if (state === get_INTERRUPTED_RCV()) {
      segment.v1z(index);
      return 5;
    } else if (state === get_POISONED()) {
      segment.v1z(index);
      return 5;
    } else if (state === get_CHANNEL_CLOSED()) {
      segment.v1z(index);
      completeCloseOrCancel($this);
      return 4;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      segment.v1z(index);
      var tmp;
      if (state instanceof WaiterEB) {
        tmp = state.j21_1;
      } else {
        tmp = state;
      }
      var receiver = tmp;
      var tmp_0;
      if (tryResumeReceiver($this, receiver, element)) {
        segment.x1z(index, get_DONE_RCV());
        $this.i21();
        tmp_0 = 0;
      } else {
        if (!(segment.z1z(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.m20(index, true);
        }
        tmp_0 = 5;
      }
      return tmp_0;
    }
  }
}
function shouldSendSuspend0($this, curSendersAndCloseStatus) {
  if (_get_isClosedForSend0__kxgf9m($this, curSendersAndCloseStatus))
    return false;
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  var tmp$ret$0 = bitwiseAnd(curSendersAndCloseStatus, new Long(-1, 268435455));
  return !bufferOrRendezvousSend($this, tmp$ret$0);
}
function bufferOrRendezvousSend($this, curSenders) {
  var tmp;
  if (compare(curSenders, _get_bufferEndCounter__2d4hee($this)) < 0) {
    tmp = true;
  } else {
    var tmp0 = $this.h21();
    // Inline function 'kotlin.Long.plus' call
    var other = $this.a20_1;
    var tmp$ret$0 = add(tmp0, fromInt(other));
    tmp = compare(curSenders, tmp$ret$0) < 0;
  }
  return tmp;
}
function tryResumeReceiver($this, $receiver, element) {
  var tmp;
  if (isInterface($receiver, SelectInstance)) {
    tmp = $receiver.o21($this, element);
  } else {
    if ($receiver instanceof ReceiveCatching) {
      if (!($receiver instanceof ReceiveCatching))
        THROW_CCE();
      var tmp_0 = Companion_getInstance_0().m21(element);
      var tmp1_safe_receiver = $this.b20_1;
      tmp = tryResume0($receiver.n21_1, new ChannelResult(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFunResult($this, tmp1_safe_receiver));
    } else {
      if ($receiver instanceof BufferedChannelIterator) {
        if (!($receiver instanceof BufferedChannelIterator))
          THROW_CCE();
        tmp = $receiver.k21(element);
      } else {
        if (isInterface($receiver, CancellableContinuation)) {
          if (!isInterface($receiver, CancellableContinuation))
            THROW_CCE();
          var tmp2_safe_receiver = $this.b20_1;
          tmp = tryResume0($receiver, element, tmp2_safe_receiver == null ? null : bindCancellationFun_0($this, tmp2_safe_receiver));
        } else {
          // Inline function 'kotlin.error' call
          var message = 'Unexpected receiver type: ' + toString($receiver);
          throw IllegalStateException.o(toString(message));
        }
      }
    }
  }
  return tmp;
}
function *receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var tmp0 = $this;
      var tmp2 = segment;
      var tmp4 = index;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var r_0 = r;
      var updCellResult = updateCellReceive(tmp0, tmp2, tmp4, r_0, cancellable);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(tmp0, cancellable, tmp2, tmp4);
      } else if (updCellResult === get_FAILED()) {
        if (compare(r_0, tmp0.e21()) < 0) {
          tmp2.y20();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = tmp0.h20_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (tmp0.f21()) {
              onClosedReceiveOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_1 = tmp0.d20_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_1, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$8 = modulo(r_1, fromInt(other_0));
            var i = convertToInt(tmp$ret$8);
            if (!equalsLong(segment_0.r1r_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(tmp0, segment_0, i, r_1, cancellable);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (compare(r_1, tmp0.e21()) < 0) {
                segment_0.y20();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException.o(toString(message));
            } else {
              segment_0.y20();
              var tmp0_safe_receiver = $this.b20_1;
              var onCancellation = tmp0_safe_receiver == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver);
              cancellable.a1r(updCellResult_0, onCancellation);
            }
            break $l$block_0;
          }
        }
      } else {
        tmp2.y20();
        var tmp0_safe_receiver_0 = $this.b20_1;
        var onCancellation_0 = tmp0_safe_receiver_0 == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver_0);
        cancellable.a1r(updCellResult, onCancellation_0);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.p1s();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.v1p();
  };
}
function prepareReceiverForSuspension($this, $receiver, segment, index) {
  $this.p21();
  $receiver.v1s(segment, index);
}
function onClosedReceiveOnNoWaiterSuspend($this, cont) {
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = _get_receiveException__foorc1($this);
  var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.qd(tmp$ret$1);
}
function *receiveCatchingOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  var tmp$ret$0 = (yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var waiter = new ReceiveCatching(cancellable instanceof CancellableContinuationImpl ? cancellable : THROW_CCE());
      var tmp0 = $this;
      var tmp2 = segment;
      var tmp4 = index;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var r_0 = r;
      var updCellResult = updateCellReceive(tmp0, tmp2, tmp4, r_0, waiter);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(tmp0, waiter, tmp2, tmp4);
      } else if (updCellResult === get_FAILED()) {
        if (compare(r_0, tmp0.e21()) < 0) {
          tmp2.y20();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = tmp0.h20_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (tmp0.f21()) {
              onClosedReceiveCatchingOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_1 = tmp0.d20_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_1, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$8 = modulo(r_1, fromInt(other_0));
            var i = convertToInt(tmp$ret$8);
            if (!equalsLong(segment_0.r1r_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(tmp0, segment_0, i, r_1, waiter);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (compare(r_1, tmp0.e21()) < 0) {
                segment_0.y20();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException.o(toString(message));
            } else {
              segment_0.y20();
              var tmp_0 = Companion_getInstance_0().m21(updCellResult_0);
              var tmp0_safe_receiver = $this.b20_1;
              cancellable.a1r(new ChannelResult(tmp_0), tmp0_safe_receiver == null ? null : bindCancellationFunResult($this, tmp0_safe_receiver));
            }
            break $l$block_0;
          }
        }
      } else {
        tmp2.y20();
        var tmp_1 = Companion_getInstance_0().m21(updCellResult);
        var tmp0_safe_receiver_0 = $this.b20_1;
        cancellable.a1r(new ChannelResult(tmp_1), tmp0_safe_receiver_0 == null ? null : bindCancellationFunResult($this, tmp0_safe_receiver_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.p1s();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.v1p();
  }).q21_1;
  return new ChannelResult(tmp$ret$0);
}
function onClosedReceiveCatchingOnNoWaiterSuspend($this, cont) {
  // Inline function 'kotlin.coroutines.resume' call
  // Inline function 'kotlin.Companion.success' call
  var value = new ChannelResult(Companion_getInstance_0().r21($this.d21()));
  var tmp$ret$1 = _Result___init__impl__xyqfz8(value);
  cont.qd(tmp$ret$1);
}
function updateCellReceive($this, segment, index, r, waiter) {
  var state = segment.w1z(index);
  if (state === null) {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var this_0 = $this.c20_1.kotlinx$atomicfu$value;
    var senders = bitwiseAnd(this_0, new Long(-1, 268435455));
    if (compare(r, senders) >= 0) {
      if (waiter === null) {
        return get_SUSPEND_NO_WAITER();
      }
      if (segment.y1z(index, state, waiter)) {
        expandBuffer($this);
        return get_SUSPEND();
      }
    }
  } else if (state === get_BUFFERED())
    if (segment.y1z(index, state, get_DONE_RCV())) {
      expandBuffer($this);
      return segment.u1z(index);
    }
  return updateCellReceiveSlow($this, segment, index, r, waiter);
}
function updateCellReceiveSlow($this, segment, index, r, waiter) {
  $l$loop: while (true) {
    var state = segment.w1z(index);
    if (state === null || state === get_IN_BUFFER()) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var this_0 = $this.c20_1.kotlinx$atomicfu$value;
      var senders = bitwiseAnd(this_0, new Long(-1, 268435455));
      if (compare(r, senders) < 0) {
        if (segment.y1z(index, state, get_POISONED())) {
          expandBuffer($this);
          return get_FAILED();
        }
      } else {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.y1z(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED()) {
      if (segment.y1z(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.u1z(index);
      }
    } else if (state === get_INTERRUPTED_SEND())
      return get_FAILED();
    else if (state === get_POISONED())
      return get_FAILED();
    else if (state === get_CHANNEL_CLOSED()) {
      expandBuffer($this);
      return get_FAILED();
    } else if (state === get_RESUMING_BY_EB())
      continue $l$loop;
    else {
      if (segment.y1z(index, state, get_RESUMING_BY_RCV())) {
        var helpExpandBuffer = state instanceof WaiterEB;
        var tmp;
        if (state instanceof WaiterEB) {
          tmp = state.j21_1;
        } else {
          tmp = state;
        }
        var sender = tmp;
        var tmp_0;
        if (tryResumeSender($this, sender, segment, index)) {
          segment.x1z(index, get_DONE_RCV());
          expandBuffer($this);
          tmp_0 = segment.u1z(index);
        } else {
          segment.x1z(index, get_INTERRUPTED_SEND());
          segment.m20(index, false);
          if (helpExpandBuffer) {
            expandBuffer($this);
          }
          tmp_0 = get_FAILED();
        }
        return tmp_0;
      }
    }
  }
}
function tryResumeSender($this, $receiver, segment, index) {
  var tmp;
  if (isInterface($receiver, CancellableContinuation)) {
    if (!isInterface($receiver, CancellableContinuation))
      THROW_CCE();
    tmp = tryResume0($receiver, Unit_instance);
  } else {
    if (isInterface($receiver, SelectInstance)) {
      if (!($receiver instanceof SelectImplementation))
        THROW_CCE();
      var trySelectResult = $receiver.w21($this, Unit_instance);
      if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
        segment.v1z(index);
      }
      tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
    } else {
      if ($receiver instanceof SendBroadcast) {
        tmp = tryResume0($receiver.s21_1, true);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'Unexpected waiter: ' + toString($receiver);
        throw IllegalStateException.o(toString(message));
      }
    }
  }
  return tmp;
}
function expandBuffer($this) {
  if (_get_isRendezvousOrUnlimited__3mdufi($this))
    return Unit_instance;
  var segment = $this.i20_1.kotlinx$atomicfu$value;
  try_again: while (true) {
    var b = $this.e20_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = divide(b, fromInt(other));
    var s = $this.e21();
    if (compare(s, b) <= 0) {
      if (compare(segment.r1r_1, id) < 0 && !(segment.u20() == null)) {
        moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
      }
      incCompletedExpandBufferAttempts($this);
      return Unit_instance;
    }
    if (!equalsLong(segment.r1r_1, id)) {
      var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue try_again;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var tmp$ret$1 = modulo(b, fromInt(other_0));
    var i = convertToInt(tmp$ret$1);
    if (updateCellExpandBuffer($this, segment, i, b)) {
      incCompletedExpandBufferAttempts($this);
      return Unit_instance;
    } else {
      incCompletedExpandBufferAttempts($this);
      continue try_again;
    }
  }
}
function updateCellExpandBuffer($this, segment, index, b) {
  var state = segment.w1z(index);
  if (!(state == null) ? isInterface(state, Waiter) : false) {
    if (compare(b, $this.d20_1.kotlinx$atomicfu$value) >= 0) {
      if (segment.y1z(index, state, get_RESUMING_BY_EB())) {
        var tmp;
        if (tryResumeSender($this, state, segment, index)) {
          segment.x1z(index, get_BUFFERED());
          tmp = true;
        } else {
          segment.x1z(index, get_INTERRUPTED_SEND());
          segment.m20(index, false);
          tmp = false;
        }
        return tmp;
      }
    }
  }
  return updateCellExpandBufferSlow($this, segment, index, b);
}
function updateCellExpandBufferSlow($this, segment, index, b) {
  $l$loop: while (true) {
    var state = segment.w1z(index);
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      if (compare(b, $this.d20_1.kotlinx$atomicfu$value) < 0) {
        if (segment.y1z(index, state, new WaiterEB(state)))
          return true;
      } else {
        if (segment.y1z(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender($this, state, segment, index)) {
            segment.x1z(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.x1z(index, get_INTERRUPTED_SEND());
            segment.m20(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    } else {
      if (state === get_INTERRUPTED_SEND())
        return false;
      else {
        if (state === null) {
          if (segment.y1z(index, state, get_IN_BUFFER()))
            return true;
        } else {
          if (state === get_BUFFERED())
            return true;
          else {
            if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
              return true;
            else {
              if (state === get_CHANNEL_CLOSED())
                return true;
              else {
                if (state === get_RESUMING_BY_RCV())
                  continue $l$loop;
                else {
                  // Inline function 'kotlin.error' call
                  var message = 'Unexpected cell state: ' + toString_0(state);
                  throw IllegalStateException.o(toString(message));
                }
              }
            }
          }
        }
      }
    }
  }
}
function incCompletedExpandBufferAttempts($this, nAttempts) {
  nAttempts = nAttempts === VOID ? new Long(1, 0) : nAttempts;
  // Inline function 'kotlin.also' call
  var this_0 = $this.f20_1.atomicfu$addAndGet$long(nAttempts);
  // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
  if (!equalsLong(bitwiseAnd(this_0, new Long(0, 1073741824)), new Long(0, 0))) {
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      var this_1 = $this.f20_1.kotlinx$atomicfu$value;
      if (!!equalsLong(bitwiseAnd(this_1, new Long(0, 1073741824)), new Long(0, 0))) {
        break $l$loop;
      }
    }
  }
}
function _get_receiveException__foorc1($this) {
  var tmp0_elvis_lhs = $this.d21();
  return tmp0_elvis_lhs == null ? ClosedReceiveChannelException.d22('Channel was closed') : tmp0_elvis_lhs;
}
function invokeCloseHandler($this) {
  var tmp0 = $this.l20_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.getAndUpdate' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      if (cur === null) {
        tmp = get_CLOSE_HANDLER_CLOSED();
      } else {
        tmp = get_CLOSE_HANDLER_INVOKED();
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = cur;
        break $l$block;
      }
    }
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var closeHandler = tmp_0;
  if (typeof closeHandler !== 'function')
    THROW_CCE();
  closeHandler($this.d21());
}
function markClosed($this) {
  var tmp0 = $this.c20_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp;
      switch (convertToInt(shiftRight(cur, 60))) {
        case 0:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$3 = bitwiseAnd(cur, new Long(-1, 268435455));
          tmp = constructSendersAndCloseStatus(tmp$ret$3, 2);
          break;
        case 1:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$4 = bitwiseAnd(cur, new Long(-1, 268435455));
          tmp = constructSendersAndCloseStatus(tmp$ret$4, 3);
          break;
        default:
          return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function markCancelled($this) {
  var tmp0 = $this.c20_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var tmp$ret$2 = bitwiseAnd(cur, new Long(-1, 268435455));
      var upd = constructSendersAndCloseStatus(tmp$ret$2, 3);
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function markCancellationStarted($this) {
  var tmp0 = $this.c20_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      if (convertToInt(shiftRight(cur, 60)) === 0) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$3 = bitwiseAnd(cur, new Long(-1, 268435455));
        tmp = constructSendersAndCloseStatus(tmp$ret$3, 1);
      } else {
        return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function completeCloseOrCancel($this) {
  $this.e22();
}
function completeClose($this, sendersCur) {
  var lastSegment = closeLinkedList($this);
  if ($this.g22()) {
    var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
    if (!equalsLong(lastBufferedCellGlobalIndex, new Long(-1, -1))) {
      $this.f22(lastBufferedCellGlobalIndex);
    }
  }
  cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
  return lastSegment;
}
function completeCancel($this, sendersCur) {
  var lastSegment = completeClose($this, sendersCur);
  removeUnprocessedElements($this, lastSegment);
}
function closeLinkedList($this) {
  var lastSegment = $this.i20_1.kotlinx$atomicfu$value;
  // Inline function 'kotlin.let' call
  var it = $this.g20_1.kotlinx$atomicfu$value;
  if (compare(it.r1r_1, lastSegment.r1r_1) > 0)
    lastSegment = it;
  // Inline function 'kotlin.let' call
  var it_0 = $this.h20_1.kotlinx$atomicfu$value;
  if (compare(it_0.r1r_1, lastSegment.r1r_1) > 0)
    lastSegment = it_0;
  return close(lastSegment);
}
function markAllEmptyCellsAsClosed($this, lastSegment) {
  var segment = lastSegment;
  while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.r1r_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        if (compare(globalIndex, $this.h21()) < 0)
          return new Long(-1, -1);
        cell_update: while (true) {
          var state = segment.w1z(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.y1z(index, state, get_CHANNEL_CLOSED())) {
              segment.o20();
              break cell_update;
            }
          } else if (state === get_BUFFERED())
            return globalIndex;
          else
            break cell_update;
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.x20();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return new Long(-1, -1);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
}
function removeUnprocessedElements($this, lastSegment) {
  var onUndeliveredElement = $this.b20_1;
  var undeliveredElementException = null;
  var suspendedSenders = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.r1r_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        update_cell: while (true) {
          var state = segment.w1z(index);
          if (state === get_DONE_RCV())
            break process_segments;
          else {
            if (state === get_BUFFERED()) {
              if (compare(globalIndex, $this.h21()) < 0)
                break process_segments;
              if (segment.y1z(index, state, get_CHANNEL_CLOSED())) {
                if (!(onUndeliveredElement == null)) {
                  var element = segment.t1z(index);
                  undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                }
                segment.v1z(index);
                segment.o20();
                break update_cell;
              }
            } else {
              if (state === get_IN_BUFFER() || state === null) {
                if (segment.y1z(index, state, get_CHANNEL_CLOSED())) {
                  segment.o20();
                  break update_cell;
                }
              } else {
                var tmp;
                if (!(state == null) ? isInterface(state, Waiter) : false) {
                  tmp = true;
                } else {
                  tmp = state instanceof WaiterEB;
                }
                if (tmp) {
                  if (compare(globalIndex, $this.h21()) < 0)
                    break process_segments;
                  var tmp_0;
                  if (state instanceof WaiterEB) {
                    tmp_0 = state.j21_1;
                  } else {
                    tmp_0 = (!(state == null) ? isInterface(state, Waiter) : false) ? state : THROW_CCE();
                  }
                  var sender = tmp_0;
                  if (segment.y1z(index, state, get_CHANNEL_CLOSED())) {
                    if (!(onUndeliveredElement == null)) {
                      var element_0 = segment.t1z(index);
                      undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                    }
                    suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                    segment.v1z(index);
                    segment.o20();
                    break update_cell;
                  }
                } else {
                  if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                    break process_segments;
                  else {
                    if (state === get_RESUMING_BY_EB())
                      continue update_cell;
                    else {
                      break update_cell;
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.x20();
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      break process_segments;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    segment = tmp_1;
  }
  var tmp0_0 = suspendedSenders;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList)) {
        var it = access$_get_holder__kkflen(tmp0_0);
        resumeSenderOnCancelledChannel($this, it);
      } else {
        var tmp_2 = access$_get_holder__kkflen(tmp0_0);
        var list = tmp_2 instanceof ArrayList ? tmp_2 : THROW_CCE();
        var inductionVariable_0 = list.s2() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.u2(i);
            resumeSenderOnCancelledChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  var tmp1_safe_receiver = undeliveredElementException;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp1_safe_receiver;
  }
}
function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
  var suspendedReceivers = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (!(segment == null)) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.r1r_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var tmp$ret$1 = add(this_0, fromInt(index));
        if (compare(tmp$ret$1, sendersCounter) < 0)
          break process_segments;
        cell_update: while (true) {
          var state = segment.w1z(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.y1z(index, state, get_CHANNEL_CLOSED())) {
              segment.o20();
              break cell_update;
            }
          } else {
            if (state instanceof WaiterEB) {
              if (segment.y1z(index, state, get_CHANNEL_CLOSED())) {
                suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.j21_1);
                segment.m20(index, true);
                break cell_update;
              }
            } else {
              if (!(state == null) ? isInterface(state, Waiter) : false) {
                if (segment.y1z(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                  segment.m20(index, true);
                  break cell_update;
                }
              } else {
                break cell_update;
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    segment = segment.x20();
  }
  var tmp0_0 = suspendedReceivers;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList)) {
        var it = access$_get_holder__kkflen(tmp0_0);
        resumeReceiverOnClosedChannel($this, it);
      } else {
        var tmp = access$_get_holder__kkflen(tmp0_0);
        var list = tmp instanceof ArrayList ? tmp : THROW_CCE();
        var inductionVariable_0 = list.s2() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.u2(i);
            resumeReceiverOnClosedChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
}
function resumeReceiverOnClosedChannel($this, $receiver) {
  return resumeWaiterOnClosedChannel($this, $receiver, true);
}
function resumeSenderOnCancelledChannel($this, $receiver) {
  return resumeWaiterOnClosedChannel($this, $receiver, false);
}
function resumeWaiterOnClosedChannel($this, $receiver, receiver) {
  if ($receiver instanceof SendBroadcast) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $receiver.s21_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
    this_0.qd(tmp$ret$1);
  } else {
    if (isInterface($receiver, CancellableContinuation)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = receiver ? _get_receiveException__foorc1($this) : $this.g21();
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
      $receiver.qd(tmp$ret$3);
    } else {
      if ($receiver instanceof ReceiveCatching) {
        var tmp0 = $receiver.n21_1;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = new ChannelResult(Companion_getInstance_0().r21($this.d21()));
        var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
        tmp0.qd(tmp$ret$5);
      } else {
        if ($receiver instanceof BufferedChannelIterator) {
          $receiver.y21();
        } else {
          if (isInterface($receiver, SelectInstance))
            $receiver.o21($this, get_CHANNEL_CLOSED());
          else {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected waiter: ' + toString($receiver);
            throw IllegalStateException.o(toString(message));
          }
        }
      }
    }
  }
}
function _get_isClosedForSend0__kxgf9m($this, $receiver) {
  return isClosed($this, $receiver, false);
}
function _get_isClosedForReceive0__f7qknl($this, $receiver) {
  return isClosed($this, $receiver, true);
}
function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var tmp;
  switch (convertToInt(shiftRight(sendersAndCloseStatusCur, 60))) {
    case 0:
      tmp = false;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$1 = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
      completeClose($this, tmp$ret$1);
      tmp = isClosedForReceive ? !$this.h22() : true;
      break;
    case 3:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$2 = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
      completeCancel($this, tmp$ret$2);
      tmp = true;
      break;
    default:
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

      // Inline function 'kotlin.error' call

      var message = 'unexpected close status: ' + convertToInt(shiftRight(sendersAndCloseStatusCur, 60));
      throw IllegalStateException.o(toString(message));
  }
  return tmp;
}
function isCellNonEmpty($this, segment, index, globalIndex) {
  while (true) {
    var state = segment.w1z(index);
    if (state === null || state === get_IN_BUFFER()) {
      if (segment.y1z(index, state, get_POISONED())) {
        expandBuffer($this);
        return false;
      }
    } else if (state === get_BUFFERED())
      return true;
    else if (state === get_INTERRUPTED_SEND())
      return false;
    else if (state === get_CHANNEL_CLOSED())
      return false;
    else if (state === get_DONE_RCV())
      return false;
    else if (state === get_POISONED())
      return false;
    else if (state === get_RESUMING_BY_EB())
      return true;
    else if (state === get_RESUMING_BY_RCV())
      return false;
    else
      return equalsLong(globalIndex, $this.h21());
  }
}
function findSegmentSend($this, id, startFrom) {
  var tmp0 = $this.g20_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (compare(cur.r1r_1, tmp2.r1r_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.q20()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.r20()) {
                cur.s7();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.r20()) {
              tmp2.s7();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.r1r_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    var tmp$ret$6 = multiply(tmp0_0, fromInt(other));
    if (compare(tmp$ret$6, $this.h21()) < 0) {
      startFrom.y20();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (compare(segment.r1r_1, id) > 0) {
      var tmp0_1 = segment.r1r_1;
      // Inline function 'kotlin.Long.times' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$7 = multiply(tmp0_1, fromInt(other_0));
      updateSendersCounterIfLower($this, tmp$ret$7);
      var tmp0_2 = segment.r1r_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$8 = multiply(tmp0_2, fromInt(other_1));
      if (compare(tmp$ret$8, $this.h21()) < 0) {
        segment.y20();
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function findSegmentReceive($this, id, startFrom) {
  var tmp0 = $this.h20_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (compare(cur.r1r_1, tmp2.r1r_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.q20()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.r20()) {
                cur.s7();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.r20()) {
              tmp2.s7();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.r1r_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    var tmp$ret$6 = multiply(tmp0_0, fromInt(other));
    if (compare(tmp$ret$6, $this.e21()) < 0) {
      startFrom.y20();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
      var tmp0_1 = _get_bufferEndCounter__2d4hee($this);
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$7 = divide(tmp0_1, fromInt(other_0));
      tmp_1 = compare(id, tmp$ret$7) <= 0;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp0_2 = $this.i20_1;
      $l$block_5: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        // Inline function 'kotlinx.atomicfu.loop' call
        while (true) {
          var cur_0 = tmp0_2.kotlinx$atomicfu$value;
          if (compare(cur_0.r1r_1, segment.r1r_1) >= 0) {
            break $l$block_5;
          }
          if (!segment.q20()) {
            break $l$block_5;
          }
          if (tmp0_2.atomicfu$compareAndSet(cur_0, segment)) {
            if (cur_0.r20()) {
              cur_0.s7();
            }
            break $l$block_5;
          }
          if (segment.r20()) {
            segment.s7();
          }
        }
      }
    }
    var tmp_2;
    if (compare(segment.r1r_1, id) > 0) {
      var tmp0_3 = segment.r1r_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$11 = multiply(tmp0_3, fromInt(other_1));
      updateReceiversCounterIfLower($this, tmp$ret$11);
      var tmp0_4 = segment.r1r_1;
      // Inline function 'kotlin.Long.times' call
      var other_2 = get_SEGMENT_SIZE();
      var tmp$ret$12 = multiply(tmp0_4, fromInt(other_2));
      if (compare(tmp$ret$12, $this.e21()) < 0) {
        segment.y20();
      }
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_2 = segment;
    }
    tmp_0 = tmp_2;
  }
  return tmp_0;
}
function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
  var tmp0 = $this.i20_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (compare(cur.r1r_1, tmp2.r1r_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.q20()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.r20()) {
                cur.s7();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.r20()) {
              tmp2.s7();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
    incCompletedExpandBufferAttempts($this);
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (compare(segment.r1r_1, id) > 0) {
      // Inline function 'kotlin.Long.plus' call
      var tmp_2 = add(currentBufferEndCounter, fromInt(1));
      var tmp0_0 = segment.r1r_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      var tmp$ret$7 = multiply(tmp0_0, fromInt(other));
      if ($this.e20_1.atomicfu$compareAndSet(tmp_2, tmp$ret$7)) {
        var tmp0_1 = segment.r1r_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$8 = multiply(tmp0_1, fromInt(other_0));
        incCompletedExpandBufferAttempts($this, subtract(tmp$ret$8, currentBufferEndCounter));
      } else {
        incCompletedExpandBufferAttempts($this);
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
  var segment = startFrom;
  $l$loop: while (compare(segment.r1r_1, id) < 0) {
    var tmp0_elvis_lhs = segment.u20();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
  while (true) {
    $l$loop_0: while (segment.p20()) {
      var tmp1_elvis_lhs = segment.u20();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      segment = tmp_0;
    }
    var tmp0 = $this.i20_1;
    var tmp2 = segment;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.moveForward' call
      var tmp$ret$1;
      // Inline function 'kotlinx.atomicfu.loop' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (compare(cur.r1r_1, tmp2.r1r_1) >= 0) {
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (!tmp2.q20()) {
          tmp$ret$0 = false;
          break $l$block_1;
        }
        if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
          if (cur.r20()) {
            cur.s7();
          }
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (tmp2.r20()) {
          tmp2.s7();
        }
      }
      tmp$ret$0 = tmp$ret$1;
    }
    if (tmp$ret$0)
      return Unit_instance;
  }
}
function updateSendersCounterIfLower($this, value) {
  var tmp$ret$0;
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.c20_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var curCounter = bitwiseAnd(cur, new Long(-1, 268435455));
    if (compare(curCounter, value) >= 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp$ret$3 = convertToInt(shiftRight(cur, 60));
    var update = constructSendersAndCloseStatus(curCounter, tmp$ret$3);
    if ($this.c20_1.atomicfu$compareAndSet(cur, update))
      return Unit_instance;
  }
  return tmp$ret$0;
}
function updateReceiversCounterIfLower($this, value) {
  var tmp$ret$0;
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.d20_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    if (compare(cur, value) >= 0)
      return Unit_instance;
    if ($this.d20_1.atomicfu$compareAndSet(cur, value))
      return Unit_instance;
  }
  return tmp$ret$0;
}
function bindCancellationFunResult($this, $receiver) {
  return BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($this);
}
function onCancellationChannelResultImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.b20_1), ensureNotNull(ChannelResult__getOrNull_impl_f5e07h(element)), context);
}
function bindCancellationFun($this, $receiver, element) {
  return BufferedChannel$bindCancellationFun$lambda($receiver, element);
}
function bindCancellationFun_0($this, $receiver) {
  return BufferedChannel$onCancellationImplDoNotCall$ref($this);
}
function onCancellationImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.b20_1), element, context);
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) => {
    var tmp;
    if (!($element === get_CHANNEL_CLOSED())) {
      callUndeliveredElement(this$0.b20_1, $element, $select.od());
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
  return (select, _unused_var__etf5q3, element) => BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
}
function BufferedChannel$onCancellationChannelResultImplDoNotCall$ref(p0) {
  return constructCallableReference((p0_0, p1, p2) => {
    var tmp0 = p0;
    onCancellationChannelResultImplDoNotCall(tmp0, p0_0, p1.q21_1, p2);
    return Unit_instance;
  }, 3, 0, 10, 'onCancellationChannelResultImplDoNotCall', [p0]);
}
function BufferedChannel$bindCancellationFun$lambda($this_bindCancellationFun, $element) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, context) => {
    callUndeliveredElement($this_bindCancellationFun, $element, context);
    return Unit_instance;
  };
}
function BufferedChannel$onCancellationImplDoNotCall$ref(p0) {
  return constructCallableReference((p0_0, p1, p2) => {
    var tmp0 = p0;
    onCancellationImplDoNotCall(tmp0, p0_0, p1, p2);
    return Unit_instance;
  }, 3, 0, 11, 'onCancellationImplDoNotCall', [p0]);
}
function initialBufferEnd(capacity) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  switch (capacity) {
    case 0:
      return new Long(0, 0);
    case 2147483647:
      return new Long(-1, 2147483647);
    default:
      return fromInt(capacity);
  }
}
function tryResume0(_this__u8e3s4, value, onCancellation) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  _init_properties_BufferedChannel_kt__d6uc4y();
  // Inline function 'kotlin.let' call
  var token = _this__u8e3s4.w1q(value, null, onCancellation);
  var tmp;
  if (!(token == null)) {
    _this__u8e3s4.b1p(token);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function constructEBCompletedAndPauseFlag(counter, pauseEB) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(pauseEB ? new Long(0, 1073741824) : new Long(0, 0), counter);
}
function constructSendersAndCloseStatus(counter, closeStatus) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(shiftLeft(fromInt(closeStatus), 60), counter);
}
function createSegmentFunction() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return createSegment$ref();
}
function createSegment(id, prev) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return new ChannelSegment(id, prev, prev.q1z(), 0);
}
function createSegment$ref() {
  return constructCallableReference((p0, p1) => createSegment(p0, p1), 2, 0, 12, 'createSegment');
}
var properties_initialized_BufferedChannel_kt_58tjvw;
function _init_properties_BufferedChannel_kt__d6uc4y() {
  if (!properties_initialized_BufferedChannel_kt_58tjvw) {
    properties_initialized_BufferedChannel_kt_58tjvw = true;
    NULL_SEGMENT = new ChannelSegment(new Long(-1, -1), null, null, 0);
    SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
    EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
    BUFFERED = new Symbol('BUFFERED');
    IN_BUFFER = new Symbol('SHOULD_BUFFER');
    RESUMING_BY_RCV = new Symbol('S_RESUMING_BY_RCV');
    RESUMING_BY_EB = new Symbol('RESUMING_BY_EB');
    POISONED = new Symbol('POISONED');
    DONE_RCV = new Symbol('DONE_RCV');
    INTERRUPTED_SEND = new Symbol('INTERRUPTED_SEND');
    INTERRUPTED_RCV = new Symbol('INTERRUPTED_RCV');
    CHANNEL_CLOSED = new Symbol('CHANNEL_CLOSED');
    SUSPEND = new Symbol('SUSPEND');
    SUSPEND_NO_WAITER = new Symbol('SUSPEND_NO_WAITER');
    FAILED = new Symbol('FAILED');
    NO_RECEIVE_RESULT = new Symbol('NO_RECEIVE_RESULT');
    CLOSE_HANDLER_CLOSED = new Symbol('CLOSE_HANDLER_CLOSED');
    CLOSE_HANDLER_INVOKED = new Symbol('CLOSE_HANDLER_INVOKED');
    NO_CLOSE_CAUSE = new Symbol('NO_CLOSE_CAUSE');
  }
}
var Factory_instance;
function Factory_getInstance() {
  if (Factory_instance === VOID)
    new Factory();
  return Factory_instance;
}
function Channel_0(capacity, onBufferOverflow, onUndeliveredElement) {
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  var tmp;
  switch (capacity) {
    case 0:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    case -1:
      // Inline function 'kotlin.require' call

      if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
        var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
        throw IllegalArgumentException.h2(toString(message));
      }

      tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
      break;
    case 2147483647:
      tmp = new BufferedChannel(2147483647, onUndeliveredElement);
      break;
    case -2:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().i23_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    default:
      tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
      break;
  }
  return tmp;
}
function _ChannelResult___init__impl__siwsuf(holder) {
  return holder;
}
function _ChannelResult___get_holder__impl__pm9gzw($this) {
  return $this;
}
function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return !(tmp instanceof Failed);
}
function _ChannelResult___get_isFailure__impl__nz6ehu($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return tmp instanceof Failed;
}
function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return tmp instanceof Closed;
}
function ChannelResult__getOrNull_impl_f5e07h($this) {
  var tmp;
  var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (!(tmp_0 instanceof Failed)) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  } else {
    tmp = null;
  }
  return tmp;
}
function ChannelResult__getOrThrow_impl_od1axs($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (!(tmp instanceof Failed))
    return _ChannelResult___get_holder__impl__pm9gzw($this);
  var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (tmp_0 instanceof Closed) {
    // Inline function 'kotlin.check' call
    if (!!(_ChannelResult___get_holder__impl__pm9gzw($this).j23_1 == null)) {
      var message = "Trying to call 'getOrThrow' on a channel closed without a cause";
      throw IllegalStateException.o(toString(message));
    }
    throw _ChannelResult___get_holder__impl__pm9gzw($this).j23_1;
  }
  // Inline function 'kotlin.error' call
  var message_0 = "Trying to call 'getOrThrow' on a failed result of a non-closed channel";
  throw IllegalStateException.o(toString(message_0));
}
function ChannelResult__exceptionOrNull_impl_16ei30($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j23_1;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function ChannelResult__toString_impl_rrcqu7($this) {
  var tmp;
  if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this).toString();
  } else {
    tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
  }
  return tmp;
}
function ChannelResult__hashCode_impl_lilec2($this) {
  return $this == null ? 0 : hashCode($this);
}
function ChannelResult__equals_impl_f471ri($this, other) {
  if (!(other instanceof ChannelResult))
    return false;
  var tmp0_other_with_cast = other instanceof ChannelResult ? other.q21_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function cancelConsumed(_this__u8e3s4, cause) {
  var tmp;
  if (cause == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
    tmp = tmp0_elvis_lhs == null ? CancellationException_0('Channel was consumed, consumer had failed', cause) : tmp0_elvis_lhs;
  }
  _this__u8e3s4.n1n(tmp);
}
function trySendImpl($this, element, isSendOp) {
  return $this.b24_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : $this.m22(element);
}
function trySendDropLatest($this, element, isSendOp) {
  var result = protoOf(BufferedChannel).k22.call($this, element);
  if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
    return result;
  if (isSendOp) {
    var tmp0_safe_receiver = $this.b20_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  }
  return Companion_getInstance_0().m21(Unit_instance);
}
function produce(_this__u8e3s4, context, capacity, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  capacity = capacity === VOID ? 0 : capacity;
  return produce_0(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
}
function produce_0(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  onCompletion = onCompletion === VOID ? null : onCompletion;
  var channel = Channel_0(capacity, onBufferOverflow);
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = new ProducerCoroutine(newContext, channel);
  if (!(onCompletion == null)) {
    coroutine.g1n(onCompletion);
  }
  coroutine.r1m(start, coroutine, block);
  return coroutine;
}
function flow(block) {
  return new SafeFlow(block);
}
function *emitAll(_this__u8e3s4, channel, $completion) {
  return yield* emitAllImpl(_this__u8e3s4, channel, true, $completion);
}
function *emitAllImpl(_this__u8e3s4, channel, consume, $completion) {
  ensureActive_2(_this__u8e3s4);
  var cause = null;
  try {
    var _iterator__ex2g4s = channel.p1();
    while (yield* _iterator__ex2g4s.x21($completion)) {
      var element = _iterator__ex2g4s.r1();
      yield* _this__u8e3s4.k24(element, $completion);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cause = e;
      throw e;
    } else {
      throw $p;
    }
  }
  finally {
    if (consume) {
      cancelConsumed(channel, cause);
    }
  }
  return Unit_instance;
}
var NO_VALUE;
function fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
  _init_properties_SharedFlow_kt__umasnn();
  if ((capacity === 0 || capacity === -3) && onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
    return _this__u8e3s4;
  }
  return new ChannelFlowOperatorImpl(_this__u8e3s4, context, capacity, onBufferOverflow);
}
function _get_head__d7jo8b($this) {
  var tmp0 = $this.y24_1;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = $this.x24_1;
  return compare(tmp0, b) <= 0 ? tmp0 : b;
}
function _get_replaySize__dxgnb1($this) {
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.z24_1;
  var tmp$ret$0 = add(tmp0, fromInt(other));
  return convertToInt(subtract(tmp$ret$0, $this.x24_1));
}
function _get_totalSize__xhdb3o($this) {
  return $this.z24_1 + $this.a25_1 | 0;
}
function _get_bufferEndIndex__d2rk18($this) {
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.z24_1;
  return add(tmp0, fromInt(other));
}
function _get_queueEndIndex__4m025l($this) {
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.z24_1;
  var tmp0_0 = add(tmp0, fromInt(other));
  // Inline function 'kotlin.Long.plus' call
  var other_0 = $this.a25_1;
  return add(tmp0_0, fromInt(other_0));
}
function tryEmitLocked($this, value) {
  if ($this.c25_1 === 0)
    return tryEmitNoCollectorsLocked($this, value);
  if ($this.z24_1 >= $this.u24_1 && compare($this.y24_1, $this.x24_1) <= 0) {
    switch ($this.v24_1.w1_1) {
      case 0:
        return false;
      case 2:
        return true;
      case 1:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  enqueueLocked($this, value);
  $this.z24_1 = $this.z24_1 + 1 | 0;
  if ($this.z24_1 > $this.u24_1) {
    dropOldestLocked($this);
  }
  if (_get_replaySize__dxgnb1($this) > $this.t24_1) {
    // Inline function 'kotlin.Long.plus' call
    var this_0 = $this.x24_1;
    var tmp$ret$0 = add(this_0, fromInt(1));
    updateBufferLocked($this, tmp$ret$0, $this.y24_1, _get_bufferEndIndex__d2rk18($this), _get_queueEndIndex__4m025l($this));
  }
  return true;
}
function tryEmitNoCollectorsLocked($this, value) {
  // Inline function 'kotlinx.coroutines.assert' call
  if ($this.t24_1 === 0)
    return true;
  enqueueLocked($this, value);
  $this.z24_1 = $this.z24_1 + 1 | 0;
  if ($this.z24_1 > $this.t24_1) {
    dropOldestLocked($this);
  }
  var tmp = $this;
  var tmp0 = _get_head__d7jo8b($this);
  // Inline function 'kotlin.Long.plus' call
  var other = $this.z24_1;
  tmp.y24_1 = add(tmp0, fromInt(other));
  return true;
}
function dropOldestLocked($this) {
  setBufferAt(ensureNotNull($this.w24_1), _get_head__d7jo8b($this), null);
  $this.z24_1 = $this.z24_1 - 1 | 0;
  // Inline function 'kotlin.Long.plus' call
  var this_0 = _get_head__d7jo8b($this);
  var newHead = add(this_0, fromInt(1));
  if (compare($this.x24_1, newHead) < 0)
    $this.x24_1 = newHead;
  if (compare($this.y24_1, newHead) < 0) {
    correctCollectorIndexesOnDropOldest($this, newHead);
  }
  // Inline function 'kotlinx.coroutines.assert' call
}
function correctCollectorIndexesOnDropOldest($this, newHead) {
  $l$block: {
    // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
    if ($this.c25_1 === 0) {
      break $l$block;
    }
    var tmp0_safe_receiver = $this.b25_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element == null)) {
          if (compare(element.f25_1, new Long(0, 0)) >= 0 && compare(element.f25_1, newHead) < 0) {
            element.f25_1 = newHead;
          }
        }
      }
    }
  }
  $this.y24_1 = newHead;
}
function enqueueLocked($this, item) {
  var curSize = _get_totalSize__xhdb3o($this);
  var curBuffer = $this.w24_1;
  var buffer = curBuffer == null ? growBuffer($this, null, 0, 2) : curSize >= curBuffer.length ? growBuffer($this, curBuffer, curSize, imul(curBuffer.length, 2)) : curBuffer;
  // Inline function 'kotlin.Long.plus' call
  var this_0 = _get_head__d7jo8b($this);
  var tmp$ret$0 = add(this_0, fromInt(curSize));
  setBufferAt(buffer, tmp$ret$0, item);
}
function growBuffer($this, curBuffer, curSize, newSize) {
  // Inline function 'kotlin.check' call
  if (!(newSize > 0)) {
    var message = 'Buffer size overflow';
    throw IllegalStateException.o(toString(message));
  }
  // Inline function 'kotlin.arrayOfNulls' call
  // Inline function 'kotlin.also' call
  var this_0 = Array(newSize);
  $this.w24_1 = this_0;
  var newBuffer = this_0;
  if (curBuffer == null)
    return newBuffer;
  var head = _get_head__d7jo8b($this);
  var inductionVariable = 0;
  if (inductionVariable < curSize)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.Long.plus' call
      var tmp = add(head, fromInt(i));
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$6 = add(head, fromInt(i));
      setBufferAt(newBuffer, tmp, getBufferAt(curBuffer, tmp$ret$6));
    }
     while (inductionVariable < curSize);
  return newBuffer;
}
function updateBufferLocked($this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex) {
  // Inline function 'kotlin.comparisons.minOf' call
  var newHead = compare(newMinCollectorIndex, newReplayIndex) <= 0 ? newMinCollectorIndex : newReplayIndex;
  // Inline function 'kotlinx.coroutines.assert' call
  var inductionVariable = _get_head__d7jo8b($this);
  if (compare(inductionVariable, newHead) < 0)
    do {
      var index = inductionVariable;
      inductionVariable = add(inductionVariable, new Long(1, 0));
      setBufferAt(ensureNotNull($this.w24_1), index, null);
    }
     while (compare(inductionVariable, newHead) < 0);
  $this.x24_1 = newReplayIndex;
  $this.y24_1 = newMinCollectorIndex;
  $this.z24_1 = convertToInt(subtract(newBufferEndIndex, newHead));
  $this.a25_1 = convertToInt(subtract(newQueueEndIndex, newBufferEndIndex));
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
}
function tryPeekLocked($this, slot) {
  var index = slot.f25_1;
  if (compare(index, _get_bufferEndIndex__d2rk18($this)) < 0)
    return index;
  if ($this.u24_1 > 0)
    return new Long(-1, -1);
  if (compare(index, _get_head__d7jo8b($this)) > 0)
    return new Long(-1, -1);
  if ($this.a25_1 === 0)
    return new Long(-1, -1);
  return index;
}
function findSlotsToResumeLocked($this, resumesIn) {
  var resumes = resumesIn;
  var resumeCount = resumesIn.length;
  $l$block: {
    // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
    if ($this.c25_1 === 0) {
      break $l$block;
    }
    var tmp0_safe_receiver = $this.b25_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element == null)) {
          $l$block_1: {
            var tmp0_elvis_lhs = element.g25_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              break $l$block_1;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var cont = tmp;
            if (compare(tryPeekLocked($this, element), new Long(0, 0)) < 0) {
              break $l$block_1;
            }
            if (resumeCount >= resumes.length) {
              var tmp_0 = resumes;
              // Inline function 'kotlin.comparisons.maxOf' call
              var b = imul(2, resumes.length);
              var tmp$ret$4 = Math.max(2, b);
              resumes = copyOf(tmp_0, tmp$ret$4);
            }
            var tmp_1 = resumes;
            var _unary__edvuaz = resumeCount;
            resumeCount = _unary__edvuaz + 1 | 0;
            tmp_1[_unary__edvuaz] = cont;
            element.g25_1 = null;
          }
        }
      }
    }
  }
  return resumes;
}
function getBufferAt(_this__u8e3s4, index) {
  _init_properties_SharedFlow_kt__umasnn();
  return _this__u8e3s4[convertToInt(index) & (_this__u8e3s4.length - 1 | 0)];
}
function setBufferAt(_this__u8e3s4, index, item) {
  _init_properties_SharedFlow_kt__umasnn();
  return _this__u8e3s4[convertToInt(index) & (_this__u8e3s4.length - 1 | 0)] = item;
}
var properties_initialized_SharedFlow_kt_tmefor;
function _init_properties_SharedFlow_kt__umasnn() {
  if (!properties_initialized_SharedFlow_kt_tmefor) {
    properties_initialized_SharedFlow_kt_tmefor = true;
    NO_VALUE = new Symbol('NO_VALUE');
  }
}
function get_NONE() {
  _init_properties_StateFlow_kt__eu9yi5();
  return NONE;
}
var NONE;
function get_PENDING() {
  _init_properties_StateFlow_kt__eu9yi5();
  return PENDING;
}
var PENDING;
function MutableStateFlow(value) {
  _init_properties_StateFlow_kt__eu9yi5();
  return new StateFlowImpl(value == null ? get_NULL() : value);
}
function updateState($this, expectedState, newState) {
  var curSequence;
  var curSlots;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  var oldState = $this.l25_1.kotlinx$atomicfu$value;
  if (!(expectedState == null) && !equals(oldState, expectedState))
    return false;
  if (equals(oldState, newState))
    return true;
  $this.l25_1.kotlinx$atomicfu$value = newState;
  curSequence = $this.m25_1;
  if ((curSequence & 1) === 0) {
    curSequence = curSequence + 1 | 0;
    $this.m25_1 = curSequence;
  } else {
    $this.m25_1 = curSequence + 2 | 0;
    return true;
  }
  curSlots = $this.b25_1;
  while (true) {
    var tmp0_safe_receiver = curSlots;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element == null)
          null;
        else {
          element.o25();
        }
      }
    }
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    if ($this.m25_1 === curSequence) {
      $this.m25_1 = curSequence + 1 | 0;
      return true;
    }
    curSequence = $this.m25_1;
    curSlots = $this.b25_1;
  }
}
function fuseStateFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
  _init_properties_StateFlow_kt__eu9yi5();
  // Inline function 'kotlinx.coroutines.assert' call
  if (((0 <= capacity ? capacity <= 1 : false) || capacity === -2) && onBufferOverflow.equals(BufferOverflow_DROP_OLDEST_getInstance())) {
    return _this__u8e3s4;
  }
  return fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow);
}
var properties_initialized_StateFlow_kt_nsqikx;
function _init_properties_StateFlow_kt__eu9yi5() {
  if (!properties_initialized_StateFlow_kt_nsqikx) {
    properties_initialized_StateFlow_kt_nsqikx = true;
    NONE = new Symbol('NONE');
    PENDING = new Symbol('PENDING');
  }
}
function get_EMPTY_RESUMES() {
  _init_properties_AbstractSharedFlow_kt__h2xygb();
  return EMPTY_RESUMES;
}
var EMPTY_RESUMES;
var properties_initialized_AbstractSharedFlow_kt_2mpafr;
function _init_properties_AbstractSharedFlow_kt__h2xygb() {
  if (!properties_initialized_AbstractSharedFlow_kt_2mpafr) {
    properties_initialized_AbstractSharedFlow_kt_2mpafr = true;
    // Inline function 'kotlin.arrayOfNulls' call
    EMPTY_RESUMES = Array(0);
  }
}
function *collectWithContextUndispatched($this, collector, newContext, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.od();
  var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
  return yield* withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda($this), $completion);
}
function ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.h27(it, $completion);
    return Unit_instance;
  }, 1);
}
function ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.i27(it, $completion);
    return Unit_instance;
  }, 1);
}
function ChannelFlow$collect$slambda($collector, this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    yield* emitAll($collector, this$0.o27($this$coroutineScope), $completion);
    return Unit_instance;
  }, 1);
}
function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof SendingCollector) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof NopCollector;
  }
  if (tmp_0) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new UndispatchedContextCollector(_this__u8e3s4, emitContext);
  }
  return tmp;
}
function *withContextUndispatched(newContext, value, countOrElement, block, $completion) {
  countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    var tmp0 = block;
    var tmp2 = value;
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new StackFrameContinuation(uCont, newContext);
    return startCoroutineUninterceptedOrReturnGeneratorVersion(tmp0, tmp2, completion);
  };
}
function UndispatchedContextCollector$emitRef$slambda($downstream) {
  return constructCallableReference(function *(it, $completion) {
    yield* $downstream.k24(it, $completion);
    return Unit_instance;
  }, 1);
}
function *combineInternal(_this__u8e3s4, flows, arrayFactory, transform, $completion) {
  return yield* flowScope(combineInternal$slambda(flows, arrayFactory, transform, _this__u8e3s4), $completion);
}
function combineInternal$slambda$slambda$slambda($resultChannel, $i) {
  return constructCallableReference(function *(value, $completion) {
    yield* $resultChannel.j22(new IndexedValue($i, value), $completion);
    yield* yield_0($completion);
    return Unit_instance;
  }, 1);
}
function combineInternal$slambda$slambda($flows, $i, $nonClosed, $resultChannel) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var tmp_0 = $flows[$i];
      var tmp_1 = combineInternal$slambda$slambda$slambda($resultChannel, $i);
      tmp = yield* tmp_0.j24(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), $completion);
    }finally {
      if ($nonClosed.x27() === 0) {
        $resultChannel.y22();
      }
    }
    return Unit_instance;
  }, 1);
}
function combineInternal$slambda($flows, $arrayFactory, $transform, $this_combineInternal) {
  return constructCallableReference(function *($this$flowScope, $completion) {
    var size = $flows.length;
    var tmp;
    if (size === 0) {
      return Unit_instance;
    }
    // Inline function 'kotlin.arrayOfNulls' call
    var latestValues = Array(size);
    fill(latestValues, get_UNINITIALIZED());
    var resultChannel = Channel_0(size);
    var nonClosed = new LocalAtomicInt(size);
    var remainingAbsentValues = size;
    var inductionVariable = 0;
    var tmp_0;
    if (inductionVariable < size) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        launch($this$flowScope, VOID, VOID, combineInternal$slambda$slambda($flows, i, nonClosed, resultChannel));
      }
       while (inductionVariable < size);
      tmp_0 = Unit_instance;
    }
    var lastReceivedEpoch = new Int8Array(size);
    var currentEpoch = 0;
    $l$loop: while (true) {
      currentEpoch = numberToByte(currentEpoch + 1);
      var tmp0_elvis_lhs = ChannelResult__getOrNull_impl_f5e07h((yield* resultChannel.o22($completion)).q21_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var element = tmp_1;
      $l$loop_1: while (true) {
        var index = element.hm_1;
        var previous = latestValues[index];
        latestValues[index] = element.im_1;
        if (previous === get_UNINITIALIZED()) {
          remainingAbsentValues = remainingAbsentValues - 1 | 0;
        }
        if (lastReceivedEpoch[index] === currentEpoch)
          break $l$loop_1;
        lastReceivedEpoch[index] = currentEpoch;
        var tmp1_elvis_lhs = ChannelResult__getOrNull_impl_f5e07h(resultChannel.p22());
        var tmp_2;
        if (tmp1_elvis_lhs == null) {
          break $l$loop_1;
        } else {
          tmp_2 = tmp1_elvis_lhs;
        }
        element = tmp_2;
      }
      if (remainingAbsentValues === 0) {
        var results = $arrayFactory();
        if (results == null) {
          yield* $transform($this_combineInternal, isArray(latestValues) ? latestValues : THROW_CCE(), $completion);
        } else {
          // Inline function 'kotlin.collections.copyInto' call
          var this_0 = isArray(latestValues) ? latestValues : THROW_CCE();
          var endIndex = this_0.length;
          arrayCopy(this_0, results, 0, 0, endIndex);
          yield* $transform($this_combineInternal, (!(results == null) ? isArray(results) : false) ? results : THROW_CCE(), $completion);
        }
      }
    }
    return Unit_instance;
  }, 1);
}
function *flowScope(block, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var coroutine = new FlowCoroutine(uCont.od(), uCont);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  };
}
function checkOwnership(_this__u8e3s4, owner) {
  if (!(_this__u8e3s4.g28_1 === owner))
    throw _this__u8e3s4;
}
function ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, $value) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* this$0.n28_1($collector, $value, $completion);
    return Unit_instance;
  }, 1);
}
function ChannelFlowTransformLatest$flowCollect$slambda$slambda($previousFlow, $this_coroutineScope, this$0, $collector) {
  return constructCallableReference(function *(value, $completion) {
    var tmp0_safe_receiver = $previousFlow._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      tmp0_safe_receiver.n1n(ChildCancelledException.t28());
      yield* tmp0_safe_receiver.k1n($completion);
    }
    var tmp = CoroutineStart_UNDISPATCHED_getInstance();
    $previousFlow._v = launch($this_coroutineScope, VOID, tmp, ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, value));
    return Unit_instance;
  }, 1);
}
function ChannelFlowTransformLatest$flowCollect$slambda(this$0, $collector) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var previousFlow = {_v: null};
    var tmp = ChannelFlowTransformLatest$flowCollect$slambda$slambda(previousFlow, $this$coroutineScope, this$0, $collector);
    yield* this$0.g27_1.j24(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp), $completion);
    return Unit_instance;
  }, 1);
}
var NopCollector_instance;
function NopCollector_getInstance() {
  return NopCollector_instance;
}
function get_NULL() {
  _init_properties_NullSurrogate_kt__n2yti9();
  return NULL;
}
var NULL;
function get_UNINITIALIZED() {
  _init_properties_NullSurrogate_kt__n2yti9();
  return UNINITIALIZED;
}
var UNINITIALIZED;
var DONE;
var properties_initialized_NullSurrogate_kt_39v8bl;
function _init_properties_NullSurrogate_kt__n2yti9() {
  if (!properties_initialized_NullSurrogate_kt_39v8bl) {
    properties_initialized_NullSurrogate_kt_39v8bl = true;
    NULL = new Symbol('NULL');
    UNINITIALIZED = new Symbol('UNINITIALIZED');
    DONE = new Symbol('DONE');
  }
}
function checkContext(_this__u8e3s4, currentContext) {
  var result = currentContext.dp(0, checkContext$lambda(_this__u8e3s4));
  if (!(result === _this__u8e3s4.n24_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Flow invariant is violated:\n' + ('\t\tFlow was collected in ' + toString(_this__u8e3s4.m24_1) + ',\n') + ('\t\tbut emission happened in ' + toString(currentContext) + '.\n') + "\t\tPlease refer to 'flow' documentation or use 'flowOn' instead";
    throw IllegalStateException.o(toString(message));
  }
}
function transitiveCoroutineParent(_this__u8e3s4, collectJob) {
  var $this = _this__u8e3s4;
  var collectJob_0 = collectJob;
  $l$1: do {
    $l$0: do {
      if ($this === null)
        return null;
      if ($this === collectJob_0)
        return $this;
      if (!($this instanceof ScopeCoroutine))
        return $this;
      var tmp0 = $this.x1m();
      var tmp1 = collectJob_0;
      $this = tmp0;
      collectJob_0 = tmp1;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function checkContext$lambda($this_checkContext) {
  return (count, element) => {
    var key = element.j3();
    var collectElement = $this_checkContext.m24_1.ae(key);
    var tmp;
    if (!(key === Key_instance_3)) {
      return !(element === collectElement) ? -2147483648 : count + 1 | 0;
    }
    var collectJob = (collectElement == null ? true : isInterface(collectElement, Job)) ? collectElement : THROW_CCE();
    var emissionParentJob = transitiveCoroutineParent(isInterface(element, Job) ? element : THROW_CCE(), collectJob);
    var tmp_0;
    if (!(emissionParentJob === collectJob)) {
      // Inline function 'kotlin.error' call
      var message = 'Flow invariant is violated:\n\t\tEmission from another coroutine is detected.\n' + ('\t\tChild of ' + toString_0(emissionParentJob) + ', expected child of ' + toString_0(collectJob) + '.\n') + '\t\tFlowCollector is not thread-safe and concurrent emissions are prohibited.\n' + "\t\tTo mitigate this restriction please use 'channelFlow' builder instead of 'flow'";
      throw IllegalStateException.o(toString(message));
    }
    return collectJob == null ? count : count + 1 | 0;
  };
}
function buffer(_this__u8e3s4, capacity, onBufferOverflow) {
  capacity = capacity === VOID ? -2 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  // Inline function 'kotlin.require' call
  if (!(capacity >= 0 || capacity === -2 || capacity === -1)) {
    var message = 'Buffer size should be non-negative, BUFFERED, or CONFLATED, but was ' + capacity;
    throw IllegalArgumentException.h2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(!(capacity === -1) || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
    var message_0 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
    throw IllegalArgumentException.h2(toString(message_0));
  }
  var capacity_0 = capacity;
  var onBufferOverflow_0 = onBufferOverflow;
  if (capacity_0 === -1) {
    capacity_0 = 0;
    onBufferOverflow_0 = BufferOverflow_DROP_OLDEST_getInstance();
  }
  var tmp;
  if (isInterface(_this__u8e3s4, FusibleFlow)) {
    tmp = _this__u8e3s4.d26(VOID, capacity_0, onBufferOverflow_0);
  } else {
    tmp = new ChannelFlowOperatorImpl(_this__u8e3s4, VOID, capacity_0, onBufferOverflow_0);
  }
  return tmp;
}
function ensureActive_2(_this__u8e3s4) {
  if (_this__u8e3s4 instanceof ThrowingCollector)
    throw _this__u8e3s4.x28_1;
}
var DEFAULT_CONCURRENCY;
function mapLatest(_this__u8e3s4, transform) {
  _init_properties_Merge_kt__cbpr96();
  return transformLatest(_this__u8e3s4, mapLatest$slambda(transform));
}
function transformLatest(_this__u8e3s4, transform) {
  _init_properties_Merge_kt__cbpr96();
  return new ChannelFlowTransformLatest(transform, _this__u8e3s4);
}
function mapLatest$slambda($transform) {
  return constructCallableReference(function *($this$transformLatest, it, $completion) {
    yield* $this$transformLatest.k24(yield* $transform(it, $completion), $completion);
    return Unit_instance;
  }, 2);
}
var properties_initialized_Merge_kt_dhn6vs;
function _init_properties_Merge_kt__cbpr96() {
  if (!properties_initialized_Merge_kt_dhn6vs) {
    properties_initialized_Merge_kt_dhn6vs = true;
    DEFAULT_CONCURRENCY = systemProp('kotlinx.coroutines.flow.defaultConcurrency', 16, 1, 2147483647);
  }
}
function combine(flow, flow2, transform) {
  return combine_0(flow, flow2, transform);
}
function combine_0(_this__u8e3s4, flow, transform) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new combine$$inlined$unsafeFlow$1(_this__u8e3s4, flow, transform);
}
function nullArrayFactory() {
  return nullArrayFactory$lambda;
}
function combine$o$collect$slambda($transform) {
  return constructCallableReference(function *($this$combineInternal, it, $completion) {
    yield* $this$combineInternal.k24(yield* $transform(it[0], it[1], $completion), $completion);
    return Unit_instance;
  }, 2);
}
function nullArrayFactory$lambda() {
  return null;
}
function *collectLatest(_this__u8e3s4, action, $completion) {
  yield* collect(buffer(mapLatest(_this__u8e3s4, action), 0), $completion);
  return Unit_instance;
}
function *collect(_this__u8e3s4, $completion) {
  return yield* _this__u8e3s4.j24(NopCollector_instance, $completion);
}
function *first(_this__u8e3s4, predicate, $completion) {
  var result = {_v: get_NULL()};
  // Inline function 'kotlinx.coroutines.flow.collectWhile' call
  var collector = new first$$inlined$collectWhile$1(predicate, result);
  try {
    yield* _this__u8e3s4.j24(collector, $completion);
  } catch ($p) {
    if ($p instanceof AbortFlowException) {
      var e = $p;
      checkOwnership(e, collector);
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$1 = $completion.od();
      ensureActive_0(tmp$ret$1);
    } else {
      throw $p;
    }
  }
  if (result._v === get_NULL())
    throw NoSuchElementException.a2('Expected at least one element matching the predicate');
  return result._v;
}
function *first_0(_this__u8e3s4, $completion) {
  var result = {_v: get_NULL()};
  // Inline function 'kotlinx.coroutines.flow.collectWhile' call
  var collector = new first$$inlined$collectWhile$2(result);
  try {
    yield* _this__u8e3s4.j24(collector, $completion);
  } catch ($p) {
    if ($p instanceof AbortFlowException) {
      var e = $p;
      checkOwnership(e, collector);
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$1 = $completion.od();
      ensureActive_0(tmp$ret$1);
    } else {
      throw $p;
    }
  }
  if (result._v === get_NULL())
    throw NoSuchElementException.a2('Expected at least one element');
  return result._v;
}
function set_value(_this__u8e3s4, value) {
  return _this__u8e3s4.g29(value);
}
function get_value(_this__u8e3s4) {
  return _this__u8e3s4.a1v();
}
function get_CLOSED() {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  return CLOSED;
}
var CLOSED;
function close(_this__u8e3s4) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this_0);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return cur;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (next === null) {
      if (cur.z20())
        return cur;
    } else {
      cur = next;
    }
  }
}
function _SegmentOrClosed___init__impl__jnexvb(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
  return _get_value__a43j40($this) === get_CLOSED();
}
function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
  var tmp;
  if (_get_value__a43j40($this) === get_CLOSED()) {
    // Inline function 'kotlin.error' call
    var message = 'Does not contain segment';
    throw IllegalStateException.o(toString(message));
  } else {
    var tmp_0 = _get_value__a43j40($this);
    tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
  }
  return tmp;
}
function SegmentOrClosed__toString_impl_pzb2an($this) {
  return 'SegmentOrClosed(value=' + toString_0($this) + ')';
}
function SegmentOrClosed__hashCode_impl_4855hs($this) {
  return $this == null ? 0 : hashCode($this);
}
function SegmentOrClosed__equals_impl_6erq1g($this, other) {
  if (!(other instanceof SegmentOrClosed))
    return false;
  var tmp0_other_with_cast = other instanceof SegmentOrClosed ? other.i22_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _get_nextOrClosed__w0gmuv($this) {
  return $this.s20_1.kotlinx$atomicfu$value;
}
function _get_aliveSegmentLeft__mr4ndu($this) {
  var cur = $this.x20();
  while (!(cur === null) && cur.p20())
    cur = cur.t20_1.kotlinx$atomicfu$value;
  return cur;
}
function _get_aliveSegmentRight__7ulr0b($this) {
  // Inline function 'kotlinx.coroutines.assert' call
  var cur = ensureNotNull($this.u20());
  while (cur.p20()) {
    var tmp0_elvis_lhs = cur.u20();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return cur;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    cur = tmp;
  }
  return cur;
}
function access$_get_nextOrClosed__ywzond($this) {
  return _get_nextOrClosed__w0gmuv($this);
}
function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  $l$loop: while (compare(cur.r1r_1, id) < 0 || cur.p20()) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this_0);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (!(next == null)) {
      cur = next;
      continue $l$loop;
    }
    // Inline function 'kotlin.Long.plus' call
    var this_1 = cur.r1r_1;
    var newTail = createNewSegment(add(this_1, fromInt(1)), cur);
    if (cur.v20(newTail)) {
      if (cur.p20()) {
        cur.s7();
      }
      cur = newTail;
    }
  }
  return _SegmentOrClosed___init__impl__jnexvb(cur);
}
function access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy() {
  return get_CLOSED();
}
var properties_initialized_ConcurrentLinkedList_kt_kwt434;
function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
  if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
    properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
    CLOSED = new Symbol('CLOSED');
  }
}
function handleUncaughtCoroutineException(context, exception) {
  var _iterator__ex2g4s = get_platformExceptionHandlers().p1();
  while (_iterator__ex2g4s.q1()) {
    var handler = _iterator__ex2g4s.r1();
    try {
      handler.y1t(context, exception);
    } catch ($p) {
      if ($p instanceof ExceptionSuccessfullyProcessed) {
        var _unused_var__etf5q3 = $p;
        return Unit_instance;
      } else {
        if ($p instanceof Error) {
          var t = $p;
          propagateExceptionFinalResort(handlerException(exception, t));
        } else {
          throw $p;
        }
      }
    }
  }
  try {
    addSuppressed(exception, DiagnosticCoroutineContextException.k29(context));
  } catch ($p_0) {
    if ($p_0 instanceof Error) {
      var e = $p_0;
    } else {
      throw $p_0;
    }
  }
  propagateExceptionFinalResort(exception);
}
function get_UNDEFINED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return UNDEFINED;
}
var UNDEFINED;
function get_REUSABLE_CLAIMED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return REUSABLE_CLAIMED;
}
var REUSABLE_CLAIMED;
function resumeCancellableWith(_this__u8e3s4, result) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp;
  if (_this__u8e3s4 instanceof DispatchedContinuation) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith' call
    var state = toState_0(result);
    if (safeIsDispatchNeeded(_this__u8e3s4.e1r_1, _this__u8e3s4.od())) {
      _this__u8e3s4.g1r_1 = state;
      _this__u8e3s4.n1r_1 = 1;
      safeDispatch(_this__u8e3s4.e1r_1, _this__u8e3s4.od(), _this__u8e3s4);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().y1u();
        if (false && eventLoop.t1u()) {
          break $l$block;
        }
        var tmp_0;
        if (eventLoop.s1u()) {
          _this__u8e3s4.g1r_1 = state;
          _this__u8e3s4.n1r_1 = 1;
          eventLoop.r1u(_this__u8e3s4);
          tmp_0 = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.u1u(true);
          try {
            var tmp$ret$5;
            $l$block_0: {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
              var job = _this__u8e3s4.od().ae(Key_instance_3);
              if (!(job == null) && !job.e1m()) {
                var cause = job.d1n();
                _this__u8e3s4.k1s(state, cause);
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(cause));
                _this__u8e3s4.qd(tmp$ret$7);
                tmp$ret$5 = true;
                break $l$block_0;
              }
              tmp$ret$5 = false;
            }
            if (!tmp$ret$5) {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
              _this__u8e3s4.f1r_1;
              // Inline function 'kotlinx.coroutines.withContinuationContext' call
              _this__u8e3s4.h1r_1;
              _this__u8e3s4.f1r_1.qd(result);
            }
            $l$loop: while (eventLoop.q1u()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              _this__u8e3s4.d1t(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.v1u(true);
          }
          tmp_0 = false;
        }
      }
    }
    tmp = Unit_instance;
  } else {
    _this__u8e3s4.qd(result);
    tmp = Unit_instance;
  }
  return tmp;
}
function _get_reusableCancellableContinuation__9qex09($this) {
  var tmp = $this.i1r_1.kotlinx$atomicfu$value;
  return tmp instanceof CancellableContinuationImpl ? tmp : null;
}
function safeDispatch(_this__u8e3s4, context, runnable) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    _this__u8e3s4.s1t(context, runnable);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw DispatchException.m29(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function safeIsDispatchNeeded(_this__u8e3s4, context) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    return _this__u8e3s4.r1t(context);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw DispatchException.m29(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function yieldUndispatched(_this__u8e3s4) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
    // Inline function 'kotlinx.coroutines.assert' call
    var eventLoop = ThreadLocalEventLoop_getInstance().y1u();
    if (true && eventLoop.t1u()) {
      tmp$ret$0 = false;
      break $l$block;
    }
    var tmp;
    if (eventLoop.s1u()) {
      _this__u8e3s4.g1r_1 = Unit_instance;
      _this__u8e3s4.n1r_1 = 1;
      eventLoop.r1u(_this__u8e3s4);
      tmp = true;
    } else {
      // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
      eventLoop.u1u(true);
      try {
        _this__u8e3s4.c1t();
        $l$loop: while (eventLoop.q1u()) {
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          _this__u8e3s4.d1t(e);
        } else {
          throw $p;
        }
      }
      finally {
        eventLoop.v1u(true);
      }
      tmp = false;
    }
    tmp$ret$0 = tmp;
  }
  return tmp$ret$0;
}
var properties_initialized_DispatchedContinuation_kt_2siadq;
function _init_properties_DispatchedContinuation_kt__tnmqc0() {
  if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
    properties_initialized_DispatchedContinuation_kt_2siadq = true;
    UNDEFINED = new Symbol('UNDEFINED');
    REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  }
}
function get_isReusableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 2;
}
function get_isCancellableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
}
function dispatch(_this__u8e3s4, mode) {
  // Inline function 'kotlinx.coroutines.assert' call
  var delegate = _this__u8e3s4.i1s();
  var undispatched = mode === 4;
  var tmp;
  var tmp_0;
  if (!undispatched) {
    tmp_0 = delegate instanceof DispatchedContinuation;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.n1r_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    var dispatcher = delegate.e1r_1;
    var context = delegate.od();
    if (safeIsDispatchNeeded(dispatcher, context)) {
      safeDispatch(dispatcher, context, _this__u8e3s4);
    } else {
      resumeUnconfined(_this__u8e3s4);
    }
  } else {
    resume(_this__u8e3s4, delegate, undispatched);
  }
}
function resumeUnconfined(_this__u8e3s4) {
  var eventLoop = ThreadLocalEventLoop_getInstance().y1u();
  if (eventLoop.s1u()) {
    eventLoop.r1u(_this__u8e3s4);
  } else {
    // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
    eventLoop.u1u(true);
    try {
      resume(_this__u8e3s4, _this__u8e3s4.i1s(), true);
      $l$loop: while (eventLoop.q1u()) {
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        _this__u8e3s4.d1t(e);
      } else {
        throw $p;
      }
    }
    finally {
      eventLoop.v1u(true);
    }
  }
}
function resume(_this__u8e3s4, delegate, undispatched) {
  var state = _this__u8e3s4.j1s();
  var exception = _this__u8e3s4.a1t(state);
  var tmp;
  if (!(exception == null)) {
    // Inline function 'kotlin.Companion.failure' call
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = _this__u8e3s4.q1s(state);
    tmp = _Result___init__impl__xyqfz8(value);
  }
  var result = tmp;
  if (undispatched) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
    var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
    this_0.f1r_1;
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    this_0.h1r_1;
    this_0.f1r_1.qd(result);
  } else {
    delegate.qd(result);
  }
}
function _InlineList___init__impl__z8n56(holder) {
  holder = holder === VOID ? null : holder;
  return holder;
}
function _get_holder__f6h5pd($this) {
  return $this;
}
function InlineList__plus_impl_nuetvo($this, element) {
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_subject = _get_holder__f6h5pd($this);
  var tmp;
  if (tmp0_subject == null) {
    tmp = _InlineList___init__impl__z8n56(element);
  } else {
    if (tmp0_subject instanceof ArrayList) {
      var tmp_0 = _get_holder__f6h5pd($this);
      (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).d2(element);
      tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
    } else {
      var list = ArrayList.n2(4);
      list.d2(_get_holder__f6h5pd($this));
      list.d2(element);
      tmp = _InlineList___init__impl__z8n56(list);
    }
  }
  return tmp;
}
function access$_get_holder__kkflen($this) {
  return _get_holder__f6h5pd($this);
}
function callUndeliveredElement(_this__u8e3s4, element, context) {
  var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    handleCoroutineException(context, tmp0_safe_receiver);
  }
}
function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
  undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
  try {
    _this__u8e3s4(element);
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) {
        addSuppressed(undeliveredElementException, ex);
      } else {
        return UndeliveredElementException.q29('Exception in undelivered element handler for ' + toString_0(element), ex);
      }
    } else {
      throw $p;
    }
  }
  return undeliveredElementException;
}
function systemProp(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? 1 : minValue;
  maxValue = maxValue === VOID ? 2147483647 : maxValue;
  return convertToInt(systemProp_0(propertyName, fromInt(defaultValue), fromInt(minValue), fromInt(maxValue)));
}
function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? new Long(1, 0) : minValue;
  maxValue = maxValue === VOID ? new Long(-1, 2147483647) : maxValue;
  var tmp0_elvis_lhs = systemProp_1(propertyName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return defaultValue;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var value = tmp;
  var tmp1_elvis_lhs = toLongOrNull(value);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
    throw IllegalStateException.o(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parsed = tmp_0;
  if (!(compare(minValue, parsed) <= 0 ? compare(parsed, maxValue) <= 0 : false)) {
    // Inline function 'kotlin.error' call
    var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + '..' + maxValue.toString() + ", but is '" + parsed.toString() + "'";
    throw IllegalStateException.o(toString(message_0));
  }
  return parsed;
}
function startCoroutineCancellable(_this__u8e3s4, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUninterceptedGeneratorVersion_0(_this__u8e3s4, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$2);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startCoroutineCancellable_0(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUninterceptedGeneratorVersion(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$2);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startCoroutineCancellable_1(_this__u8e3s4, fatalCompletion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(_this__u8e3s4);
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$2);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(fatalCompletion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function dispatcherFailure(completion, e) {
  var tmp;
  if (e instanceof DispatchException) {
    tmp = e.w1t_1;
  } else {
    tmp = e;
  }
  var reportException = tmp;
  // Inline function 'kotlin.Companion.failure' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(reportException));
  completion.qd(tmp$ret$0);
  throw reportException;
}
function startUndispatchedOrReturn(_this__u8e3s4, receiver, block) {
  return startUndspatched(_this__u8e3s4, true, receiver, block);
}
function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
  var actualCompletion = completion;
  var tmp;
  try {
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    actualCompletion.od();
    // Inline function 'kotlinx.coroutines.internal.probeCoroutineResumed' call
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      var tmp_1;
      if (e instanceof DispatchException) {
        tmp_1 = e.w1t_1;
      } else {
        tmp_1 = e;
      }
      var reportException = tmp_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$6 = _Result___init__impl__xyqfz8(createFailure(reportException));
      actualCompletion.qd(tmp$ret$6);
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  var value = tmp;
  if (!(value === get_COROUTINE_SUSPENDED())) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$8 = _Result___init__impl__xyqfz8(value);
    actualCompletion.qd(tmp$ret$8);
  }
}
function startUndispatchedOrReturnIgnoreTimeout(_this__u8e3s4, receiver, block) {
  return startUndspatched(_this__u8e3s4, false, receiver, block);
}
function startUndspatched(_this__u8e3s4, alwaysRethrow, receiver, block) {
  var tmp;
  try {
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(block, receiver, _this__u8e3s4);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof DispatchException) {
      var e = $p;
      dispatchExceptionAndMakeCompleting(_this__u8e3s4, e);
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        tmp_0 = new CompletedExceptionally(e_0);
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  }
  var result = tmp;
  if (result === get_COROUTINE_SUSPENDED())
    return get_COROUTINE_SUSPENDED();
  var state = _this__u8e3s4.m1m(result);
  if (state === get_COMPLETING_WAITING_CHILDREN())
    return get_COROUTINE_SUSPENDED();
  _this__u8e3s4.v1q();
  var tmp_1;
  if (state instanceof CompletedExceptionally) {
    var tmp_2;
    if (alwaysRethrow || notOwnTimeout(_this__u8e3s4, state.j1m_1)) {
      throw recoverStackTrace(state.j1m_1, _this__u8e3s4.u1q_1);
    } else {
      if (result instanceof CompletedExceptionally) {
        throw recoverStackTrace(result.j1m_1, _this__u8e3s4.u1q_1);
      } else {
        tmp_2 = result;
      }
    }
    tmp_1 = tmp_2;
  } else {
    tmp_1 = unboxState(state);
  }
  return tmp_1;
}
function dispatchExceptionAndMakeCompleting(_this__u8e3s4, e) {
  _this__u8e3s4.v1n(new CompletedExceptionally(e.w1t_1));
  throw recoverStackTrace(e.w1t_1, _this__u8e3s4.u1q_1);
}
function notOwnTimeout(_this__u8e3s4, cause) {
  var tmp;
  if (!(cause instanceof TimeoutCancellationException)) {
    tmp = true;
  } else {
    tmp = !(cause.v1y_1 === _this__u8e3s4);
  }
  return tmp;
}
var DUMMY_PROCESS_RESULT_FUNCTION;
function get_STATE_REG() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_REG;
}
var STATE_REG;
function get_STATE_COMPLETED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_COMPLETED;
}
var STATE_COMPLETED;
function get_STATE_CANCELLED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_CANCELLED;
}
var STATE_CANCELLED;
function get_NO_RESULT() {
  _init_properties_Select_kt__zhm2jg();
  return NO_RESULT;
}
var NO_RESULT;
var PARAM_CLAUSE_0;
function trySelectInternal($this, clauseObject, internalResult) {
  $l$loop: while (true) {
    var curState = $this.t21_1.kotlinx$atomicfu$value;
    if (isInterface(curState, CancellableContinuation)) {
      var tmp0_elvis_lhs = findClause($this, clauseObject);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var clause = tmp;
      var onCancellation = clause.x29($this, internalResult);
      if ($this.t21_1.atomicfu$compareAndSet(curState, clause)) {
        var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
        $this.v21_1 = internalResult;
        if (tryResume_1(cont, onCancellation))
          return 0;
        $this.v21_1 = get_NO_RESULT();
        return 2;
      }
    } else {
      var tmp_0;
      if (equals(curState, get_STATE_COMPLETED())) {
        tmp_0 = true;
      } else {
        tmp_0 = curState instanceof ClauseData;
      }
      if (tmp_0)
        return 3;
      else {
        if (equals(curState, get_STATE_CANCELLED()))
          return 2;
        else {
          if (equals(curState, get_STATE_REG())) {
            if ($this.t21_1.atomicfu$compareAndSet(curState, listOf_0(clauseObject)))
              return 1;
          } else {
            if (isInterface(curState, KtList)) {
              if ($this.t21_1.atomicfu$compareAndSet(curState, plus_0(curState, clauseObject)))
                return 1;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected state: ' + toString(curState);
              throw IllegalStateException.o(toString(message));
            }
          }
        }
      }
    }
  }
}
function findClause($this, clauseObject) {
  var tmp0_elvis_lhs = $this.u21_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var clauses = tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = clauses.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element.u29_1 === clauseObject) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Clause with object ' + toString(clauseObject) + ' is not found';
    throw IllegalStateException.o(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
var TrySelectDetailedResult_SUCCESSFUL_instance;
var TrySelectDetailedResult_REREGISTER_instance;
var TrySelectDetailedResult_CANCELLED_instance;
var TrySelectDetailedResult_ALREADY_SELECTED_instance;
var TrySelectDetailedResult_entriesInitialized;
function TrySelectDetailedResult_initEntries() {
  if (TrySelectDetailedResult_entriesInitialized)
    return Unit_instance;
  TrySelectDetailedResult_entriesInitialized = true;
  TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult('SUCCESSFUL', 0);
  TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult('REREGISTER', 1);
  TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult('CANCELLED', 2);
  TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult('ALREADY_SELECTED', 3);
}
function TrySelectDetailedResult_0(trySelectInternalResult) {
  _init_properties_Select_kt__zhm2jg();
  var tmp;
  switch (trySelectInternalResult) {
    case 0:
      tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
      break;
    case 1:
      tmp = TrySelectDetailedResult_REREGISTER_getInstance();
      break;
    case 2:
      tmp = TrySelectDetailedResult_CANCELLED_getInstance();
      break;
    case 3:
      tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Unexpected internal result: ' + trySelectInternalResult;
      throw IllegalStateException.o(toString(message));
  }
  return tmp;
}
function tryResume_1(_this__u8e3s4, onCancellation) {
  _init_properties_Select_kt__zhm2jg();
  var tmp0_elvis_lhs = _this__u8e3s4.w1q(Unit_instance, null, onCancellation);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var token = tmp;
  _this__u8e3s4.b1p(token);
  return true;
}
function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
  _init_properties_Select_kt__zhm2jg();
  return null;
}
function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_SUCCESSFUL_instance;
}
function TrySelectDetailedResult_REREGISTER_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_REREGISTER_instance;
}
function TrySelectDetailedResult_CANCELLED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_CANCELLED_instance;
}
function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_ALREADY_SELECTED_instance;
}
var properties_initialized_Select_kt_7rpl36;
function _init_properties_Select_kt__zhm2jg() {
  if (!properties_initialized_Select_kt_7rpl36) {
    properties_initialized_Select_kt_7rpl36 = true;
    DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
    STATE_REG = new Symbol('STATE_REG');
    STATE_COMPLETED = new Symbol('STATE_COMPLETED');
    STATE_CANCELLED = new Symbol('STATE_CANCELLED');
    NO_RESULT = new Symbol('NO_RESULT');
    PARAM_CLAUSE_0 = new Symbol('PARAM_CLAUSE_0');
  }
}
function get_NO_OWNER() {
  _init_properties_Mutex_kt__jod56b();
  return NO_OWNER;
}
var NO_OWNER;
var ON_LOCK_ALREADY_LOCKED_BY_OWNER;
function Mutex(locked) {
  locked = locked === VOID ? false : locked;
  _init_properties_Mutex_kt__jod56b();
  return new MutexImpl(locked);
}
function MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this$0, this$1) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) => {
    // Inline function 'kotlinx.coroutines.assert' call
    this$0.f2a_1.kotlinx$atomicfu$value = this$1.i2a_1;
    this$0.k2a(this$1.i2a_1);
    return Unit_instance;
  };
}
function MutexImpl$CancellableContinuationWithOwner$resume$lambda(this$0, this$1) {
  return (it) => {
    this$0.k2a(this$1.i2a_1);
    return Unit_instance;
  };
}
function holdsLockImpl($this, owner) {
  $l$loop: while (true) {
    if (!$this.l2a())
      return 0;
    var curOwner = $this.f2a_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER())
      continue $l$loop;
    return curOwner === owner ? 1 : 2;
  }
}
function *lockSuspend($this, owner, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var contWithOwner = new CancellableContinuationWithOwner($this, cancellable, owner);
      $this.acquireCont(contWithOwner);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.p1s();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.v1p();
  });
  return Unit_instance;
}
function tryLockImpl($this, owner) {
  $l$loop: while (true) {
    if ($this.t2a()) {
      // Inline function 'kotlinx.coroutines.assert' call
      $this.f2a_1.kotlinx$atomicfu$value = owner;
      return 0;
    } else {
      if (owner == null)
        return 1;
      switch (holdsLockImpl($this, owner)) {
        case 1:
          return 2;
        case 2:
          return 1;
        case 0:
          continue $l$loop;
      }
    }
  }
}
function MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, $owner) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) => {
    this$0.k2a($owner);
    return Unit_instance;
  };
}
function MutexImpl$onSelectCancellationUnlockConstructor$lambda(this$0) {
  return (_unused_var__etf5q3, owner, _unused_var__etf5q3_0) => MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, owner);
}
var properties_initialized_Mutex_kt_yv4p3j;
function _init_properties_Mutex_kt__jod56b() {
  if (!properties_initialized_Mutex_kt_yv4p3j) {
    properties_initialized_Mutex_kt_yv4p3j = true;
    NO_OWNER = new Symbol('NO_OWNER');
    ON_LOCK_ALREADY_LOCKED_BY_OWNER = new Symbol('ALREADY_LOCKED_BY_OWNER');
  }
}
function get_MAX_SPIN_CYCLES() {
  _init_properties_Semaphore_kt__t514r6();
  return MAX_SPIN_CYCLES;
}
var MAX_SPIN_CYCLES;
function get_PERMIT() {
  _init_properties_Semaphore_kt__t514r6();
  return PERMIT;
}
var PERMIT;
function get_TAKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return TAKEN;
}
var TAKEN;
function get_BROKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return BROKEN;
}
var BROKEN;
function get_CANCELLED() {
  _init_properties_Semaphore_kt__t514r6();
  return CANCELLED;
}
var CANCELLED;
function get_SEGMENT_SIZE_0() {
  _init_properties_Semaphore_kt__t514r6();
  return SEGMENT_SIZE_0;
}
var SEGMENT_SIZE_0;
function decPermits($this) {
  $l$loop: while (true) {
    var p = $this.r2a_1.atomicfu$getAndDecrement();
    if (p > $this.m2a_1)
      continue $l$loop;
    return p;
  }
}
function coerceAvailablePermitsAtMaximum($this) {
  $l$loop_0: while (true) {
    var cur = $this.r2a_1.kotlinx$atomicfu$value;
    if (cur <= $this.m2a_1)
      break $l$loop_0;
    if ($this.r2a_1.atomicfu$compareAndSet(cur, $this.m2a_1))
      break $l$loop_0;
  }
}
function addAcquireToQueue($this, waiter) {
  var curTail = $this.p2a_1.kotlinx$atomicfu$value;
  var enqIdx = $this.q2a_1.atomicfu$getAndIncrement$long();
  var createNewSegment = createSegment$ref_0();
  var tmp0 = $this.p2a_1;
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE_0();
  var tmp2 = divide(enqIdx, fromInt(other));
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curTail, tmp2, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2_0 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$3;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (compare(cur.r1r_1, tmp2_0.r1r_1) >= 0) {
              tmp$ret$2 = true;
              break $l$block_1;
            }
            if (!tmp2_0.q20()) {
              tmp$ret$2 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2_0)) {
              if (cur.r20()) {
                cur.s7();
              }
              tmp$ret$2 = true;
              break $l$block_1;
            }
            if (tmp2_0.r20()) {
              tmp2_0.s7();
            }
          }
          tmp$ret$2 = tmp$ret$3;
        }
        tmp = tmp$ret$2;
      }
      if (tmp) {
        tmp$ret$1 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$1);
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var tmp$ret$5 = modulo(enqIdx, fromInt(other_0));
  var i = convertToInt(tmp$ret$5);
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  if (segment.f2b_1.atomicfu$get(i).atomicfu$compareAndSet(null, waiter)) {
    waiter.v1s(segment, i);
    return true;
  }
  var tmp4 = get_PERMIT();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  var value = get_TAKEN();
  if (segment.f2b_1.atomicfu$get(i).atomicfu$compareAndSet(tmp4, value)) {
    if (isInterface(waiter, CancellableContinuation)) {
      if (!isInterface(waiter, CancellableContinuation))
        THROW_CCE();
      waiter.a1r(Unit_instance, $this.s2a_1);
    } else {
      if (isInterface(waiter, SelectInstance)) {
        waiter.t29(Unit_instance);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unexpected: ' + toString(waiter);
        throw IllegalStateException.o(toString(message));
      }
    }
    return true;
  }
  // Inline function 'kotlinx.coroutines.assert' call
  return false;
}
function tryResumeNextFromQueue($this) {
  var curHead = $this.n2a_1.kotlinx$atomicfu$value;
  var deqIdx = $this.o2a_1.atomicfu$getAndIncrement$long();
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE_0();
  var id = divide(deqIdx, fromInt(other));
  var createNewSegment = createSegment$ref_0();
  var tmp0 = $this.n2a_1;
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curHead, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$3;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (compare(cur.r1r_1, tmp2.r1r_1) >= 0) {
              tmp$ret$2 = true;
              break $l$block_1;
            }
            if (!tmp2.q20()) {
              tmp$ret$2 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.r20()) {
                cur.s7();
              }
              tmp$ret$2 = true;
              break $l$block_1;
            }
            if (tmp2.r20()) {
              tmp2.s7();
            }
          }
          tmp$ret$2 = tmp$ret$3;
        }
        tmp = tmp$ret$2;
      }
      if (tmp) {
        tmp$ret$1 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$1);
  segment.y20();
  if (compare(segment.r1r_1, id) > 0)
    return false;
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var tmp$ret$5 = modulo(deqIdx, fromInt(other_0));
  var i = convertToInt(tmp$ret$5);
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.getAndSet' call
  var value = get_PERMIT();
  var cellState = segment.f2b_1.atomicfu$get(i).atomicfu$getAndSet(value);
  if (cellState === null) {
    // Inline function 'kotlin.repeat' call
    var times = get_MAX_SPIN_CYCLES();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.get' call
        if (segment.f2b_1.atomicfu$get(i).kotlinx$atomicfu$value === get_TAKEN())
          return true;
      }
       while (inductionVariable < times);
    var tmp4 = get_PERMIT();
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
    var value_0 = get_BROKEN();
    return !segment.f2b_1.atomicfu$get(i).atomicfu$compareAndSet(tmp4, value_0);
  } else if (cellState === get_CANCELLED())
    return false;
  else
    return tryResumeAcquire($this, cellState);
}
function tryResumeAcquire($this, $receiver) {
  var tmp;
  if (isInterface($receiver, CancellableContinuation)) {
    if (!isInterface($receiver, CancellableContinuation))
      THROW_CCE();
    var token = $receiver.w1q(Unit_instance, null, $this.s2a_1);
    var tmp_0;
    if (!(token == null)) {
      $receiver.b1p(token);
      tmp_0 = true;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    if (isInterface($receiver, SelectInstance)) {
      tmp = $receiver.o21($this, Unit_instance);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'unexpected: ' + toString($receiver);
      throw IllegalStateException.o(toString(message));
    }
  }
  return tmp;
}
function SemaphoreAndMutexImpl$onCancellationRelease$lambda(this$0) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) => {
    this$0.a2b();
    return Unit_instance;
  };
}
function createSegment$ref_0() {
  return constructCallableReference((p0, p1) => createSegment_0(p0, p1), 2, 0, 13, 'createSegment');
}
function createSegment_0(id, prev) {
  _init_properties_Semaphore_kt__t514r6();
  return new SemaphoreSegment(id, prev, 0);
}
var properties_initialized_Semaphore_kt_uqcwok;
function _init_properties_Semaphore_kt__t514r6() {
  if (!properties_initialized_Semaphore_kt_uqcwok) {
    properties_initialized_Semaphore_kt_uqcwok = true;
    MAX_SPIN_CYCLES = systemProp('kotlinx.coroutines.semaphore.maxSpinCycles', 100);
    PERMIT = new Symbol('PERMIT');
    TAKEN = new Symbol('TAKEN');
    BROKEN = new Symbol('BROKEN');
    CANCELLED = new Symbol('CANCELLED');
    SEGMENT_SIZE_0 = systemProp('kotlinx.coroutines.semaphore.segmentSize', 16);
  }
}
function createDefaultDispatcher() {
  var tmp;
  if (isJsdom()) {
    tmp = NodeDispatcher_getInstance();
  } else {
    var tmp_0;
    var tmp_1;
    if (!(typeof window === 'undefined')) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = window != null;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = !(typeof window.addEventListener === 'undefined');
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = asCoroutineDispatcher(window);
    } else {
      if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
        tmp = SetTimeoutDispatcher_getInstance();
      } else {
        tmp = NodeDispatcher_getInstance();
      }
    }
  }
  return tmp;
}
function isJsdom() {
  return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
}
var counter;
function get_DEBUG() {
  return DEBUG;
}
var DEBUG;
function get_classSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).j1();
  return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
}
function get_hexAddress(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var result = _this__u8e3s4.__debug_counter;
  if (!(typeof result === 'number')) {
    counter = counter + 1 | 0;
    result = counter;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.__debug_counter = result;
  }
  return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
}
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance === VOID)
    NodeDispatcher.i2b();
  return NodeDispatcher_instance;
}
function ScheduledMessageQueue$processQueue$lambda(this$0) {
  return () => {
    this$0.v2b();
    return Unit_instance;
  };
}
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
function WindowMessageQueue$lambda(this$0) {
  return (event) => {
    var tmp;
    if (event.source == this$0.l2c_1 && event.data == this$0.m2c_1) {
      event.stopPropagation();
      this$0.v2b();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function WindowMessageQueue$schedule$lambda(this$0) {
  return (it) => {
    this$0.v2b();
    return Unit_instance;
  };
}
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
function *await_0(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
    cancellable.u1p();
    var tmp = await$lambda(cancellable);
    _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
    return cancellable.v1p();
  };
}
function asDeferred(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var deferred = _this__u8e3s4.deferred;
  var tmp;
  if (deferred == null) {
    var tmp_0 = GlobalScope_instance;
    var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
    tmp = async(tmp_0, VOID, tmp_1, asDeferred$slambda(_this__u8e3s4));
  } else {
    tmp = deferred;
  }
  return tmp;
}
function await$lambda($cont) {
  return (it) => {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(it);
    this_0.qd(tmp$ret$1);
    return Unit_instance;
  };
}
function await$lambda_0($cont) {
  return (it) => {
    var tmp0 = $cont;
    var tmp0_elvis_lhs = it instanceof Error ? it : null;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = tmp0_elvis_lhs == null ? Exception.c6('Non-Kotlin exception ' + it.toString()) : tmp0_elvis_lhs;
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.qd(tmp$ret$1);
    return Unit_instance;
  };
}
function asDeferred$slambda($this_asDeferred) {
  return constructCallableReference(function *($this$async, $completion) {
    return yield* /*#__NOINLINE__*/await_0($this_asDeferred, $completion);
  }, 1);
}
function asCoroutineDispatcher(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = WindowDispatcher.q2c(_this__u8e3s4);
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.coroutineDispatcher = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function propagateExceptionFinalResort(exception) {
  console.error(exception.toString());
}
function createEventLoop() {
  return UnconfinedEventLoop.v2c();
}
function unsupported() {
  throw UnsupportedOperationException.a1('runBlocking event loop is not supported');
}
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance === VOID)
    SetTimeoutDispatcher.y2c();
  return SetTimeoutDispatcher_instance;
}
function SetTimeoutBasedDispatcher$invokeOnTimeout$lambda($block) {
  return () => {
    $block.c1t();
    return Unit_instance;
  };
}
function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return () => {
    // Inline function 'kotlin.with' call
    $continuation.z1q(this$0, Unit_instance);
    return Unit_instance;
  };
}
function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return () => {
    // Inline function 'kotlin.with' call
    $continuation.z1q(this$0, Unit_instance);
    return Unit_instance;
  };
}
function delayToInt(timeMillis) {
  return convertToInt(coerceIn(timeMillis, new Long(0, 0), new Long(2147483647, 0)));
}
function newCoroutineContext(_this__u8e3s4, context) {
  var combined = _this__u8e3s4.d1m().ep(context);
  return !(combined === Dispatchers_getInstance().c1u_1) && combined.ae(Key_instance) == null ? combined.ep(Dispatchers_getInstance().c1u_1) : combined;
}
function newCoroutineContext_0(_this__u8e3s4, addedContext) {
  return _this__u8e3s4.ep(addedContext);
}
function toDebugString(_this__u8e3s4) {
  return toString(_this__u8e3s4);
}
function get_DefaultDelay() {
  var tmp = Dispatchers_getInstance().c1u_1;
  return isInterface(tmp, Delay) ? tmp : THROW_CCE();
}
function get_coroutineName(_this__u8e3s4) {
  return null;
}
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance === VOID)
    new Dispatchers();
  return Dispatchers_instance;
}
function CancellationException_0(message, cause) {
  return CancellationException.p(message, cause);
}
function Runnable$run$ref(p0) {
  return constructCallableReference(() => {
    p0.c1t();
    return Unit_instance;
  }, 0, 0, 14, 'run', [p0]);
}
function SafeCollector$collectContextSize$lambda(count, _unused_var__etf5q3) {
  return count + 1 | 0;
}
function identitySet(expectedSize) {
  return HashSet.b3(expectedSize);
}
function get_platformExceptionHandlers_() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return platformExceptionHandlers_;
}
var platformExceptionHandlers_;
function get_platformExceptionHandlers() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return get_platformExceptionHandlers_();
}
var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
  if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
    properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    platformExceptionHandlers_ = LinkedHashSet.v2();
  }
}
function recoverStackTrace(exception, continuation) {
  return exception;
}
function unwrap(exception) {
  return exception;
}
function initCause(_this__u8e3s4, cause) {
}
function recoverStackTrace_0(exception) {
  return exception;
}
function systemProp_1(propertyName) {
  return null;
}
function threadContextElements(context) {
  return 0;
}
function commonThreadLocal(name) {
  return new CommonThreadLocal();
}
//region block: post-declaration
initMetadataForInterface(Job, 'Job', VOID, VOID, [Element], [0]);
initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Job], [0]);
protoOf(JobSupport).i1n = invokeOnCompletion$default;
protoOf(JobSupport).o1n = cancel$default;
protoOf(JobSupport).ep = plus;
protoOf(JobSupport).ae = get_0;
protoOf(JobSupport).dp = fold;
protoOf(JobSupport).cp = minusKey_0;
initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Job, ParentJob], [0]);
initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, VOID, [Job, Continuation], [0]);
initMetadataForInterface(NotCompleted, 'NotCompleted');
initMetadataForInterface(CancelHandler, 'CancelHandler', VOID, VOID, [NotCompleted]);
initMetadataForClass(DisposeHandlersOnCancel, 'DisposeHandlersOnCancel', VOID, VOID, [CancelHandler]);
initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
initMetadataForInterface(DisposableHandle, 'DisposableHandle');
initMetadataForInterface(Incomplete, 'Incomplete');
initMetadataForClass(JobNode, 'JobNode', VOID, VOID, [DisposableHandle, Incomplete]);
initMetadataForClass(AwaitAllNode, 'AwaitAllNode');
initMetadataForClass(AwaitAll, 'AwaitAll', VOID, VOID, VOID, [0]);
initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, VOID, VOID, [0]);
initMetadataForInterface(Deferred, 'Deferred', VOID, VOID, [Job], [0]);
initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, VOID, [Deferred], [0]);
initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(ScopeCoroutine, 'ScopeCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(DispatchedCoroutine, 'DispatchedCoroutine', VOID, VOID, VOID, [0]);
initMetadataForInterface(CancellableContinuation, 'CancellableContinuation', VOID, VOID, [Continuation]);
initMetadataForClass(DisposeOnCancel, 'DisposeOnCancel', VOID, VOID, [CancelHandler]);
initMetadataForClass(UserSupplied, 'UserSupplied', VOID, VOID, [CancelHandler]);
initMetadataForInterface(Runnable, 'Runnable');
initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
initMetadataForClass(DispatchedTask, 'DispatchedTask');
initMetadataForInterface(Waiter, 'Waiter');
initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, VOID, [CancellableContinuation, Waiter]);
initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
initMetadataForClass(CompletedContinuation, 'CompletedContinuation');
initMetadataForClass(ChildContinuation, 'ChildContinuation');
initMetadataForClass(CompletableDeferredImpl, 'CompletableDeferredImpl', VOID, VOID, [Deferred], [0]);
initMetadataForInterface(CompletableJob, 'CompletableJob', VOID, VOID, [Job], [0]);
initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
initMetadataForClass(CancelledContinuation, 'CancelledContinuation');
initMetadataForObject(Key, 'Key');
protoOf(CoroutineDispatcher).ae = get;
protoOf(CoroutineDispatcher).cp = minusKey;
initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, VOID, [ContinuationInterceptor]);
initMetadataForObject(Key_0, 'Key');
initMetadataForObject(Key_1, 'Key');
initMetadataForClass(CoroutineName, 'CoroutineName');
initMetadataForObject(GlobalScope, 'GlobalScope');
initMetadataForClass(CoroutineStart, 'CoroutineStart');
initMetadataForInterface(CopyableThrowable, 'CopyableThrowable');
initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
initMetadataForInterface(DelayWithTimeoutDiagnostics, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay], [1]);
initMetadataForClass(EventLoop, 'EventLoop');
initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException');
initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError');
initMetadataForObject(Key_2, 'Key');
initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle', VOID, VOID, [DisposableHandle]);
initMetadataForClass(DisposeOnCompletion, 'DisposeOnCompletion');
initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
initMetadataForClass(Finishing, 'Finishing', VOID, VOID, [Incomplete]);
initMetadataForClass(ChildCompletion, 'ChildCompletion');
initMetadataForClass(AwaitContinuation, 'AwaitContinuation');
initMetadataForClass(JobImpl, 'JobImpl', VOID, VOID, [CompletableJob], [0]);
initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
initMetadataForClass(LockFreeLinkedListHead, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
initMetadataForClass(NodeList, 'NodeList', NodeList, VOID, [Incomplete]);
initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion');
initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling');
initMetadataForClass(ResumeOnCompletion, 'ResumeOnCompletion');
initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, VOID, [DisposableHandle]);
initMetadataForClass(ResumeAwaitOnCompletion, 'ResumeAwaitOnCompletion');
initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher');
protoOf(NonCancellable).i1n = invokeOnCompletion$default;
protoOf(NonCancellable).o1n = cancel$default;
initMetadataForObject(NonCancellable, 'NonCancellable', VOID, VOID, [Job], [0]);
initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, VOID, VOID, [0]);
initMetadataForClass(SupervisorCoroutine, 'SupervisorCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException', VOID, VOID, [CopyableThrowable]);
initMetadataForClass(TimeoutCoroutine, 'TimeoutCoroutine', VOID, VOID, [Runnable], [0]);
initMetadataForObject(Unconfined, 'Unconfined');
initMetadataForObject(Key_3, 'Key');
initMetadataForClass(YieldContext, 'YieldContext', YieldContext.i1z);
initMetadataForClass(BufferOverflow, 'BufferOverflow');
initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
initMetadataForClass(Segment, 'Segment', VOID, VOID, [NotCompleted]);
initMetadataForClass(ChannelSegment, 'ChannelSegment');
initMetadataForClass(SendBroadcast, 'SendBroadcast', VOID, VOID, [Waiter]);
initMetadataForClass(BufferedChannelIterator, 'BufferedChannelIterator', VOID, VOID, [Waiter], [0, 3]);
initMetadataForInterface(SendChannel, 'SendChannel', VOID, VOID, VOID, [1]);
initMetadataForInterface(ReceiveChannel, 'ReceiveChannel', VOID, VOID, VOID, [0]);
initMetadataForInterface(Channel, 'Channel', VOID, VOID, [SendChannel, ReceiveChannel], [1, 0]);
protoOf(BufferedChannel).y22 = close$default;
protoOf(BufferedChannel).a23 = cancel$default_0;
initMetadataForClass(BufferedChannel, 'BufferedChannel', VOID, VOID, [Channel], [1, 4, 0, 3]);
initMetadataForClass(WaiterEB, 'WaiterEB');
initMetadataForClass(ReceiveCatching, 'ReceiveCatching', VOID, VOID, [Waiter]);
initMetadataForObject(Factory, 'Factory');
initMetadataForClass(ClosedReceiveChannelException, 'ClosedReceiveChannelException');
initMetadataForClass(Failed, 'Failed', Failed);
initMetadataForClass(Closed, 'Closed');
initMetadataForCompanion(Companion);
initMetadataForClass(ChannelResult, 'ChannelResult');
initMetadataForClass(ClosedSendChannelException, 'ClosedSendChannelException');
protoOf(ChannelCoroutine).y22 = close$default;
initMetadataForClass(ChannelCoroutine, 'ChannelCoroutine', VOID, VOID, [Channel], [1, 0]);
initMetadataForClass(ConflatedBufferedChannel, 'ConflatedBufferedChannel', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(ProducerCoroutine, 'ProducerCoroutine', VOID, VOID, [SendChannel], [1, 0]);
initMetadataForInterface(Flow, 'Flow', VOID, VOID, VOID, [1]);
initMetadataForClass(AbstractFlow, 'AbstractFlow', VOID, VOID, [Flow], [1]);
initMetadataForClass(SafeFlow, 'SafeFlow', VOID, VOID, VOID, [1]);
initMetadataForInterface(FlowCollector, 'FlowCollector', VOID, VOID, VOID, [1]);
initMetadataForClass(AbstractSharedFlow, 'AbstractSharedFlow');
initMetadataForInterface(FusibleFlow, 'FusibleFlow', VOID, VOID, [Flow], [1]);
protoOf(StateFlowImpl).d26 = fuse$default;
initMetadataForClass(StateFlowImpl, 'StateFlowImpl', VOID, VOID, [Flow, FlowCollector, FusibleFlow], [1]);
initMetadataForClass(AbstractSharedFlowSlot, 'AbstractSharedFlowSlot');
initMetadataForClass(StateFlowSlot, 'StateFlowSlot', StateFlowSlot, VOID, VOID, [0]);
protoOf(ChannelFlow).d26 = fuse$default;
initMetadataForClass(ChannelFlow, 'ChannelFlow', VOID, VOID, [FusibleFlow], [1]);
initMetadataForClass(ChannelFlowOperator, 'ChannelFlowOperator', VOID, VOID, VOID, [1, 2]);
initMetadataForClass(ChannelFlowOperatorImpl, 'ChannelFlowOperatorImpl', VOID, VOID, VOID, [1]);
initMetadataForClass(UndispatchedContextCollector, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(StackFrameContinuation, 'StackFrameContinuation', VOID, VOID, [Continuation]);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(FlowCoroutine, 'FlowCoroutine', VOID, VOID, VOID, [0]);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(ChannelFlowTransformLatest, 'ChannelFlowTransformLatest', VOID, VOID, VOID, [1]);
initMetadataForObject(NopCollector, 'NopCollector', VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(SendingCollector, 'SendingCollector', VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(ThrowingCollector, 'ThrowingCollector', VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(SubscribedFlowCollector, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector], [0, 1]);
initMetadataForClass(combine$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
initMetadataForClass(first$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(first$$inlined$collectWhile$2, VOID, VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(SegmentOrClosed, 'SegmentOrClosed');
initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed');
initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation', VOID, VOID, [Continuation]);
initMetadataForClass(DispatchException, 'DispatchException');
initMetadataForClass(UndeliveredElementException, 'UndeliveredElementException');
initMetadataForClass(ContextScope, 'ContextScope');
initMetadataForClass(Symbol, 'Symbol');
initMetadataForInterface(SelectInstance, 'SelectInstance');
initMetadataForClass(ClauseData, 'ClauseData', VOID, VOID, VOID, [1]);
initMetadataForClass(SelectImplementation, 'SelectImplementation', VOID, VOID, [CancelHandler, SelectInstance, Waiter], [0, 2]);
initMetadataForClass(TrySelectDetailedResult, 'TrySelectDetailedResult');
initMetadataForClass(CancellableContinuationWithOwner, 'CancellableContinuationWithOwner', VOID, VOID, [CancellableContinuation, Waiter]);
initMetadataForClass(SemaphoreAndMutexImpl, 'SemaphoreAndMutexImpl', VOID, VOID, VOID, [0]);
initMetadataForClass(MutexImpl, 'MutexImpl', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(SemaphoreSegment, 'SemaphoreSegment');
initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, VOID, [Delay], [1]);
initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, VOID, VOID, [1]);
initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue');
initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue');
initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop.v2c);
initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, VOID, VOID, [1]);
initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, VOID, [CancelHandler, DisposableHandle]);
initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout');
initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, VOID, [Delay], [1]);
initMetadataForClass(UndispatchedCoroutine, 'UndispatchedCoroutine', VOID, VOID, VOID, [0]);
initMetadataForObject(Dispatchers, 'Dispatchers');
initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher');
initMetadataForClass(JobCancellationException, 'JobCancellationException');
initMetadataForClass(AbortFlowException, 'AbortFlowException');
initMetadataForClass(ChildCancelledException, 'ChildCancelledException', ChildCancelledException.t28);
initMetadataForClass(SafeCollector, 'SafeCollector', VOID, VOID, [FlowCollector], [1]);
initMetadataForClass(WorkaroundAtomicReference, 'WorkaroundAtomicReference');
initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException');
initMetadataForClass(ListClosed, 'ListClosed');
initMetadataForClass(LocalAtomicInt, 'LocalAtomicInt');
initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
//endregion
//region block: init
Active_instance = new Active();
Key_instance_1 = new Key_0();
Key_instance_2 = new Key_1();
GlobalScope_instance = new GlobalScope();
Key_instance_3 = new Key_2();
NonDisposableHandle_instance = new NonDisposableHandle();
Key_instance_4 = new Key_3();
NopCollector_instance = new NopCollector();
counter = 0;
DEBUG = false;
//endregion
//region block: exports
export {
  ChannelResult__exceptionOrNull_impl_16ei30 as ChannelResult__exceptionOrNull_impl_16ei302x9fo9thjhzif,
  ChannelResult__getOrNull_impl_f5e07h as ChannelResult__getOrNull_impl_f5e07h2lg0qlstspu0r,
  ChannelResult__getOrThrow_impl_od1axs as ChannelResult__getOrThrow_impl_od1axsdky2zm58n02y,
  _ChannelResult___get_holder__impl__pm9gzw as _ChannelResult___get_holder__impl__pm9gzwvud6m7n0fzs7,
  _ChannelResult___get_isClosed__impl__mg7kuu as _ChannelResult___get_isClosed__impl__mg7kuu3a26on4apn4j4,
  _ChannelResult___get_isFailure__impl__nz6ehu as _ChannelResult___get_isFailure__impl__nz6ehu2fj0qoa5trbx8,
  _ChannelResult___get_isSuccess__impl__odq1z9 as _ChannelResult___get_isSuccess__impl__odq1z9t6ktwy0g0q0f,
  Factory_getInstance as Factory_getInstance32nnliw9sj63p,
  Key_instance_1 as Key_instancex2w5ku7ehbar,
  Dispatchers_getInstance as Dispatchers_getInstance20p7pyqnrepag,
  GlobalScope_instance as GlobalScope_instance3w3xrcgjszz2p,
  Key_instance_3 as Key_instancebefxze3q9f64,
  NonCancellable_getInstance as NonCancellable_getInstance245ec57g3sl0k,
  BufferOverflow_DROP_OLDEST_getInstance as BufferOverflow_DROP_OLDEST_getInstanceckq6sjfawt4w,
  BufferOverflow_SUSPEND_getInstance as BufferOverflow_SUSPEND_getInstanceob833ibjouyy,
  CoroutineStart_LAZY_getInstance as CoroutineStart_LAZY_getInstanceyyljs516jwiz,
  CoroutineStart_UNDISPATCHED_getInstance as CoroutineStart_UNDISPATCHED_getInstance2pq896dvru5v1,
  collectLatest as collectLatest385x84q3xq78u,
  first_0 as first1gbp9d21tksw3,
  first as first3ar30drnglxos,
  awaitAll as awaitAllncublvoeclj6,
  awaitCancellation as awaitCancellation3exsywb4az079,
  await_0 as await3gx2tubo6ckuc,
  cancelAndJoin as cancelAndJoin21f2rd386nyt8,
  coroutineScope as coroutineScope39ukucf23mhsm,
  delay as delay3e2ei0hoxjoud,
  delay_0 as delayvyed5wvki0ic,
  supervisorScope as supervisorScope3mi0bhexh7bxt,
  withContext as withContextqz5k6d9p9xx5,
  withTimeoutOrNull as withTimeoutOrNull3qi35nuwr2k8a,
  withTimeoutOrNull_0 as withTimeoutOrNull2qr9d4v42lp0r,
  withTimeout as withTimeout1cf9pp7nybo8u,
  yield_0 as yieldyvh2mab0488,
  cancel$default_0 as cancel$default2imfx8rp1ubvu,
  close$default as close$defaultlxi0kykibhye,
  cancel$default as cancel$default2xpiixsrbjcxw,
  invokeOnCompletion$default as invokeOnCompletion$default3ce018mbgf2ad,
  Closed as Closed8t4xgopf7j5r,
  Failed as Failed2z52ugz2lqu8t,
  ChannelResult as ChannelResult2y4k69ac6y3du,
  Channel_0 as Channel3r72atmcithql,
  Channel as Channel3g65mgfma68ln,
  ClosedReceiveChannelException as ClosedReceiveChannelException3ofg6gf5f5b38,
  ClosedSendChannelException as ClosedSendChannelException29m33prpq9jaw,
  cancelConsumed as cancelConsumed2i0oizqhmljf6,
  produce as produce1iljho2c8bp6o,
  FlowCollector as FlowCollector26clgpmzihvke,
  Flow as Flow3375h4584bu3w,
  MutableStateFlow as MutableStateFlow34bfoyvwu8czu,
  combine as combinemp03aok49jmu,
  flow as flow3tazazxj2t7g4,
  recoverStackTrace as recoverStackTrace2i3si2i8nvw1k,
  startCoroutineCancellable as startCoroutineCancellable18shtfwdieib,
  Mutex as Mutex16li1l0asjv17,
  CancellableContinuationImpl as CancellableContinuationImpl1cx201opicavg,
  CancellationException_0 as CancellationExceptionjngvjj221x3v,
  CompletableDeferred_0 as CompletableDeferred10t3vc1asgghx,
  CompletableDeferred as CompletableDeferred2lnqvsbvx74d3,
  CompletableJob as CompletableJob1w6swnu15iclo,
  CopyableThrowable as CopyableThrowable1mvc99jcyvivf,
  CoroutineDispatcher as CoroutineDispatcherizb7p9bijexj,
  CoroutineName as CoroutineName2g5zosw74tf0f,
  CoroutineScope as CoroutineScopelux7s7zphw7e,
  Deferred as Deferred6wjx2us769ee,
  invokeOnTimeout as invokeOnTimeout3llts2igdsa63,
  Delay as Delay9umexudtwyie,
  DisposableHandle as DisposableHandle1uzxt8frdchxn,
  Job_0 as Job13y4jkazwjho0,
  MainScope as MainScope1gi1r4abhrtmm,
  SupervisorJob as SupervisorJobythnfxkr3jxc,
  TimeoutCancellationException as TimeoutCancellationException198b5zwr3v3uw,
  asDeferred as asDeferredzhtizu7g12ut,
  async as asyncz02dsa2nb2zt,
  cancelChildren as cancelChildrennwartoz0yn6c,
  cancelChildren_0 as cancelChildren10wlln0b749a7,
  cancel as cancel36mj9lv3a0whl,
  cancel_2 as cancel2en0dn4yvpufo,
  cancel_0 as cancel2ztysw4v4hav6,
  cancel_1 as cancel1xim2hrvjmwpn,
  completeWith as completeWith2hvdlbg1q1mlx,
  ensureActive as ensureActivem48bojk66pw0,
  get_isActive as get_isActivehakov5bm97hw,
  get_job as get_job2zvlvce9o9a29,
  launch as launch1c91vkjzdi9sd,
};
//endregion
